/* tslint:disable */
/* eslint-disable */
/**
 * CO2AI Ecosystem API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccessRequestAnswerRequest {
    'approved': boolean;
    'token': string;
}
export interface AccessRequestListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface AccessRequestListResponse {
    'data': ReadonlyArray<AccessRequestResponse>;
    'metadata': AccessRequestListMetadataResponse;
}
export interface AccessRequestResponse {
    'createdAt': string;
    'senderEmail': string;
    'token': string;
}
export interface AccountCreateRequest {
    'accessManagementToken'?: string;
    'organisationCity': string;
    'organisationCountry': string;
    'organisationName': string;
    'userEmail': string;
    'userFullName': string;
    'userJobTitle'?: string;
    'userPassword'?: string;
}
export interface AggregatedProductRequestAgeResponse {
    'moreThanNinetyDays': number;
    'ninetyDays': number;
    'sixtyDays': number;
    'tenDays': number;
    'thirtyDays': number;
}
export interface AggregatedProductRequestDataResponse {
    'received': ProductRequestOverview;
    'sent': ProductRequestOverview;
}
export interface AggregatedRequestDataResponse {
    'receivedRequestsAnswered': number;
    'receivedRequestsRejected': number;
    'receivedRequestsResubmitted': number;
    'sentRequestsAnswered': number;
    'sentRequestsRejected': number;
    'sentRequestsResubmitted': number;
    'totalReceivedRequests': number;
    'totalSentRequests': number;
}

export const AllocationMethodology = {
    VOLUME_SKU: 'volume_sku',
    REVENUE_SHARE: 'revenue_share',
    OTHER: 'other'
} as const;

export type AllocationMethodology = typeof AllocationMethodology[keyof typeof AllocationMethodology];


export interface AnswerMetadata {
    'sources'?: ReadonlyArray<AnswerSource>;
}
export interface AnswerSource {
    'attachmentId': string;
    'pageNumber'?: number;
}
export interface AttachmentInfo {
    'createdAt': string;
    'id': string;
    'isUsed': boolean;
    'name': string;
}
export interface AttachmentListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface AttachmentListResponse {
    'data': ReadonlyArray<AttachmentInfo>;
    'metadata': AttachmentListMetadataResponse;
}
export interface AttachmentsDeleteRequest {
    'ids': ReadonlyArray<string>;
}
export interface AttachmentsDeleteResponse {
    'ids': ReadonlyArray<string>;
}
export interface CarbonFootprint {
    'aircraftGhgEmissions'?: string;
    'allocationRulesDescription'?: string;
    'biogenicCO2Uptake'?: string;
    'biogenicCarbonContent'?: string;
    'biogenicNonCO2Emissions'?: string;
    'boundaryProcessesDescription'?: string;
    'ccsTechnologicalCO2Capture'?: string;
    'ccsTechnologicalCO2CaptureIncluded'?: string;
    'ccuCalculationApproach'?: string;
    'ccuCarbonContent'?: string;
    'ccuCreditCertification'?: string;
    'crossSectoralStandards': ReadonlyArray<CarbonFootprintCrossSectoralStandardsEnum>;
    'declaredUnitAmount': string;
    'declaredUnitOfMeasurement': CarbonFootprintDeclaredUnitOfMeasurementEnum;
    'dqi'?: DataQualityIndicators;
    'exemptedEmissionsDescription'?: string;
    'exemptedEmissionsPercent': string;
    'fossilCarbonContent': string;
    'fossilGhgEmissions': string;
    'geographyCountry'?: string;
    'geographyCountrySubdivision'?: string;
    'geographyRegionOrSubregion'?: string;
    'ipccCharacterizationFactors': ReadonlyArray<CarbonFootprintIpccCharacterizationFactorsEnum>;
    'landAreaOccupation'?: string;
    'landCarbonLeakage'?: string;
    'landManagementBiogenicCO2Emissions'?: string;
    'landManagementBiogenicCO2Removals'?: string;
    'landManagementFossilGhgEmissions'?: string;
    'landUseChangeGhgEmissions'?: string;
    'outboundLogisticsGhgEmissions'?: string;
    'packagingBiogenicCarbonContent'?: string;
    'packagingEmissionsIncluded': boolean;
    'packagingGhgEmissions'?: string;
    'pcfExcludingBiogenicUptake': string;
    'pcfIncludingBiogenicUptake': string;
    'primaryDataShare'?: string;
    'productMassPerDeclaredUnit': string;
    'productOrSectorSpecificRules'?: any;
    'recycledCarbonContent'?: string;
    'referencePeriodEnd': string;
    'referencePeriodStart': string;
    'secondaryEmissionFactorSources'?: ReadonlyArray<EmissionFactorSource>;
    'technologicalCO2CaptureOrigin'?: string;
    'technologicalCO2Removals'?: string;
    'verification'?: CarbonFootprintVerification;
}

export const CarbonFootprintCrossSectoralStandardsEnum = {
    GHGP_PRODUCT: 'GHGP-Product',
    ISO14067: 'ISO14067',
    ISO14083: 'ISO14083',
    ISO14040_44: 'ISO14040-44',
    PEF: 'PEF',
    PACT_1_0: 'PACT-1.0',
    PACT_2_0: 'PACT-2.0',
    PACT_3_0: 'PACT-3.0',
    PAS2050: 'PAS2050',
    PAS2090: 'PAS2090',
    CATENA_X: 'Catena-X',
    ISO3459: 'ISO3459',
    BP_X30_323_0: 'BP-X30-323-0',
    EN15804: 'EN15804',
    EPD_PCR: 'EPD-PCR',
    CALCULATOR: 'Calculator',
    TF_S: 'TfS',
    UNKNOWN: 'Unknown'
} as const;

export type CarbonFootprintCrossSectoralStandardsEnum = typeof CarbonFootprintCrossSectoralStandardsEnum[keyof typeof CarbonFootprintCrossSectoralStandardsEnum];
export const CarbonFootprintDeclaredUnitOfMeasurementEnum = {
    LITER: 'liter',
    KILOGRAM: 'kilogram',
    CUBIC_METER: 'cubic meter',
    KILOWATT_HOUR: 'kilowatt hour',
    MEGAJOULE: 'megajoule',
    TON_KILOMETER: 'ton kilometer',
    SQUARE_METER: 'square meter',
    PIECE: 'piece',
    HOUR: 'hour',
    MEGABIT_SECOND: 'megabit second'
} as const;

export type CarbonFootprintDeclaredUnitOfMeasurementEnum = typeof CarbonFootprintDeclaredUnitOfMeasurementEnum[keyof typeof CarbonFootprintDeclaredUnitOfMeasurementEnum];
export const CarbonFootprintIpccCharacterizationFactorsEnum = {
    AR6: 'AR6',
    AR5: 'AR5',
    AR4: 'AR4'
} as const;

export type CarbonFootprintIpccCharacterizationFactorsEnum = typeof CarbonFootprintIpccCharacterizationFactorsEnum[keyof typeof CarbonFootprintIpccCharacterizationFactorsEnum];

export interface CarbonFootprintV2 {
    'aircraftGhgEmissions'?: string;
    'allocationRulesDescription'?: string;
    'assurance'?: any;
    'biogenicAccountingMethodology'?: string;
    'biogenicCarbonContent': string;
    'biogenicCarbonWithdrawal'?: string;
    'boundaryProcessesDescription': string;
    'characterizationFactors': CarbonFootprintV2CharacterizationFactorsEnum;
    'crossSectoralStandardsUsed': ReadonlyArray<CarbonFootprintV2CrossSectoralStandardsUsedEnum>;
    'dLucGhgEmissions'?: string;
    'declaredUnit': CarbonFootprintV2DeclaredUnitEnum;
    'dlucGhgEmissions'?: string;
    'dqi'?: DataQualityIndicators;
    'exemptedEmissionsDescription': string;
    'exemptedEmissionsPercent': number;
    'fossilCarbonContent': string;
    'fossilGhgEmissions'?: string;
    'geographyCountry'?: string;
    'geographyCountrySubdivision'?: string;
    'geographyRegionOrSubregion'?: string;
    'iLucGhgEmissions'?: string;
    'ilucGhgEmissions'?: string;
    'landManagementGhgEmissions'?: string;
    'otherBiogenicGhgEmissions'?: string;
    'pCfExcludingBiogenic': string;
    'pCfIncludingBiogenic'?: string;
    'packagingEmissionsIncluded': boolean;
    'packagingGhgEmissions'?: string;
    'pcfExcludingBiogenic': string;
    'pcfIncludingBiogenic'?: string;
    'primaryDataShare'?: number;
    'productOrSectorSpecificRules'?: any;
    'referencePeriodEnd': string;
    'referencePeriodStart': string;
    'secondaryEmissionFactorSources'?: ReadonlyArray<EmissionFactorSource>;
    'uncertaintyAssessmentDescription'?: string;
    'unitaryProductAmount': string;
}

export const CarbonFootprintV2CharacterizationFactorsEnum = {
    AR6: 'AR6',
    AR5: 'AR5',
    AR4: 'AR4'
} as const;

export type CarbonFootprintV2CharacterizationFactorsEnum = typeof CarbonFootprintV2CharacterizationFactorsEnum[keyof typeof CarbonFootprintV2CharacterizationFactorsEnum];
export const CarbonFootprintV2CrossSectoralStandardsUsedEnum = {
    GHG_PROTOCOL_PRODUCT_STANDARD: 'GHG Protocol Product standard',
    ISO_STANDARD_14067: 'ISO Standard 14067',
    ISO_STANDARD_14044: 'ISO Standard 14044',
    UNKNOWN: 'Unknown'
} as const;

export type CarbonFootprintV2CrossSectoralStandardsUsedEnum = typeof CarbonFootprintV2CrossSectoralStandardsUsedEnum[keyof typeof CarbonFootprintV2CrossSectoralStandardsUsedEnum];
export const CarbonFootprintV2DeclaredUnitEnum = {
    LITER: 'liter',
    KILOGRAM: 'kilogram',
    CUBIC_METER: 'cubic meter',
    KILOWATT_HOUR: 'kilowatt hour',
    MEGAJOULE: 'megajoule',
    TON_KILOMETER: 'ton kilometer',
    SQUARE_METER: 'square meter',
    PIECE: 'piece',
    HOUR: 'hour',
    MEGABIT_SECOND: 'megabit second'
} as const;

export type CarbonFootprintV2DeclaredUnitEnum = typeof CarbonFootprintV2DeclaredUnitEnum[keyof typeof CarbonFootprintV2DeclaredUnitEnum];

export interface CarbonFootprintVerification {
    'comments'?: string;
    'completedAt'?: string;
    'coverage'?: CarbonFootprintVerificationCoverageEnum;
    'providerName'?: string;
    'standardName'?: string;
}

export const CarbonFootprintVerificationCoverageEnum = {
    PRODUCT_LEVEL: 'product level',
    PCF_PROGRAM: 'PCF program',
    PCF_CALCULATION_MODEL: 'PCF calculation model'
} as const;

export type CarbonFootprintVerificationCoverageEnum = typeof CarbonFootprintVerificationCoverageEnum[keyof typeof CarbonFootprintVerificationCoverageEnum];

export interface CatenaXCredentialsResponse {
    'bpnl': string;
    'componentId'?: string;
    'dosBeta': boolean;
    'dosClientId'?: string;
    'dosManagedByCo2ai': boolean;
    'dtrComponentId'?: string;
    'edcAddress': string;
    'organisationId': string;
    'walletClientId'?: string;
    'walletTokenUrl'?: string;
}
export interface CatenaXCredentialsUpdateRequest {
    'bpnl': string;
    'componentId'?: string;
    'discoveryClientId'?: string;
    'discoveryClientSecret'?: string;
    'discoveryTokenUrl'?: string;
    'dosBeta': boolean;
    'dosClientId'?: string;
    'dosClientSecret'?: string;
    'dosManagedByCo2ai': boolean;
    'dtrComponentId'?: string;
    'edcAddress': string;
    'edcManagementApiKey'?: string;
    'walletClientId'?: string;
    'walletClientSecret'?: string;
    'walletTokenUrl'?: string;
}
export interface CatenaXProductPartnersRequest {
    'bpnls': ReadonlyArray<string>;
    'manufacturerPartId': string;
}
export interface CatenaXProductPartnersResponse {
    'bpnls': ReadonlyArray<string>;
    'manufacturerPartId'?: string;
}
export interface CatenaXSharePartner {
    'bpnl': string;
    'name': string;
}
export interface CatenaXShareRequest {
    'partners': ReadonlyArray<CatenaXSharePartner>;
    'productIds': ReadonlyArray<string>;
}
export interface ChatMessage {
    'content': string;
    'role': string;
}
export interface ChatRequest {
    'maxTokens': number;
    'messages': ReadonlyArray<ChatRequestMessagesInner>;
    'model': string;
    'systemPrompt'?: string;
    'temperature': number;
    'toolChoice'?: { [key: string]: any; };
    'tools'?: ReadonlyArray<{ [key: string]: any; }>;
}
/**
 * @type ChatRequestMessagesInner
 */
export type ChatRequestMessagesInner = ChatMessage | FullAssistantMessage | ToolResultMessage;

export interface ChatResponse {
    'error'?: string;
    'messages': ReadonlyArray<ChatRequestMessagesInner>;
    'usage'?: TokenUsage;
}
export interface CloudEventData {
    'classification'?: ReadonlyArray<string>;
    'comment'?: string;
    'companyId'?: ReadonlyArray<string>;
    'geography'?: ReadonlyArray<string>;
    'productId'?: ReadonlyArray<string>;
    'status'?: string;
    'validAfter'?: string;
    'validBefore'?: string;
    'validOn'?: string;
}
export interface CloudEventPayload {
    'data'?: CloudEventData;
    'id'?: string;
    'source'?: string;
    'type'?: string;
}
export interface CompanyExistsRequest {
    'email': string;
}
export interface CompanyExistsResponse {
    'domainExists': boolean;
    'domainWhitelisted': boolean;
    'email': string;
    'userActivationStatus'?: CompanyExistsResponseUserActivationStatusEnum;
    'userAlreadyExists': boolean;
}

export const CompanyExistsResponseUserActivationStatusEnum = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
    WAITING_FOR_COMPLETION: 'WAITING_FOR_COMPLETION'
} as const;

export type CompanyExistsResponseUserActivationStatusEnum = typeof CompanyExistsResponseUserActivationStatusEnum[keyof typeof CompanyExistsResponseUserActivationStatusEnum];


export const ConfidenceLevel = {
    VERY: 'VERY',
    SOMEWHAT: 'SOMEWHAT',
    NONE: 'NONE'
} as const;

export type ConfidenceLevel = typeof ConfidenceLevel[keyof typeof ConfidenceLevel];


export interface ConnectedOrganizationConnectorsResponse {
    'pact'?: PactConnectorResponse;
}
export interface ConnectedOrganizationRequest {
    'connectedOrgEmailDomain'?: string;
    'connectedOrgId': string;
    'connectedOrgName': string;
}
export interface ConnectedOrganizationResponse {
    'connectedOrgEmailDomain'?: string;
    'connectedOrgId': string;
    'connectedOrgName': string;
    'connectors': ConnectedOrganizationConnectorsResponse;
    'createdAt': string;
    'id': string;
    'productsCount': number;
    'updatedAt': string;
}
export interface ConnectedOrganizationUpdateRequest {
    'connectedOrgEmailDomain'?: string;
    'connectedOrgName'?: string;
}
export interface ConnectedOrganizationsMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface ConnectedOrganizationsResponse {
    'data': ReadonlyArray<ConnectedOrganizationResponse>;
    'metadata': ConnectedOrganizationsMetadataResponse;
}
export interface ContactRequest {
    'message': string;
}
export interface CorpoEmissionProductListResponse {
    'data': ReadonlyArray<CorpoEmissionProductResponse>;
    'metadata': CorpoProductListMetadataResponse;
}
export interface CorpoEmissionProductResponse {
    'emissionFactor'?: number;
    'id': string;
    'internalReference'?: string;
    'lastUpdated': string;
    'name': string;
}
export interface CorpoProductListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface CorpoSupplierResponse {
    'id': string;
    'name': string;
}
export interface CorpoSuppliersMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface CorpoSuppliersResponse {
    'data': ReadonlyArray<CorpoSupplierResponse>;
    'metadata': CorpoSuppliersMetadataResponse;
}
export interface CorporateAllocationData {
    'allocationMethodology'?: AllocationMethodology;
    'allocationMethodologyOther'?: string;
    'allocationPercentage'?: number;
}


export interface CorporateDataAttachment {
    'id'?: string;
    'name'?: string;
    'url'?: string;
}
export interface CorporateDataDto {
    'data': CorporateYearData;
    'year': number;
}
export interface CorporateDataDtoResponse {
    'reference': string;
    'reportingYear': number;
    'supplierId': string;
}
export interface CorporateDataRejectionRequest {
    'reason': string;
}
export interface CorporateDataRequestDetailResponse {
    'answeredAllocationData'?: CorporateAllocationData;
    'answeredAt'?: string;
    'answeredCorporateData'?: CorporateYearData;
    'comments'?: string;
    'createdAt': string;
    'customerId': string;
    'customerName'?: string;
    'id': string;
    'reason'?: string;
    'reference': string;
    'reportingYear': number;
    'spendAllocationPercentage'?: number;
    'status': DataRequestStatus;
    'supplierId': string;
    'supplierName'?: string;
    'updatedAt': string;
}


export interface CorporateDataRequestListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface CorporateDataRequestListResponse {
    'data': ReadonlyArray<CorporateDataRequestDetailResponse>;
    'metadata': CorporateDataRequestListMetadataResponse;
}
export interface CorporateDataRequestResponse {
    'answeredAllocationData'?: CorporateAllocationData;
    'answeredAt'?: string;
    'answeredCorporateData'?: CorporateYearData;
    'comments'?: string;
    'createdAt': string;
    'customerId': string;
    'reason'?: string;
    'reference': string;
    'reportingYear': number;
    'spendAllocationPercentage'?: number;
    'status': DataRequestStatus;
    'supplierId': string;
    'updatedAt': string;
}


export interface CorporateDataResponse {
    'createdAt': string;
    'createdBy': string;
    'data': CorporateYearData;
    'id': string;
    'organisationId': string;
    'updatedAt': string;
    'updatedBy': string;
    'year': number;
}

export const CorporateGhgCalculationMethodology = {
    GHG_PROTOCOL: 'ghgProtocol',
    ISO14064_1_2018: 'iso14064_1_2018',
    BILAN_CARBONE_FRANCE: 'bilan_carbone_france',
    UNI_11824_2021_ITALY: 'uni_11824_2021_italy',
    UNE_EN_ISO_14064_1_SPAIN: 'une_en_iso_14064_1_spain',
    GHG_GUIDELINES_JAPAN: 'ghg_guidelines_japan',
    GBT_32151_1_2015_CHINA: 'gbt_32151_1_2015_china',
    GHG_ENERGY_TARGET_KOREA: 'ghg_energy_target_korea',
    NATIONAL_GHG_REPORTING_CANADA: 'national_ghg_reporting_canada',
    NATIONAL_GREENHOUSE_SCHEME_AUSTRALIA: 'national_greenhouse_scheme_australia',
    OTHER: 'other'
} as const;

export type CorporateGhgCalculationMethodology = typeof CorporateGhgCalculationMethodology[keyof typeof CorporateGhgCalculationMethodology];


export interface CorporateGhgEmissions {
    'aiMetadataMap'?: { [key: string]: AnswerMetadata; };
    'attachments'?: ReadonlyArray<CorporateDataAttachment>;
    'ghgCalculationMethodology'?: CorporateGhgCalculationMethodology;
    'ghgCalculationMethodologyOther'?: string;
    'hasComputedGhgEmissions'?: boolean;
    'hasComputedScope3Emissions'?: boolean;
    'hasScope3Breakdown'?: boolean;
    'hasThirdPartyAuditedGhgEmissions'?: boolean;
    'isGhgProtocolAligned'?: boolean;
    'scope12PlanToMeasure'?: ScopePlanToMeasure;
    'scope12ScopesComputed'?: Scope12ScopesComputed;
    'scope2CalculationMethod'?: CorporateScopeCalculationMethodUsed;
    'scope3PlanToMeasure'?: ScopePlanToMeasure;
    'scopedGhgEmissions'?: ReadonlyArray<CorporateScopedGhgEmission>;
    'selectedSubscopes'?: ReadonlyArray<GHGScope>;
    'thirdPartyAuditAttachments'?: ReadonlyArray<CorporateDataAttachment>;
    'thirdPartyAuditedGhgScopes'?: ReadonlyArray<GHGScope>;
    'thirdPartyAuditorName'?: string;
}



export const CorporateHasTargets = {
    SBTI: 'sbti',
    NON_SBTI: 'nonSbti',
    NO: 'no'
} as const;

export type CorporateHasTargets = typeof CorporateHasTargets[keyof typeof CorporateHasTargets];



export const CorporateIntensityDenominator = {
    KG_CO2_EQ: 'KG_CO2EQ',
    USD: 'USD',
    KG: 'KG',
    KM: 'KM',
    M2: 'M2',
    M3: 'M3',
    KM_M3: 'KM_M3',
    M3_DAY: 'M3_DAY',
    KWH: 'KWH',
    DAY: 'DAY',
    KG_DAY: 'KG_DAY',
    INDIVIDUAL: 'INDIVIDUAL',
    DAY_INDIVIDUAL: 'DAY_INDIVIDUAL',
    INDIVIDUAL_KM: 'INDIVIDUAL_KM',
    KM_VEHICLE: 'KM_VEHICLE',
    KM_YEAR: 'KM_YEAR',
    M2_YEAR: 'M2_YEAR',
    KG_KM: 'KG_KM',
    GIGABYTE: 'GIGABYTE',
    ITEM: 'ITEM',
    OTHER: 'OTHER'
} as const;

export type CorporateIntensityDenominator = typeof CorporateIntensityDenominator[keyof typeof CorporateIntensityDenominator];


export interface CorporateReductionInitiative {
    'aiMetadata'?: AnswerMetadata;
    'description'?: string;
    'endYear'?: number;
    'estimatedEmissionsReductionKg'?: number;
    'name'?: string;
    'scopesImpacted'?: ReadonlyArray<GHGScope>;
    'startYear'?: number;
    'status'?: ReductionInitiativeStatus;
}



export const CorporateScopeCalculationMethod = {
    MARKET_BASED: 'marketBased',
    LOCATION_BASED: 'locationBased'
} as const;

export type CorporateScopeCalculationMethod = typeof CorporateScopeCalculationMethod[keyof typeof CorporateScopeCalculationMethod];



export const CorporateScopeCalculationMethodUsed = {
    MARKET_BASED: 'marketBased',
    LOCATION_BASED: 'locationBased',
    BOTH: 'both',
    NONE: 'none'
} as const;

export type CorporateScopeCalculationMethodUsed = typeof CorporateScopeCalculationMethodUsed[keyof typeof CorporateScopeCalculationMethodUsed];


export interface CorporateScopedGhgEmission {
    'aiMetadata'?: AnswerMetadata;
    'calculationMethod'?: CorporateScopeCalculationMethod;
    'scope'?: GHGScope;
    'total'?: number;
}


export interface CorporateSustainabilityPerformance {
    'additionalDocumentAttachments'?: ReadonlyArray<CorporateDataAttachment>;
    'aiMetadataMap'?: { [key: string]: AnswerMetadata; };
    'calculatesProductCarbonFootprints'?: boolean;
    'corporateSustainabilityTrainings'?: ReadonlyArray<CorporateSustainabilityTrainingData>;
    'hasAdditionalSustainabilityDocuments'?: boolean;
    'hasSustainabilityReport'?: boolean;
    'hasSustainabilityTraining'?: boolean;
    'isWillingToShareAttachments'?: boolean;
    'reportAttachments'?: ReadonlyArray<CorporateDataAttachment>;
}
export interface CorporateSustainabilityTrainingData {
    'attachment'?: CorporateDataAttachment;
    'details'?: string;
    'status': CorporateSustainabilityTrainingStatus;
    'type': string;
    'year': number;
}



export const CorporateSustainabilityTrainingStatus = {
    NOT_STARTED: 'not_started',
    ENROLLED: 'enrolled',
    COMPLETED: 'completed'
} as const;

export type CorporateSustainabilityTrainingStatus = typeof CorporateSustainabilityTrainingStatus[keyof typeof CorporateSustainabilityTrainingStatus];


export interface CorporateTarget {
    'aiMetadata'?: AnswerMetadata;
    'baselineEmissions'?: ReadonlyArray<CorporateScopedGhgEmission>;
    'intensityDenominator'?: CorporateIntensityDenominator;
    'intensityDenominatorDetail'?: string;
    'isSbtiTarget'?: boolean;
    'name'?: string;
    'sbtiId'?: string;
    'scopesInSupplierFootprint'?: ReadonlyArray<GHGScope>;
    'startYear'?: number;
    'status'?: CorporateTargetStatus;
    'targetReductionPercentage'?: number;
    'targetSector'?: CorporateTargetSector;
    'targetType'?: CorporateTargetType;
    'targetYear'?: number;
    'timeFrame'?: CorporateTargetTimeFrame;
}



export const CorporateTargetSector = {
    ENERGY: 'ENERGY',
    FLAG: 'FLAG',
    INDUSTRY: 'INDUSTRY',
    BUILT_ENVIRONMENT: 'BUILT_ENVIRONMENT',
    FINANCIAL_INSTITUTIONS: 'FINANCIAL_INSTITUTIONS',
    TRANSPORT: 'TRANSPORT'
} as const;

export type CorporateTargetSector = typeof CorporateTargetSector[keyof typeof CorporateTargetSector];



export const CorporateTargetStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED'
} as const;

export type CorporateTargetStatus = typeof CorporateTargetStatus[keyof typeof CorporateTargetStatus];



export const CorporateTargetTimeFrame = {
    NEAR_TERM: 'NEAR_TERM',
    LONG_TERM: 'LONG_TERM',
    MEDIUM_TERM: 'MEDIUM_TERM',
    UNKNOWN: 'UNKNOWN'
} as const;

export type CorporateTargetTimeFrame = typeof CorporateTargetTimeFrame[keyof typeof CorporateTargetTimeFrame];



export const CorporateTargetType = {
    ABSOLUTE: 'ABSOLUTE',
    INTENSITY: 'INTENSITY',
    OTHER: 'OTHER'
} as const;

export type CorporateTargetType = typeof CorporateTargetType[keyof typeof CorporateTargetType];


export interface CorporateTargetsInitiatives {
    'aiMetadataMap'?: { [key: string]: AnswerMetadata; };
    'hasReductionInitiatives'?: boolean;
    'hasTargets'?: CorporateHasTargets;
    'reductionInitiatives'?: ReadonlyArray<CorporateReductionInitiative>;
    'sbtiId'?: string;
    'targets'?: ReadonlyArray<CorporateTarget>;
}


export interface CorporateYearData {
    'ghgEmissions'?: CorporateGhgEmissions;
    'sustainabilityPerformance'?: CorporateSustainabilityPerformance;
    'targets'?: CorporateTargetsInitiatives;
}
export interface CreateCorporateDataRequestsRequest {
    'suppliers': ReadonlyArray<SupplierCorporateRequest>;
}
export interface CreateEmissionRequest {
    'formTemplateVersionId'?: string;
    'productIds': ReadonlyArray<string>;
    'supplierId': string;
}
export interface CreateEmissionRequestsRequest {
    'category'?: ProductOrServiceCategory;
    'formTemplateId'?: string;
    'products': ReadonlyArray<ProductSupplierId>;
}


export interface CreateFormTemplateRequest {
    'description'?: string;
    'isDefault': boolean;
    'name': string;
}
export interface CreateFormTemplateVersionRequest {
    'formSchema': { [key: string]: any; };
    'isPactCompliant': boolean;
}
export interface CreateInvitationsRequest {
    'emailsToNotifyPerPrimaryEmail': { [key: string]: ReadonlyArray<string>; };
    'recipientOrganisationIdByEmail': { [key: string]: string; };
}
export interface Customer {
    'id': string;
    'name': string;
}
export interface CustomerShareRecipient {
    'recipientEmail'?: string;
    'recipientOrgName': string;
    'recipientOrganisationId'?: string;
}
export interface CustomerShareRequest {
    'productIds': ReadonlyArray<string>;
    'recipients': ReadonlyArray<CustomerShareRecipient>;
}
export interface DataQualityIndicators {
    'geographicalDQR': string;
    'technologicalDQR': string;
    'temporalDQR': string;
}
/**
 * Status of an emission data request.
 */

export const DataRequestStatus = {
    NOT_STARTED: 'NOT_STARTED',
    REJECTED: 'REJECTED',
    REQUESTED: 'REQUESTED',
    PENDING_REVIEW: 'PENDING_REVIEW',
    REQUESTED_CLARIFICATION: 'REQUESTED_CLARIFICATION',
    COMPLETED: 'COMPLETED',
    DECLINED: 'DECLINED',
    CANCELED: 'CANCELED'
} as const;

export type DataRequestStatus = typeof DataRequestStatus[keyof typeof DataRequestStatus];


export interface DataSourceDetail {
    'dataSourceType': DataSourceDetailDataSourceTypeEnum;
    'sourceDescription': DataSourceDetailSourceDescriptionEnum;
    'sourceDescriptionOther'?: string;
}

export const DataSourceDetailDataSourceTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    BOTH: 'BOTH',
    NONE: 'NONE'
} as const;

export type DataSourceDetailDataSourceTypeEnum = typeof DataSourceDetailDataSourceTypeEnum[keyof typeof DataSourceDetailDataSourceTypeEnum];
export const DataSourceDetailSourceDescriptionEnum = {
    SELF: 'SELF',
    SUPPLIER: 'SUPPLIER',
    EPA_GHG_EMISSION_FACTORS_HUB: 'EPA_GHG_EMISSION_FACTORS_HUB',
    DEFRA_CONVERSION_FACTORS: 'DEFRA_CONVERSION_FACTORS',
    ADEME_BASE_CARBONE: 'ADEME_BASE_CARBONE',
    IPCC_EMISSION_FACTORS_DATABASE: 'IPCC_EMISSION_FACTORS_DATABASE',
    ECOMETRICA: 'ECOMETRICA',
    IDEMAT: 'IDEMAT',
    ECOINVENT: 'ECOINVENT',
    AGRIFOOTPRINT: 'AGRIFOOTPRINT',
    GABI: 'GABI',
    PRODUCT_ECOSYSTEM_CALCULATOR: 'PRODUCT_ECOSYSTEM_CALCULATOR',
    AGRIBALYSE: 'AGRIBALYSE',
    GLEC: 'GLEC',
    OTHER: 'OTHER'
} as const;

export type DataSourceDetailSourceDescriptionEnum = typeof DataSourceDetailSourceDescriptionEnum[keyof typeof DataSourceDetailSourceDescriptionEnum];

export interface DataSources {
    'dataSourceDetails': ReadonlyArray<DataSourceDetail>;
    'dataSourceType'?: DataSourcesDataSourceTypeEnum;
    'primarySourceDescription'?: string;
    'secondarySourceDescription'?: string;
    'secondarySourceDescriptionOther'?: string;
    'secondarySourceDetails'?: ReadonlyArray<SecondaryDataSourceDetail>;
    'shareOfPrimaryDataInEmissionFactor'?: number;
}

export const DataSourcesDataSourceTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    BOTH: 'BOTH',
    NONE: 'NONE'
} as const;

export type DataSourcesDataSourceTypeEnum = typeof DataSourcesDataSourceTypeEnum[keyof typeof DataSourcesDataSourceTypeEnum];

export interface DeprecatedCreateInvitationsRequest {
    'emails': ReadonlyArray<string>;
}
export interface DraftDataSourceDetail {
    'dataSourceType'?: DraftDataSourceDetailDataSourceTypeEnum;
    'sourceDescription'?: DraftDataSourceDetailSourceDescriptionEnum;
    'sourceDescriptionOther'?: string;
}

export const DraftDataSourceDetailDataSourceTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    BOTH: 'BOTH',
    NONE: 'NONE'
} as const;

export type DraftDataSourceDetailDataSourceTypeEnum = typeof DraftDataSourceDetailDataSourceTypeEnum[keyof typeof DraftDataSourceDetailDataSourceTypeEnum];
export const DraftDataSourceDetailSourceDescriptionEnum = {
    SELF: 'SELF',
    SUPPLIER: 'SUPPLIER',
    EPA_GHG_EMISSION_FACTORS_HUB: 'EPA_GHG_EMISSION_FACTORS_HUB',
    DEFRA_CONVERSION_FACTORS: 'DEFRA_CONVERSION_FACTORS',
    ADEME_BASE_CARBONE: 'ADEME_BASE_CARBONE',
    IPCC_EMISSION_FACTORS_DATABASE: 'IPCC_EMISSION_FACTORS_DATABASE',
    ECOMETRICA: 'ECOMETRICA',
    IDEMAT: 'IDEMAT',
    ECOINVENT: 'ECOINVENT',
    AGRIFOOTPRINT: 'AGRIFOOTPRINT',
    GABI: 'GABI',
    PRODUCT_ECOSYSTEM_CALCULATOR: 'PRODUCT_ECOSYSTEM_CALCULATOR',
    AGRIBALYSE: 'AGRIBALYSE',
    GLEC: 'GLEC',
    OTHER: 'OTHER'
} as const;

export type DraftDataSourceDetailSourceDescriptionEnum = typeof DraftDataSourceDetailSourceDescriptionEnum[keyof typeof DraftDataSourceDetailSourceDescriptionEnum];

export interface DraftDataSources {
    'dataSourceDetails'?: ReadonlyArray<DraftDataSourceDetail>;
    'dataSourceType'?: DraftDataSourcesDataSourceTypeEnum;
    'shareOfPrimaryDataInEmissionFactor'?: number;
}

export const DraftDataSourcesDataSourceTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    BOTH: 'BOTH',
    NONE: 'NONE'
} as const;

export type DraftDataSourcesDataSourceTypeEnum = typeof DraftDataSourcesDataSourceTypeEnum[keyof typeof DraftDataSourcesDataSourceTypeEnum];

export interface DraftEmissionRequestFormData {
    'answeredUnit'?: EmissionValueAnsweredUnit;
    'comment'?: string;
    'dataSources'?: DraftDataSources;
    'emissionValues'?: DraftEmissionValues;
    'methodologies'?: DraftMethodologies;
    'reductionInitiatives'?: ReadonlyArray<ReductionInitiative>;
    'reductionPlan'?: DraftReductionPlan;
    'reportingUnit'?: ReportingUnit;
    'verificationData'?: DraftVerificationData;
}


export interface DraftEmissionValueItem {
    'description'?: string;
    'emissionType'?: EmissionType;
    'lifecycleStage'?: LifecycleStage;
    'unit'?: EmissionValueUnit;
    'value'?: number;
}


export interface DraftEmissionValues {
    'additionalInformation'?: string;
    'allocationMethodUsed'?: DraftEmissionValuesAllocationMethodUsedEnum;
    'appliedExemptionsComments'?: string;
    'biogenicCO2UptakeValue'?: number;
    'biogenicEmissionsValue'?: number;
    'biogenicLandUseEmissionsValue'?: number;
    'biogenicNonCO2EmissionsValue'?: number;
    'breakdownSharingLevel'?: DraftEmissionValuesBreakdownSharingLevelEnum;
    'confidence'?: ConfidenceLevel;
    'downstreamTransportationGhgEmissions'?: number;
    'emissionValuesBoundary'?: EmissionValueBoundary;
    'emissionValuesGranularity'?: EmissionValueGranularityLevel;
    'emissionValuesLocation'?: DraftEmissionValuesLocation;
    'emissionsAttachments'?: ReadonlyArray<DraftEmissionsAttachment>;
    'emissionsValuesBreakdown'?: DraftEmissionsValuesBreakdown;
    'emissionsWithBiogenicValue'?: number;
    'exactProductionProcessComments'?: string;
    'fossilEmissionsValue'?: number;
    'hasAllocationBetweenCoProducts'?: boolean;
    'hasAppliedExemptions'?: boolean;
    'hasEmissionAlreadyAvailable'?: boolean;
    'hasRenewableEnergyAtSite'?: boolean;
    'includeBiogenicBreakdownEmissions'?: boolean;
    'includeBiogenicCO2Uptake'?: boolean;
    'includeBiogenicEmissions'?: boolean;
    'includeDownstreamTransportationEmissions'?: boolean;
    'includePackagingEmissions'?: boolean;
    'isExactProductionProcess'?: DraftEmissionValuesIsExactProductionProcessEnum;
    'isUsingMassBalancing'?: boolean;
    'manufacturingGhgEmissions'?: number;
    'otherBiogenicEmissionsValue'?: number;
    'packagingGhgEmissions'?: number;
    'pcfMainContributorsComment'?: string;
    'percentageFromOwnOperations'?: number;
    'percentageOfDownstreamTransportationEmissions'?: number;
    'percentageOfManufacturingEmissions'?: number;
    'percentageOfPackagingEmissions'?: number;
    'percentageOfPcrInPackaging'?: number;
    'percentageRenewableEnergyOnPPAs'?: number;
    'percentageRenewableEnergyOnSite'?: number;
    'percentageRenewableEnergyOnUnbundledRECs'?: number;
    'percentageRenewableOnGreenTariff'?: number;
    'referenceYear'?: number;
    'scope1Emissions'?: number;
    'scope2Emissions'?: number;
    'transportEnergies'?: ReadonlyArray<TransportEnergy>;
    'transportModes'?: ReadonlyArray<TransportMode>;
    'transportTemperature'?: TransportTemperature;
}

export const DraftEmissionValuesAllocationMethodUsedEnum = {
    AVOID_BY_PARTITIONING: 'AVOID_BY_PARTITIONING',
    AVOID_BY_SYSTEM_EXPANSION: 'AVOID_BY_SYSTEM_EXPANSION',
    ECONOMIC_ALLOCATION: 'ECONOMIC_ALLOCATION',
    MASS_ALLOCATION: 'MASS_ALLOCATION',
    OTHER: 'OTHER'
} as const;

export type DraftEmissionValuesAllocationMethodUsedEnum = typeof DraftEmissionValuesAllocationMethodUsedEnum[keyof typeof DraftEmissionValuesAllocationMethodUsedEnum];
export const DraftEmissionValuesBreakdownSharingLevelEnum = {
    NONE: 'NONE',
    AGGREGATED: 'AGGREGATED',
    DETAILED: 'DETAILED'
} as const;

export type DraftEmissionValuesBreakdownSharingLevelEnum = typeof DraftEmissionValuesBreakdownSharingLevelEnum[keyof typeof DraftEmissionValuesBreakdownSharingLevelEnum];
export const DraftEmissionValuesIsExactProductionProcessEnum = {
    YES_EXACT_SAME_PROCESS: 'YES_EXACT_SAME_PROCESS',
    NO_SIMILAR: 'NO_SIMILAR',
    NO_I_DONT_KNOW: 'NO_I_DONT_KNOW'
} as const;

export type DraftEmissionValuesIsExactProductionProcessEnum = typeof DraftEmissionValuesIsExactProductionProcessEnum[keyof typeof DraftEmissionValuesIsExactProductionProcessEnum];

export interface DraftEmissionValuesLocation {
    'country'?: DraftEmissionValuesLocationCountryEnum;
    'geographySiteDetail'?: string;
    'geographySourceType'?: GeographySourceType;
    'isGeographyMatchingManufacturing'?: boolean;
    'locationType'?: DraftEmissionValuesLocationLocationTypeEnum;
    'manufacturingLocation'?: DraftManufacturingLocation;
    'region'?: DraftEmissionValuesLocationRegionEnum;
}

export const DraftEmissionValuesLocationCountryEnum = {
    AFG: 'AFG',
    AGO: 'AGO',
    ALB: 'ALB',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BOL: 'BOL',
    BRA: 'BRA',
    BRN: 'BRN',
    BTN: 'BTN',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COL: 'COL',
    CRI: 'CRI',
    CUB: 'CUB',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GHA: 'GHA',
    GIN: 'GIN',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRL: 'GRL',
    GTM: 'GTM',
    GUY: 'GUY',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IND: 'IND',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KOR: 'KOR',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAR: 'MAR',
    MDA: 'MDA',
    MDG: 'MDG',
    MEX: 'MEX',
    MKD: 'MKD',
    MLI: 'MLI',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MWI: 'MWI',
    MYS: 'MYS',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NGA: 'NGA',
    NIC: 'NIC',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PER: 'PER',
    PHL: 'PHL',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    ESH: 'ESH',
    SAU: 'SAU',
    SDN: 'SDN',
    SSD: 'SSD',
    SEN: 'SEN',
    SGP: 'SGP',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SOM: 'SOM',
    SRB: 'SRB',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SYR: 'SYR',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKM: 'TKM',
    TLS: 'TLS',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VEN: 'VEN',
    VNM: 'VNM',
    VUT: 'VUT',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type DraftEmissionValuesLocationCountryEnum = typeof DraftEmissionValuesLocationCountryEnum[keyof typeof DraftEmissionValuesLocationCountryEnum];
export const DraftEmissionValuesLocationLocationTypeEnum = {
    GLOBAL: 'GLOBAL',
    REGIONAL: 'REGIONAL',
    COUNTRY: 'COUNTRY',
    SITE: 'SITE'
} as const;

export type DraftEmissionValuesLocationLocationTypeEnum = typeof DraftEmissionValuesLocationLocationTypeEnum[keyof typeof DraftEmissionValuesLocationLocationTypeEnum];
export const DraftEmissionValuesLocationRegionEnum = {
    AFRICA: 'AFRICA',
    ANTARCTICA: 'ANTARCTICA',
    ASIA: 'ASIA',
    EUROPE: 'EUROPE',
    NORTH_AMERICA: 'NORTH_AMERICA',
    OCEANIA: 'OCEANIA',
    SOUTH_AMERICA: 'SOUTH_AMERICA'
} as const;

export type DraftEmissionValuesLocationRegionEnum = typeof DraftEmissionValuesLocationRegionEnum[keyof typeof DraftEmissionValuesLocationRegionEnum];

export interface DraftEmissionsAttachment {
    'id'?: string;
    'name'?: string;
}
export interface DraftEmissionsValuesBreakdown {
    'dataUsed'?: EmissionValueDataUsed;
    'distributionAndStorage'?: ReadonlyArray<DraftEmissionValueItem>;
    'endOfLife'?: ReadonlyArray<DraftEmissionValueItem>;
    'materialAcquisitionAndPreprocessing'?: ReadonlyArray<DraftEmissionValueItem>;
    'productUse'?: ReadonlyArray<DraftEmissionValueItem>;
    'production'?: ReadonlyArray<DraftEmissionValueItem>;
    'unit'?: EmissionValueUnit;
    'unitOther'?: string;
    'upstreamTransportation'?: ReadonlyArray<DraftEmissionValueItem>;
    'value'?: number;
    'valueExcludingBiogenicCarbon'?: number;
}


export interface DraftManufacturingLocation {
    'country'?: DraftManufacturingLocationCountryEnum;
    'locationType'?: DraftManufacturingLocationLocationTypeEnum;
    'region'?: DraftManufacturingLocationRegionEnum;
}

export const DraftManufacturingLocationCountryEnum = {
    AFG: 'AFG',
    AGO: 'AGO',
    ALB: 'ALB',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BOL: 'BOL',
    BRA: 'BRA',
    BRN: 'BRN',
    BTN: 'BTN',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COL: 'COL',
    CRI: 'CRI',
    CUB: 'CUB',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GHA: 'GHA',
    GIN: 'GIN',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRL: 'GRL',
    GTM: 'GTM',
    GUY: 'GUY',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IND: 'IND',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KOR: 'KOR',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAR: 'MAR',
    MDA: 'MDA',
    MDG: 'MDG',
    MEX: 'MEX',
    MKD: 'MKD',
    MLI: 'MLI',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MWI: 'MWI',
    MYS: 'MYS',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NGA: 'NGA',
    NIC: 'NIC',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PER: 'PER',
    PHL: 'PHL',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    ESH: 'ESH',
    SAU: 'SAU',
    SDN: 'SDN',
    SSD: 'SSD',
    SEN: 'SEN',
    SGP: 'SGP',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SOM: 'SOM',
    SRB: 'SRB',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SYR: 'SYR',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKM: 'TKM',
    TLS: 'TLS',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VEN: 'VEN',
    VNM: 'VNM',
    VUT: 'VUT',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type DraftManufacturingLocationCountryEnum = typeof DraftManufacturingLocationCountryEnum[keyof typeof DraftManufacturingLocationCountryEnum];
export const DraftManufacturingLocationLocationTypeEnum = {
    REGIONAL: 'REGIONAL',
    COUNTRY: 'COUNTRY',
    UNKNOWN: 'UNKNOWN'
} as const;

export type DraftManufacturingLocationLocationTypeEnum = typeof DraftManufacturingLocationLocationTypeEnum[keyof typeof DraftManufacturingLocationLocationTypeEnum];
export const DraftManufacturingLocationRegionEnum = {
    AFRICA: 'AFRICA',
    ANTARCTICA: 'ANTARCTICA',
    ASIA: 'ASIA',
    EUROPE: 'EUROPE',
    NORTH_AMERICA: 'NORTH_AMERICA',
    OCEANIA: 'OCEANIA',
    SOUTH_AMERICA: 'SOUTH_AMERICA'
} as const;

export type DraftManufacturingLocationRegionEnum = typeof DraftManufacturingLocationRegionEnum[keyof typeof DraftManufacturingLocationRegionEnum];

export interface DraftMethodologies {
    'collectionEndDate'?: string;
    'collectionStartDate'?: string;
    'impactAssessmentMethod'?: ReadonlyArray<DraftMethodologiesImpactAssessmentMethodEnum>;
    'methodologyStandards'?: DraftMethodologyStandards;
    'otherImpactAssessmentName'?: string;
    'validityEndDate'?: string;
    'validityStartDate'?: string;
}

export const DraftMethodologiesImpactAssessmentMethodEnum = {
    EF_3_0: 'EF_3_0',
    EF_V3_1: 'EF_V3_1',
    RECIPE_2016: 'RECIPE_2016',
    CML_IA_BASELINE: 'CML_IA_BASELINE',
    EN_15804_A2: 'EN_15804_A2',
    ILCD_2011: 'ILCD_2011',
    TRACI_2_2: 'TRACI_2_2',
    IMPACT_WORLD: 'IMPACT_WORLD',
    IPCC_2007_GWP_100: 'IPCC_2007_GWP_100',
    IPCC_2013_GWP_100: 'IPCC_2013_GWP_100',
    IPCC_2021_GWP_100: 'IPCC_2021_GWP_100',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
} as const;

export type DraftMethodologiesImpactAssessmentMethodEnum = typeof DraftMethodologiesImpactAssessmentMethodEnum[keyof typeof DraftMethodologiesImpactAssessmentMethodEnum];

export interface DraftMethodologyStandards {
    'additionalInformation'?: string;
    'standardCompliant'?: DraftMethodologyStandardsStandardCompliantEnum;
    'standardUsed'?: ReadonlyArray<Standard>;
}

export const DraftMethodologyStandardsStandardCompliantEnum = {
    YES: 'YES',
    NO: 'NO',
    UNKNOWN: 'UNKNOWN'
} as const;

export type DraftMethodologyStandardsStandardCompliantEnum = typeof DraftMethodologyStandardsStandardCompliantEnum[keyof typeof DraftMethodologyStandardsStandardCompliantEnum];

export interface DraftReductionPlan {
    'hasAlternativeWithLowerCarbon'?: boolean;
    'hasAlternativeWithLowerCarbonComments'?: string;
    'hasReductionPlan'?: boolean;
    'reductionPlanComments'?: string;
}
export interface DraftVerificationAttachment {
    'id'?: string;
    'name'?: string;
}
export interface DraftVerificationData {
    'additionalVerificationProviderDetails'?: string;
    'additionalVerificationStandardDetails'?: string;
    'isDataVerified'?: boolean;
    'isProductVerified'?: boolean;
    'isToolVerified'?: boolean;
    'verificationAttachments'?: ReadonlyArray<DraftVerificationAttachment>;
    'verificationProvider'?: VerificationProvider;
    'verificationStandard'?: Standard;
}


export interface EmailListRequest {
    'emails': ReadonlyArray<string>;
}
export interface EmailToken {
    'id'?: string;
    'initialEmail'?: string;
    'organisationId'?: string;
    'recipientEmail': string;
    'senderEmail'?: string;
    'token': string;
}
export interface EmailTokensResponse {
    'emailTokens': ReadonlyArray<EmailToken>;
}
export interface EmissionDataRejectionRequest {
    'reason': string;
}
export interface EmissionDataRequest {
    'created'?: string;
    'emissionGranularity'?: EmissionDataRequestEmissionGranularityEnum;
    'emissionRequestReference'?: string;
    'emissionValue'?: number;
    'emissionValuesLocation'?: EmissionValuesLocation;
    'formTemplateName'?: string;
    'inProgress': boolean;
    'isLocked': boolean;
    'lastUpdated'?: string;
    'levelOfConfidence'?: EmissionDataRequestLevelOfConfidenceEnum;
    'pactDqrScore'?: number;
    'sanityChecksScore'?: number;
    'source': EmissionDataRequestSourceEnum;
    'status': DataRequestStatus;
    'statusLabel'?: EmissionDataRequestStatusLabelEnum;
}

export const EmissionDataRequestEmissionGranularityEnum = {
    DETAILED_LIFECYCLE: 'DETAILED_LIFECYCLE',
    LIFECYCLE: 'LIFECYCLE',
    PRODUCT: 'PRODUCT',
    CALCULATOR: 'CALCULATOR',
    SHARE_COMPANY: 'SHARE_COMPANY',
    UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type EmissionDataRequestEmissionGranularityEnum = typeof EmissionDataRequestEmissionGranularityEnum[keyof typeof EmissionDataRequestEmissionGranularityEnum];
export const EmissionDataRequestLevelOfConfidenceEnum = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW'
} as const;

export type EmissionDataRequestLevelOfConfidenceEnum = typeof EmissionDataRequestLevelOfConfidenceEnum[keyof typeof EmissionDataRequestLevelOfConfidenceEnum];
export const EmissionDataRequestSourceEnum = {
    ECOSYSTEM: 'Ecosystem',
    PACT: 'Pact',
    CATENA_X: 'CatenaX'
} as const;

export type EmissionDataRequestSourceEnum = typeof EmissionDataRequestSourceEnum[keyof typeof EmissionDataRequestSourceEnum];
export const EmissionDataRequestStatusLabelEnum = {
    OPEN: 'OPEN',
    DECLINED: 'DECLINED',
    IN_REVIEW: 'IN_REVIEW',
    COMPLETE: 'COMPLETE',
    CANCELED: 'CANCELED'
} as const;

export type EmissionDataRequestStatusLabelEnum = typeof EmissionDataRequestStatusLabelEnum[keyof typeof EmissionDataRequestStatusLabelEnum];

export interface EmissionFactorSource {
    'name': string;
    'version': string;
}
export interface EmissionRequestAttachmentData {
    'attachmentId': string;
    'data': string;
    'mediaType': string;
}
export interface EmissionRequestProduct {
    'answeredUnit'?: EmissionValueAnsweredUnit;
    'createdAt': string;
    'customerId': string;
    'emissionData'?: EmissionRequestProductFormData;
    'emissionDraftData'?: DraftEmissionRequestFormData;
    'emissionRequestId': string;
    'featureFlags'?: EmissionRequestProductFeatureFlags;
    'formData'?: { [key: string]: any; };
    'formDataPrefillMetadata'?: { [key: string]: any; };
    'formSchema'?: { [key: string]: any; };
    'formTemplateVersionId'?: string;
    'id': string;
    'isPactCompliant': boolean;
    'lockedAt'?: string;
    'lockedByUserId'?: string;
    'organisationId'?: string;
    'pactDqrScore'?: number;
    'productDescription'?: string;
    'productId': string;
    'productInternalReference'?: string;
    'productName': string;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'productRequestComment'?: string;
    'productRequestStatus': DataRequestStatus;
    'productUnit': EmissionValueUnit;
    'purchasingPeriodEnd'?: string;
    'purchasingPeriodStart'?: string;
    'reason': string;
    'sanityChecksScore'?: number;
    'source': EmissionRequestProductSourceEnum;
    'templateId'?: string;
    'updatedAt': string;
}

export const EmissionRequestProductSourceEnum = {
    ECOSYSTEM: 'Ecosystem',
    PACT: 'Pact',
    CATENA_X: 'CatenaX'
} as const;

export type EmissionRequestProductSourceEnum = typeof EmissionRequestProductSourceEnum[keyof typeof EmissionRequestProductSourceEnum];

export interface EmissionRequestProductFeatureFlags {
    'hasAdvancedQuestions': boolean;
}
export interface EmissionRequestProductFormData {
    'answeredUnit'?: EmissionValueAnsweredUnit;
    'comment'?: string;
    'dataSources': DataSources;
    'emissionValues': EmissionValues;
    'methodologies': Methodologies;
    'reductionInitiatives'?: ReadonlyArray<ReductionInitiative>;
    'reductionPlan'?: ReductionPlan;
    'reportingUnit'?: ReportingUnit;
    'verificationData'?: VerificationData;
}


export interface EmissionRequestResponse {
    'productIds': ReadonlyArray<string>;
    'reference': string;
    'supplierId': string;
}
export interface EmissionRequestSummary {
    'customerId': string;
    'customerName': string;
    'productRequestResponseList': ReadonlyArray<ProductDataRequestResponse>;
    'productRequestsAggregatedStatus': EmissionRequestSummaryProductRequestsAggregatedStatusEnum;
    'reference': string;
    'supplierId': string;
    'supplierName': string;
}

export const EmissionRequestSummaryProductRequestsAggregatedStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
} as const;

export type EmissionRequestSummaryProductRequestsAggregatedStatusEnum = typeof EmissionRequestSummaryProductRequestsAggregatedStatusEnum[keyof typeof EmissionRequestSummaryProductRequestsAggregatedStatusEnum];

export interface EmissionRequestSummaryMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface EmissionRequestSummaryResponse {
    'items': ReadonlyArray<EmissionRequestSummary>;
    'metadata': EmissionRequestSummaryMetadataResponse;
}
export interface EmissionRequestTransientData {
    'attachments': ReadonlyArray<EmissionRequestAttachmentData>;
}

export const EmissionType = {
    SCOPE_1: 'SCOPE_1',
    SCOPE_2: 'SCOPE_2',
    SCOPE_3: 'SCOPE_3',
    SCOPE_1_2: 'SCOPE_1_2',
    SCOPE_1_2_3: 'SCOPE_1_2_3'
} as const;

export type EmissionType = typeof EmissionType[keyof typeof EmissionType];



export const EmissionValueAnsweredUnit = {
    KGCO2_EQ_KM: 'KGCO2EQ_KM',
    KGCO2_EQ_KG: 'KGCO2EQ_KG',
    KGCO2_EQ_GB: 'KGCO2EQ_GB',
    KGCO2_EQ_M2: 'KGCO2EQ_M2',
    KGCO2_EQ_M3: 'KGCO2EQ_M3',
    KGCO2_EQ_KWH: 'KGCO2EQ_KWH',
    KGCO2_EQ_KG_KM: 'KGCO2EQ_KG_KM',
    KGCO2_EQ_DAY: 'KGCO2EQ_DAY',
    KGCO2_EQ_USD: 'KGCO2EQ_USD',
    KGCO2_EQ_EUR: 'KGCO2EQ_EUR',
    KGCO2_EQ_DIMENSIONLESS: 'KGCO2EQ_DIMENSIONLESS',
    KGCO2_EQ_ITEM: 'KGCO2EQ_ITEM',
    KGCO2_EQ_MI: 'KGCO2EQ_MI',
    KGCO2_EQ_LBS: 'KGCO2EQ_LBS',
    KGCO2_EQ_FT2: 'KGCO2EQ_FT2',
    KGCO2_EQ_FT3: 'KGCO2EQ_FT3',
    KGCO2_EQ_LBS_MI: 'KGCO2EQ_LBS_MI',
    OTHER: 'OTHER'
} as const;

export type EmissionValueAnsweredUnit = typeof EmissionValueAnsweredUnit[keyof typeof EmissionValueAnsweredUnit];



export const EmissionValueBoundary = {
    CRADLE_TO_GATE: 'CRADLE_TO_GATE',
    CRADLE_TO_GRAVE: 'CRADLE_TO_GRAVE',
    CRADLE_TO_GATE_AND_END_OF_LIFE: 'CRADLE_TO_GATE_AND_END_OF_LIFE',
    GATE_TO_GATE: 'GATE_TO_GATE',
    WELL_TO_TANK: 'WELL_TO_TANK',
    TANK_TO_WHEEL: 'TANK_TO_WHEEL',
    WELL_TO_WHEEL: 'WELL_TO_WHEEL'
} as const;

export type EmissionValueBoundary = typeof EmissionValueBoundary[keyof typeof EmissionValueBoundary];



export const EmissionValueDataUsed = {
    PRODUCT: 'PRODUCT',
    COMPANY: 'COMPANY'
} as const;

export type EmissionValueDataUsed = typeof EmissionValueDataUsed[keyof typeof EmissionValueDataUsed];



export const EmissionValueGranularityLevel = {
    DETAILED_LIFECYCLE: 'DETAILED_LIFECYCLE',
    LIFECYCLE: 'LIFECYCLE',
    PRODUCT: 'PRODUCT',
    CALCULATOR: 'CALCULATOR',
    SHARE_COMPANY: 'SHARE_COMPANY',
    UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type EmissionValueGranularityLevel = typeof EmissionValueGranularityLevel[keyof typeof EmissionValueGranularityLevel];


export interface EmissionValueItem {
    'description'?: string;
    'emissionType'?: EmissionType;
    'lifecycleStage'?: LifecycleStage;
    'unit': EmissionValueUnit;
    'value': number;
}


/**
 * Units for emission values.
 */

export const EmissionValueUnit = {
    KGCO2_EQ_KM: 'KGCO2EQ_KM',
    KGCO2_EQ_KG: 'KGCO2EQ_KG',
    KGCO2_EQ_GB: 'KGCO2EQ_GB',
    KGCO2_EQ_M2: 'KGCO2EQ_M2',
    KGCO2_EQ_M3: 'KGCO2EQ_M3',
    KGCO2_EQ_KWH: 'KGCO2EQ_KWH',
    KGCO2_EQ_KG_KM: 'KGCO2EQ_KG_KM',
    KGCO2_EQ_DAY: 'KGCO2EQ_DAY',
    KGCO2_EQ_USD: 'KGCO2EQ_USD',
    KGCO2_EQ_EUR: 'KGCO2EQ_EUR',
    KGCO2_EQ_DIMENSIONLESS: 'KGCO2EQ_DIMENSIONLESS',
    KGCO2_EQ_ITEM: 'KGCO2EQ_ITEM',
    OTHER: 'OTHER'
} as const;

export type EmissionValueUnit = typeof EmissionValueUnit[keyof typeof EmissionValueUnit];


export interface EmissionValues {
    'additionalInformation'?: string;
    'allocationMethodUsed'?: EmissionValuesAllocationMethodUsedEnum;
    'appliedExemptionsComments'?: string;
    'biogenicCO2UptakeValue'?: number;
    'biogenicEmissionsValue'?: number;
    'biogenicLandUseEmissionsValue'?: number;
    'biogenicNonCO2EmissionsValue'?: number;
    'breakdownSharingLevel'?: EmissionValuesBreakdownSharingLevelEnum;
    'confidence'?: ConfidenceLevel;
    'downstreamTransportationGhgEmissions'?: number;
    'emissionValuesBoundary'?: EmissionValueBoundary;
    'emissionValuesGranularity'?: EmissionValueGranularityLevel;
    'emissionValuesLocation'?: EmissionValuesLocation;
    'emissionsAttachments'?: ReadonlyArray<EmissionsAttachment>;
    'emissionsValuesBreakdown'?: EmissionsValuesBreakdown;
    'emissionsWithBiogenicValue'?: number;
    'exactProductionProcessComments'?: string;
    'fossilEmissionsValue'?: number;
    'hasAllocationBetweenCoProducts'?: boolean;
    'hasAppliedExemptions'?: boolean;
    'hasEmissionAlreadyAvailable'?: boolean;
    'hasRenewableEnergyAtSite'?: boolean;
    'includeBiogenicBreakdownEmissions'?: boolean;
    'includeBiogenicCO2Uptake'?: boolean;
    'includeBiogenicEmissions'?: boolean;
    'includeDownstreamTransportationEmissions'?: boolean;
    'includePackagingEmissions'?: boolean;
    'isExactProductionProcess'?: EmissionValuesIsExactProductionProcessEnum;
    'isUsingMassBalancing'?: boolean;
    'manufacturingGhgEmissions'?: number;
    'otherBiogenicEmissionsValue'?: number;
    'packagingGhgEmissions'?: number;
    'pcfMainContributorsComment'?: string;
    'percentageFromOwnOperations'?: number;
    'percentageOfDownstreamTransportationEmissions'?: number;
    'percentageOfManufacturingEmissions'?: number;
    'percentageOfPackagingEmissions'?: number;
    'percentageOfPcrInPackaging'?: number;
    'percentageRenewableEnergyOnPPAs'?: number;
    'percentageRenewableEnergyOnSite'?: number;
    'percentageRenewableEnergyOnUnbundledRECs'?: number;
    'percentageRenewableOnGreenTariff'?: number;
    'referenceYear'?: number;
    'scope1Emissions'?: number;
    'scope2Emissions'?: number;
    'transportEnergies'?: ReadonlyArray<TransportEnergy>;
    'transportModes'?: ReadonlyArray<TransportMode>;
    'transportTemperature'?: TransportTemperature;
}

export const EmissionValuesAllocationMethodUsedEnum = {
    AVOID_BY_PARTITIONING: 'AVOID_BY_PARTITIONING',
    AVOID_BY_SYSTEM_EXPANSION: 'AVOID_BY_SYSTEM_EXPANSION',
    ECONOMIC_ALLOCATION: 'ECONOMIC_ALLOCATION',
    MASS_ALLOCATION: 'MASS_ALLOCATION',
    OTHER: 'OTHER'
} as const;

export type EmissionValuesAllocationMethodUsedEnum = typeof EmissionValuesAllocationMethodUsedEnum[keyof typeof EmissionValuesAllocationMethodUsedEnum];
export const EmissionValuesBreakdownSharingLevelEnum = {
    NONE: 'NONE',
    AGGREGATED: 'AGGREGATED',
    DETAILED: 'DETAILED'
} as const;

export type EmissionValuesBreakdownSharingLevelEnum = typeof EmissionValuesBreakdownSharingLevelEnum[keyof typeof EmissionValuesBreakdownSharingLevelEnum];
export const EmissionValuesIsExactProductionProcessEnum = {
    YES_EXACT_SAME_PROCESS: 'YES_EXACT_SAME_PROCESS',
    NO_SIMILAR: 'NO_SIMILAR',
    NO_I_DONT_KNOW: 'NO_I_DONT_KNOW'
} as const;

export type EmissionValuesIsExactProductionProcessEnum = typeof EmissionValuesIsExactProductionProcessEnum[keyof typeof EmissionValuesIsExactProductionProcessEnum];

export interface EmissionValuesLocation {
    'country'?: EmissionValuesLocationCountryEnum;
    'geographySiteDetail'?: string;
    'geographySourceType'?: GeographySourceType;
    'isGeographyMatchingManufacturing'?: boolean;
    'locationType'?: EmissionValuesLocationLocationTypeEnum;
    'manufacturingLocation'?: ManufacturingLocation;
    'region'?: EmissionValuesLocationRegionEnum;
}

export const EmissionValuesLocationCountryEnum = {
    AFG: 'AFG',
    AGO: 'AGO',
    ALB: 'ALB',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BOL: 'BOL',
    BRA: 'BRA',
    BRN: 'BRN',
    BTN: 'BTN',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COL: 'COL',
    CRI: 'CRI',
    CUB: 'CUB',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GHA: 'GHA',
    GIN: 'GIN',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRL: 'GRL',
    GTM: 'GTM',
    GUY: 'GUY',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IND: 'IND',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KOR: 'KOR',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAR: 'MAR',
    MDA: 'MDA',
    MDG: 'MDG',
    MEX: 'MEX',
    MKD: 'MKD',
    MLI: 'MLI',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MWI: 'MWI',
    MYS: 'MYS',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NGA: 'NGA',
    NIC: 'NIC',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PER: 'PER',
    PHL: 'PHL',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    ESH: 'ESH',
    SAU: 'SAU',
    SDN: 'SDN',
    SSD: 'SSD',
    SEN: 'SEN',
    SGP: 'SGP',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SOM: 'SOM',
    SRB: 'SRB',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SYR: 'SYR',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKM: 'TKM',
    TLS: 'TLS',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VEN: 'VEN',
    VNM: 'VNM',
    VUT: 'VUT',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type EmissionValuesLocationCountryEnum = typeof EmissionValuesLocationCountryEnum[keyof typeof EmissionValuesLocationCountryEnum];
export const EmissionValuesLocationLocationTypeEnum = {
    GLOBAL: 'GLOBAL',
    REGIONAL: 'REGIONAL',
    COUNTRY: 'COUNTRY',
    SITE: 'SITE'
} as const;

export type EmissionValuesLocationLocationTypeEnum = typeof EmissionValuesLocationLocationTypeEnum[keyof typeof EmissionValuesLocationLocationTypeEnum];
export const EmissionValuesLocationRegionEnum = {
    AFRICA: 'AFRICA',
    ANTARCTICA: 'ANTARCTICA',
    ASIA: 'ASIA',
    EUROPE: 'EUROPE',
    NORTH_AMERICA: 'NORTH_AMERICA',
    OCEANIA: 'OCEANIA',
    SOUTH_AMERICA: 'SOUTH_AMERICA'
} as const;

export type EmissionValuesLocationRegionEnum = typeof EmissionValuesLocationRegionEnum[keyof typeof EmissionValuesLocationRegionEnum];

export interface EmissionsAttachment {
    'id': string;
    'name': string;
}
export interface EmissionsDataRequestResponse {
    'customer': Customer;
    'productIds': ReadonlyArray<string>;
    'reference': string;
    'supplier': OrganizationResponse;
}
export interface EmissionsValuesBreakdown {
    'dataUsed'?: EmissionValueDataUsed;
    'distributionAndStorage': ReadonlyArray<EmissionValueItem>;
    'endOfLife': ReadonlyArray<EmissionValueItem>;
    'materialAcquisitionAndPreprocessing': ReadonlyArray<EmissionValueItem>;
    'productUse': ReadonlyArray<EmissionValueItem>;
    'production': ReadonlyArray<EmissionValueItem>;
    'unit'?: EmissionValueUnit;
    'unitOther'?: string;
    'upstreamTransportation': ReadonlyArray<EmissionValueItem>;
    'value'?: number;
    'valueExcludingBiogenicCarbon'?: number;
}


export interface FederateCorporateDataRequest {
    'comments'?: string;
    'customerId': string;
    'reference': string;
    'reportingYear': number;
    'supplierId': string;
    'userId': string;
}
export interface FederateCorporateDataResponse {
    'answeredAllocationData'?: CorporateAllocationData;
    'answeredCorporateData': CorporateYearData;
    'customerId': string;
    'reference': string;
    'supplierId': string;
    'userId': string;
}
export interface FederateCorporateDataStatusUpdate {
    'customerId': string;
    'reason'?: string;
    'reference': string;
    'status': DataRequestStatus;
    'supplierId': string;
    'userId': string;
}


export interface FederateEmissionDataRequest {
    'customerId': string;
    'emissionData': EmissionRequestProductFormData;
    'formData'?: { [key: string]: any; };
    'productId': string;
    'reference': string;
    'supplierId': string;
    'transientData'?: EmissionRequestTransientData;
    'userId': string;
}
export interface FederateEmissionRequest {
    'customerId': string;
    'initialProductStatus': DataRequestStatus;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'products': ReadonlyArray<FederationEmissionProduct>;
    'recipient': FederateEmissionRequestRecipientEnum;
    'reference': string;
    'supplierId': string;
    'userId'?: string;
}

export const FederateEmissionRequestRecipientEnum = {
    SUPPLIER: 'SUPPLIER',
    CUSTOMER: 'CUSTOMER'
} as const;

export type FederateEmissionRequestRecipientEnum = typeof FederateEmissionRequestRecipientEnum[keyof typeof FederateEmissionRequestRecipientEnum];

export interface FederateEmissionStatusUpdateRequest {
    'customerId': string;
    'formData'?: { [key: string]: any; };
    'productId': string;
    'productStatus': DataRequestStatus;
    'reason': string;
    'reference': string;
    'supplierId': string;
    'transientData'?: EmissionRequestTransientData;
    'userId': string;
}


export interface FederatedInvitationStatusUpdatedRequest {
    'accessManagementToken': string;
    'customerId': string;
}
export interface FederationEmissionProduct {
    'answeredUnit'?: EmissionValueAnsweredUnit;
    'defaultFormData'?: { [key: string]: any; };
    'formData'?: { [key: string]: any; };
    'formSchema'?: { [key: string]: any; };
    'formTemplateVersionId'?: string;
    'isPactCompliant': boolean;
    'productDescription'?: string;
    'productId': string;
    'productInternalReference'?: string;
    'productName': string;
    'productRequestComment'?: string;
    'productUnit': EmissionValueUnit;
    'purchasingPeriodEnd'?: string;
    'purchasingPeriodStart'?: string;
    'source': FederationEmissionProductSourceEnum;
}

export const FederationEmissionProductSourceEnum = {
    ECOSYSTEM: 'Ecosystem',
    PACT: 'Pact',
    CATENA_X: 'CatenaX'
} as const;

export type FederationEmissionProductSourceEnum = typeof FederationEmissionProductSourceEnum[keyof typeof FederationEmissionProductSourceEnum];

export interface FlattenedEmissionRequestListMetadata {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface FlattenedEmissionRequestListResponse {
    'data': ReadonlyArray<FlattenedEmissionRequestResponse>;
    'metadata': FlattenedEmissionRequestListMetadata;
}
export interface FlattenedEmissionRequestResponse {
    'answeredUnit'?: EmissionValueAnsweredUnit;
    'createdAt'?: string;
    'customerId'?: string;
    'customerName': string;
    'emissionRequestId': string;
    'emissionValue'?: number;
    'id': string;
    'organisationId': string;
    'pactDqrScore'?: number;
    'productId': string;
    'productInternalReference'?: string;
    'productName': string;
    'productRequestStatus'?: DataRequestStatus;
    'productUnit': EmissionValueUnit;
    'purchasingPeriodEnd'?: string;
    'purchasingPeriodStart'?: string;
    'requestReference': string;
    'sanityChecksScore'?: number;
    'source': FlattenedEmissionRequestResponseSourceEnum;
    'supplierId': string;
    'templateId'?: string;
    'updatedAt'?: string;
}

export const FlattenedEmissionRequestResponseSourceEnum = {
    ECOSYSTEM: 'Ecosystem',
    PACT: 'Pact',
    CATENA_X: 'CatenaX'
} as const;

export type FlattenedEmissionRequestResponseSourceEnum = typeof FlattenedEmissionRequestResponseSourceEnum[keyof typeof FlattenedEmissionRequestResponseSourceEnum];

export interface FootprintListResponse {
    'data': ReadonlyArray<ProductFootprint>;
    'metadata': ProductListMetadataResponse;
}
export interface FootprintListResponseV2 {
    'data': ReadonlyArray<ProductFootprintV2>;
    'metadata': ProductListMetadataResponse;
}
export interface FormTemplateResponse {
    'createdAt': string;
    'description'?: string;
    'id': string;
    'isDefault': boolean;
    'isPublic': boolean;
    'name': string;
    'updatedAt': string;
}
export interface FormTemplateVersionResponse {
    'createdAt': string;
    'formSchema': { [key: string]: any; };
    'id': string;
    'isActive': boolean;
    'isPactCompliant': boolean;
    'templateId': string;
    'updatedAt': string;
    'versionNumber': number;
}
export interface FullAssistantMessage {
    'content': ReadonlyArray<{ [key: string]: any; }>;
    'role': string;
    'id'?: string;
    'model'?: string;
    'stop_reason'?: string;
    'type'?: string;
    'usage'?: { [key: string]: any; };
}

export const GHGScope = {
    _1_0: '1.0',
    _2_0: '2.0',
    _3_0: '3.0',
    _3_1: '3.1',
    _3_2: '3.2',
    _3_3: '3.3',
    _3_4: '3.4',
    _3_5: '3.5',
    _3_6: '3.6',
    _3_7: '3.7',
    _3_8: '3.8',
    _3_9: '3.9',
    _3_10: '3.10',
    _3_11: '3.11',
    _3_12: '3.12',
    _3_13: '3.13',
    _3_14: '3.14',
    _3_15: '3.15'
} as const;

export type GHGScope = typeof GHGScope[keyof typeof GHGScope];



export const GeographySourceType = {
    UNIQUE_SITE: 'UNIQUE_SITE',
    MULTI_SITES: 'MULTI_SITES',
    OTHER_OR_UNKNOWN: 'OTHER_OR_UNKNOWN'
} as const;

export type GeographySourceType = typeof GeographySourceType[keyof typeof GeographySourceType];


export interface GetFootprintResponse {
    'data': ProductFootprint;
}
export interface GetFootprintResponseV2 {
    'data': ProductFootprintV2;
}
/**
 * @type GetOpenIdConfiguration400Response
 */
export type GetOpenIdConfiguration400Response = { [key: string]: any; } | { [key: string]: string; };


export const InitiativeLevel = {
    CORPORATE: 'corporate',
    PRODUCT: 'product'
} as const;

export type InitiativeLevel = typeof InitiativeLevel[keyof typeof InitiativeLevel];


export interface InvitationInfoResponse {
    'alreadyRegistered': boolean;
    'recipientEmail': string;
}
export interface LegacyInvitedSupplierMigrationResult {
    'organisationFailures': number;
    'organisationsScanned': number;
    'rowFailures': number;
    'rowsAlreadyOnResolvedId': number;
    'rowsResolved': number;
    'rowsScanned': number;
}

export const LifecycleStage = {
    MATERIAL_ACQUISITION: 'MATERIAL_ACQUISITION',
    PRE_PROCESSING_PROCESSING: 'PRE_PROCESSING_PROCESSING',
    MINING_AND_EXTRACTION: 'MINING_AND_EXTRACTION',
    PHOTO_SYNTHESIS: 'PHOTO_SYNTHESIS',
    FERTILIZER: 'FERTILIZER',
    ENERGY: 'ENERGY',
    FUEL: 'FUEL',
    OPERATION_OF_PREMISES: 'OPERATION_OF_PREMISES',
    WASTE: 'WASTE',
    TRANSPORTATION_TO_PRODUCTION: 'TRANSPORTATION_TO_PRODUCTION',
    PHYSICAL_OR_CHEMICAL_PROCESSING: 'PHYSICAL_OR_CHEMICAL_PROCESSING',
    MANUFACTURING: 'MANUFACTURING',
    TRANSPORTATION_OF_SEMI_FINISHED: 'TRANSPORTATION_OF_SEMI_FINISHED',
    ASSEMBLY: 'ASSEMBLY',
    RECEIPT: 'RECEIPT',
    PUT_AWAY: 'PUT_AWAY',
    HEATING: 'HEATING',
    REFRIGERATION: 'REFRIGERATION',
    DISTRIBUTION: 'DISTRIBUTION',
    PACKAGING: 'PACKAGING',
    STORAGE: 'STORAGE',
    SHIPPING_TRANSPORTATION: 'SHIPPING_TRANSPORTATION',
    TRANSPORTATION_BETWEEN_STORAGE: 'TRANSPORTATION_BETWEEN_STORAGE',
    CONSUMER_USE: 'CONSUMER_USE',
    TRANSPORTATION_TO_USE_LOCATION: 'TRANSPORTATION_TO_USE_LOCATION',
    REFRIGERATION_AT_USE_LOCATION: 'REFRIGERATION_AT_USE_LOCATION',
    PREPARATION_FOR_USE: 'PREPARATION_FOR_USE',
    REPAIR_AND_MAINTENANCE: 'REPAIR_AND_MAINTENANCE',
    END_OF_LIFE_FINAL_DISPOSAL: 'END_OF_LIFE_FINAL_DISPOSAL',
    END_OF_LIFE_COLLECTION_AND_TRANSPORT: 'END_OF_LIFE_COLLECTION_AND_TRANSPORT',
    RECYCLING: 'RECYCLING',
    DISMANTLING: 'DISMANTLING',
    SHREDDING_AND_SORTING: 'SHREDDING_AND_SORTING',
    INCINERATION_AND_SORTING: 'INCINERATION_AND_SORTING',
    LAND_FILLING: 'LAND_FILLING',
    PRODUCTION: 'PRODUCTION',
    TRANSPORTATION: 'TRANSPORTATION',
    ENERGY_FUEL: 'ENERGY_FUEL'
} as const;

export type LifecycleStage = typeof LifecycleStage[keyof typeof LifecycleStage];


export interface LinkAccountResponse {
    'linked': boolean;
}
export interface LockInfo {
    'userId': string;
    'userName': string;
}
/**
 * @type LoginUserPact200Response
 */
export type LoginUserPact200Response = LoginUserResponse | PactTokenResponse;

export interface LoginUserRequest {
    'email': string;
    'password': string;
}
export interface LoginUserResponse {
    'access_token': string;
    'expires_in': number;
    'id_token': string;
    'refresh_token': string;
    'scope': string;
    'token_type': string;
}
export interface ManufacturingLocation {
    'country'?: ManufacturingLocationCountryEnum;
    'locationType': ManufacturingLocationLocationTypeEnum;
    'region'?: ManufacturingLocationRegionEnum;
}

export const ManufacturingLocationCountryEnum = {
    AFG: 'AFG',
    AGO: 'AGO',
    ALB: 'ALB',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BOL: 'BOL',
    BRA: 'BRA',
    BRN: 'BRN',
    BTN: 'BTN',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COL: 'COL',
    CRI: 'CRI',
    CUB: 'CUB',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GHA: 'GHA',
    GIN: 'GIN',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRL: 'GRL',
    GTM: 'GTM',
    GUY: 'GUY',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IND: 'IND',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KOR: 'KOR',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAR: 'MAR',
    MDA: 'MDA',
    MDG: 'MDG',
    MEX: 'MEX',
    MKD: 'MKD',
    MLI: 'MLI',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MWI: 'MWI',
    MYS: 'MYS',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NGA: 'NGA',
    NIC: 'NIC',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PER: 'PER',
    PHL: 'PHL',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    ESH: 'ESH',
    SAU: 'SAU',
    SDN: 'SDN',
    SSD: 'SSD',
    SEN: 'SEN',
    SGP: 'SGP',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SOM: 'SOM',
    SRB: 'SRB',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SYR: 'SYR',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKM: 'TKM',
    TLS: 'TLS',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VEN: 'VEN',
    VNM: 'VNM',
    VUT: 'VUT',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type ManufacturingLocationCountryEnum = typeof ManufacturingLocationCountryEnum[keyof typeof ManufacturingLocationCountryEnum];
export const ManufacturingLocationLocationTypeEnum = {
    REGIONAL: 'REGIONAL',
    COUNTRY: 'COUNTRY',
    UNKNOWN: 'UNKNOWN'
} as const;

export type ManufacturingLocationLocationTypeEnum = typeof ManufacturingLocationLocationTypeEnum[keyof typeof ManufacturingLocationLocationTypeEnum];
export const ManufacturingLocationRegionEnum = {
    AFRICA: 'AFRICA',
    ANTARCTICA: 'ANTARCTICA',
    ASIA: 'ASIA',
    EUROPE: 'EUROPE',
    NORTH_AMERICA: 'NORTH_AMERICA',
    OCEANIA: 'OCEANIA',
    SOUTH_AMERICA: 'SOUTH_AMERICA'
} as const;

export type ManufacturingLocationRegionEnum = typeof ManufacturingLocationRegionEnum[keyof typeof ManufacturingLocationRegionEnum];

export interface Message {
    'content': any;
    'role': string;
}
export interface Methodologies {
    'collectionEndDate'?: string;
    'collectionStartDate'?: string;
    'impactAssessmentMethod'?: ReadonlyArray<MethodologiesImpactAssessmentMethodEnum>;
    'methodologyStandards'?: MethodologyStandards;
    'otherImpactAssessmentName'?: string;
    'validityEndDate'?: string;
    'validityStartDate'?: string;
}

export const MethodologiesImpactAssessmentMethodEnum = {
    EF_3_0: 'EF_3_0',
    EF_V3_1: 'EF_V3_1',
    RECIPE_2016: 'RECIPE_2016',
    CML_IA_BASELINE: 'CML_IA_BASELINE',
    EN_15804_A2: 'EN_15804_A2',
    ILCD_2011: 'ILCD_2011',
    TRACI_2_2: 'TRACI_2_2',
    IMPACT_WORLD: 'IMPACT_WORLD',
    IPCC_2007_GWP_100: 'IPCC_2007_GWP_100',
    IPCC_2013_GWP_100: 'IPCC_2013_GWP_100',
    IPCC_2021_GWP_100: 'IPCC_2021_GWP_100',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
} as const;

export type MethodologiesImpactAssessmentMethodEnum = typeof MethodologiesImpactAssessmentMethodEnum[keyof typeof MethodologiesImpactAssessmentMethodEnum];

export interface MethodologyStandards {
    'additionalInformation'?: string;
    'standardCompliant'?: MethodologyStandardsStandardCompliantEnum;
    'standardUsed'?: ReadonlyArray<Standard>;
}

export const MethodologyStandardsStandardCompliantEnum = {
    YES: 'YES',
    NO: 'NO',
    UNKNOWN: 'UNKNOWN'
} as const;

export type MethodologyStandardsStandardCompliantEnum = typeof MethodologyStandardsStandardCompliantEnum[keyof typeof MethodologyStandardsStandardCompliantEnum];

export interface MigrateLegacyInvitedSuppliersRequest {
    'organisationIds': ReadonlyArray<string>;
}
export interface Organization {
    'co2AiCorpoUrl': string;
    'customerCount': number;
    'customers': ReadonlyArray<string>;
    'dataFederationUrl': string;
    'featureFlags'?: OrganizationFeatureFlags;
    'id': string;
    'name': string;
    'senderNameForSuppliers'?: string;
    'suppliers': ReadonlyArray<string>;
}
export interface OrganizationFeatureFlags {
    'hasAdvancedQuestions'?: boolean;
    'hasCorporateRequestsEnabled'?: boolean;
}
export interface OrganizationInvitationReceivedListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface OrganizationInvitationReceivedListResponse {
    'data': ReadonlyArray<OrganizationInvitationReceivedResponse>;
    'metadata': OrganizationInvitationReceivedListMetadataResponse;
}
export interface OrganizationInvitationReceivedResponse {
    'createdAt': string;
    'invitationId': string;
    'senderEmail'?: string;
    'senderOrganisationName': string;
}
export interface OrganizationInvitationSentListMetadataResponse {
    'acceptedCount': number;
    'count': number;
    'declinedCount': number;
    'pageNumber': number;
    'pageSize': number;
    'pendingCount': number;
}
export interface OrganizationInvitationSentListResponse {
    'data': ReadonlyArray<OrganizationInvitationSentResponse>;
    'metadata': OrganizationInvitationSentListMetadataResponse;
}
export interface OrganizationInvitationSentResponse {
    'accessResponseStatus': OrganizationInvitationSentResponseAccessResponseStatusEnum;
    'createdAt': string;
    'id'?: string;
    'recipientEmail': string;
    'recipientOrganisationId'?: string;
}

export const OrganizationInvitationSentResponseAccessResponseStatusEnum = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    PENDING: 'PENDING'
} as const;

export type OrganizationInvitationSentResponseAccessResponseStatusEnum = typeof OrganizationInvitationSentResponseAccessResponseStatusEnum[keyof typeof OrganizationInvitationSentResponseAccessResponseStatusEnum];

export interface OrganizationLookupResponse {
    'organisationId'?: string;
    'status': OrganizationLookupResponseStatusEnum;
}

export const OrganizationLookupResponseStatusEnum = {
    EXISTS: 'EXISTS',
    GHOST: 'GHOST',
    NOT_FOUND: 'NOT_FOUND'
} as const;

export type OrganizationLookupResponseStatusEnum = typeof OrganizationLookupResponseStatusEnum[keyof typeof OrganizationLookupResponseStatusEnum];

export interface OrganizationResolveResponse {
    'organisationId': string;
}
export interface OrganizationResponse {
    'id': string;
    'name': string;
}
export interface OrganizationsMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface OrganizationsResponse {
    'data': ReadonlyArray<OrganizationResponse>;
    'metadata': OrganizationsMetadataResponse;
}
export interface PactConnectorRequest {
    'autoSyncFootprintIds'?: ReadonlyArray<string>;
    'outboundAuthUrl'?: string;
    'outboundClientId'?: string;
    'outboundClientSecret'?: string;
    'outboundFootprintsUrl'?: string;
    'outboundIsActive'?: boolean;
}
export interface PactConnectorResponse {
    'autoSyncFootprintIds': ReadonlyArray<string>;
    'connectorId': string;
    'hasOutboundConfig': boolean;
    'outboundAuthUrl'?: string;
    'outboundClientId'?: string;
    'outboundFootprintsUrl'?: string;
    'outboundIsActive': boolean;
    'outboundLastSyncedAt'?: string;
}
export interface PactCredentialCreatedResponse {
    'clientId': string;
    'clientSecret': string;
    'createdAt': string;
    'description'?: string;
    'id': string;
}
export interface PactCredentialResponse {
    'clientId': string;
    'createdAt': string;
    'description'?: string;
    'id': string;
}
export interface PactDataModelExtension {
    'data': any;
    'dataSchema': string;
    'specVersion': string;
}
export interface PactFootprintPreviewResponse {
    'declaredUnit'?: string;
    'id': string;
    'pcfExcludingBiogenic'?: string;
    'productDescription'?: string;
    'productName': string;
    'referencePeriodEnd'?: string;
    'referencePeriodStart'?: string;
}
export interface PactOutboundCredentialRequest {
    'authEndpoint'?: string;
    'clientId': string;
    'clientSecret': string;
    'name'?: string;
    'pactEndpoint': string;
}
export interface PactOutboundCredentialResponse {
    'authEndpoint'?: string;
    'clientId': string;
    'createdAt': string;
    'id': string;
    'name'?: string;
    'pactEndpoint': string;
}
export interface PactReceivedShareCredentialRequest {
    'description'?: string;
}
export interface PactTokenResponse {
    'access_token': string;
    'expires_in': number;
    'token_type': string;
}
export interface PcfPrefillRequest {
    'attachmentIds'?: ReadonlyArray<string>;
}
export interface PrefillCorporateDataRequest {
    'attachmentIds': ReadonlyArray<string>;
    'year': number;
}
export interface ProductCreateRequest {
    'description'?: string;
    'internalReference': string;
    'name': string;
    'purchasingPeriodEnd'?: string;
    'purchasingPeriodStart'?: string;
    'requestComment'?: string;
    'supplierLinks': ReadonlyArray<string>;
    'unit': EmissionValueUnit;
}


export interface ProductDataRequestResponse {
    'emissionDataRequest'?: EmissionDataRequest;
    'product': ProductResponse;
    'supplierInformation'?: SupplierInformation;
}
export interface ProductEmissionDataRequestDetailsResponse {
    'editLock'?: LockInfo;
    'emissionData'?: EmissionRequestProductFormData;
    'emissionDraftData'?: DraftEmissionRequestFormData;
    'featureFlags'?: EmissionRequestProductFeatureFlags;
    'formData'?: { [key: string]: any; };
    'formDataPrefillMetadata'?: { [key: string]: any; };
    'formSchema'?: { [key: string]: any; };
    'isPactCompliant': boolean;
    'pactDqrScore'?: number;
    'productInformation': ProductResponse;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'sanityChecksScore'?: number;
    'supplierInformation': OrganizationResponse;
    'updatedAt'?: string;
}


export interface ProductEmissionDataRequestListResponse {
    'data': ReadonlyArray<ProductDataRequestResponse>;
    'metadata': ProductListMetadataResponse;
}
export interface ProductFootprint {
    'comment': string;
    'companyIds': Set<string>;
    'companyName': string;
    'created': string;
    'extensions'?: ReadonlyArray<PactDataModelExtension>;
    'id': string;
    'pcf': CarbonFootprint;
    'precedingPfIds'?: ReadonlyArray<string>;
    'productClassifications'?: ReadonlyArray<string>;
    'productDescription': string;
    'productIds': Set<string>;
    'productNameCompany': string;
    'specVersion': string;
    'status': ProductFootprintStatusEnum;
    'validityPeriodEnd'?: string;
    'validityPeriodStart'?: string;
}

export const ProductFootprintStatusEnum = {
    ACTIVE: 'Active',
    DEPRECATED: 'Deprecated'
} as const;

export type ProductFootprintStatusEnum = typeof ProductFootprintStatusEnum[keyof typeof ProductFootprintStatusEnum];

export interface ProductFootprintV2 {
    'comment': string;
    'companyIds': Set<string>;
    'companyName': string;
    'created': string;
    'extensions'?: any;
    'id': string;
    'pcf': CarbonFootprintV2;
    'precedingPfIds'?: ReadonlyArray<string>;
    'productCategoryCpc': string;
    'productDescription': string;
    'productIds': Set<string>;
    'productNameCompany': string;
    'specVersion': string;
    'status': ProductFootprintV2StatusEnum;
    'statusComment'?: string;
    'updated': string;
    'validityPeriodEnd'?: string;
    'validityPeriodStart'?: string;
    'version': number;
}

export const ProductFootprintV2StatusEnum = {
    ACTIVE: 'Active',
    DEPRECATED: 'Deprecated'
} as const;

export type ProductFootprintV2StatusEnum = typeof ProductFootprintV2StatusEnum[keyof typeof ProductFootprintV2StatusEnum];

export interface ProductImportResponse {
    'addedProducts': ReadonlyArray<SupplierProductIdPair>;
    'violations': ReadonlyArray<ProductImportViolation>;
}
export interface ProductImportViolation {
    'isError': boolean;
    'lineNumber': number;
    'reference': string;
    'violationType': ProductImportViolationViolationTypeEnum;
}

export const ProductImportViolationViolationTypeEnum = {
    DUPLICATED_REFERENCE_IN_FILE: 'DUPLICATED_REFERENCE_IN_FILE',
    DUPLICATED_REFERENCE_IN_SYSTEM: 'DUPLICATED_REFERENCE_IN_SYSTEM',
    INVALID_FILE_FORMAT: 'INVALID_FILE_FORMAT',
    INVALID_HEADER: 'INVALID_HEADER',
    INVALID_VALUE: 'INVALID_VALUE',
    INVALID_NUMBER_OF_CELLS: 'INVALID_NUMBER_OF_CELLS',
    MISSING_PRODUCT_NAME: 'MISSING_PRODUCT_NAME',
    MISSING_PRODUCT_REFERENCE_NUMBER: 'MISSING_PRODUCT_REFERENCE_NUMBER',
    ORGANISATION_OR_EMAIL_NOT_FOUND: 'ORGANISATION_OR_EMAIL_NOT_FOUND'
} as const;

export type ProductImportViolationViolationTypeEnum = typeof ProductImportViolationViolationTypeEnum[keyof typeof ProductImportViolationViolationTypeEnum];


export const ProductLifecycleCategory = {
    MATERIAL_ACQUISITION_AND_PREPROCESSING: 'materialAcquisitionAndPreprocessing',
    PRODUCTION: 'production',
    DISTRIBUTION_AND_STORAGE: 'distributionAndStorage'
} as const;

export type ProductLifecycleCategory = typeof ProductLifecycleCategory[keyof typeof ProductLifecycleCategory];


export interface ProductListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
/**
 * Product or service category, corresponding to PACT product categories.
 */

export const ProductOrServiceCategory = {
    DEFAULT: 'DEFAULT',
    TRANSPORTATION: 'TRANSPORTATION'
} as const;

export type ProductOrServiceCategory = typeof ProductOrServiceCategory[keyof typeof ProductOrServiceCategory];


export interface ProductRequestOverview {
    'completed': number;
    'declined': number;
    'notStarted': number;
    'pendingReview': number;
    'rejected': number;
    'requested': number;
}
export interface ProductResponse {
    'description'?: string;
    'id': string;
    'internalReference'?: string;
    'name': string;
    'productRequestStatus': DataRequestStatus;
    'purchasingPeriodEnd'?: string;
    'purchasingPeriodStart'?: string;
    'reason': string;
    'requestComment'?: string;
    'unit': EmissionValueUnit;
}


export interface ProductSupplierId {
    'defaultFormData'?: { [key: string]: any; };
    'productId': string;
    'requestComment'?: string;
    'supplierBpnl'?: string;
    'supplierId': string;
    'supplierManufacturerPartId'?: string;
}
export interface ProductsDeleteRequest {
    'productIds': ReadonlyArray<string>;
}

export const QuantityUnit = {
    G: 'G',
    KG: 'KG',
    OZ: 'OZ',
    LB: 'LB',
    ML: 'ML',
    L: 'L',
    M3: 'M3',
    FT3: 'FT3'
} as const;

export type QuantityUnit = typeof QuantityUnit[keyof typeof QuantityUnit];


export interface ReductionInitiative {
    'aiMetadata'?: AnswerMetadata;
    'description'?: string;
    'endYear'?: number;
    'estimatedEmissionsReductionKg'?: number;
    'estimatedEmissionsReductionPercentage'?: number;
    'initiativeLevel': InitiativeLevel;
    'lifecycleStagesImpacted'?: ReadonlyArray<ProductLifecycleCategory>;
    'name'?: string;
    'scopesImpacted'?: ReadonlyArray<GHGScope>;
    'startYear'?: number;
    'status'?: ReductionInitiativeStatus;
}



export const ReductionInitiativeStatus = {
    PLANNED: 'PLANNED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
} as const;

export type ReductionInitiativeStatus = typeof ReductionInitiativeStatus[keyof typeof ReductionInitiativeStatus];


export interface ReductionPlan {
    'hasAlternativeWithLowerCarbon'?: boolean;
    'hasAlternativeWithLowerCarbonComments'?: string;
    'hasReductionPlan'?: boolean;
    'reductionPlanComments'?: string;
}
export interface RefreshTokenRequest {
    'refreshToken': string;
}
/**
 * @type ReportingUnit
 * Per-item factor: weight or volume of one item.
 */
export type ReportingUnit = { type: 'VOLUME' } & Volume | { type: 'WEIGHT' } & Weight;

export interface ResendCorporateDataRequestsRequest {
    'emailsPerCorporateDataRequestReference': { [key: string]: ReadonlyArray<string>; };
}
export interface ResendEmissionRequestsRequest {
    'emailsPerProductId': { [key: string]: ReadonlyArray<string>; };
    'message'?: string;
}
export interface ResolveConnectedOrganizationRequest {
    'connectedOrgBpnl'?: string;
    'connectedOrgEmail'?: string;
    'connectedOrgName': string;
}

export const Scope12ScopesComputed = {
    SCOPE1: 'scope1',
    SCOPE2: 'scope2',
    BOTH: 'both',
    NONE: 'none'
} as const;

export type Scope12ScopesComputed = typeof Scope12ScopesComputed[keyof typeof Scope12ScopesComputed];



export const ScopePlanToMeasure = {
    LESS_THAN1_YEAR: 'lessThan1Year',
    MORE_THAN1_YEAR: 'moreThan1Year',
    NO_PLANS: 'noPlans'
} as const;

export type ScopePlanToMeasure = typeof ScopePlanToMeasure[keyof typeof ScopePlanToMeasure];


export interface SecondaryDataSourceDetail {
    'sourceDescription'?: SecondaryDataSourceDetailSourceDescriptionEnum;
    'sourceDescriptionOther'?: string;
    'sourceVersion'?: string;
}

export const SecondaryDataSourceDetailSourceDescriptionEnum = {
    SELF: 'SELF',
    SUPPLIER: 'SUPPLIER',
    EPA_GHG_EMISSION_FACTORS_HUB: 'EPA_GHG_EMISSION_FACTORS_HUB',
    DEFRA_CONVERSION_FACTORS: 'DEFRA_CONVERSION_FACTORS',
    ADEME_BASE_CARBONE: 'ADEME_BASE_CARBONE',
    IPCC_EMISSION_FACTORS_DATABASE: 'IPCC_EMISSION_FACTORS_DATABASE',
    ECOMETRICA: 'ECOMETRICA',
    IDEMAT: 'IDEMAT',
    ECOINVENT: 'ECOINVENT',
    AGRIFOOTPRINT: 'AGRIFOOTPRINT',
    GABI: 'GABI',
    PRODUCT_ECOSYSTEM_CALCULATOR: 'PRODUCT_ECOSYSTEM_CALCULATOR',
    AGRIBALYSE: 'AGRIBALYSE',
    GLEC: 'GLEC',
    OTHER: 'OTHER'
} as const;

export type SecondaryDataSourceDetailSourceDescriptionEnum = typeof SecondaryDataSourceDetailSourceDescriptionEnum[keyof typeof SecondaryDataSourceDetailSourceDescriptionEnum];

export interface SendInvitationsAgainRequest {
    'invitedSupplierIds': ReadonlyArray<string>;
}
export interface SseEmitter {
    'timeout'?: number;
}

export const Standard = {
    ISO_3459: 'ISO_3459',
    ISO_14040: 'ISO_14040',
    ISO_14044: 'ISO_14044',
    ISO_14067: 'ISO_14067',
    ISO_14083: 'ISO_14083',
    PAS_2050: 'PAS_2050',
    PAS_2090: 'PAS_2090',
    CATENA_X: 'CATENA_X',
    PRODUCT_ENVIRONMENTAL_FOOTPRINT: 'PRODUCT_ENVIRONMENTAL_FOOTPRINT',
    BP_X30_323_0: 'BP_X30_323_0',
    EN_15804: 'EN_15804',
    EPD_PRODUCT_CATEGORY_RULES: 'EPD_PRODUCT_CATEGORY_RULES',
    CALCULATOR: 'CALCULATOR',
    TFS: 'TFS',
    PACT_2_0: 'PACT_2_0',
    PACT_3_0: 'PACT_3_0',
    OTHER: 'OTHER'
} as const;

export type Standard = typeof Standard[keyof typeof Standard];


export interface SupplierCorporateRequest {
    'comments'?: string;
    'reportingYear': number;
    'supplierId': string;
}
export interface SupplierEmissionRequestProductResponse {
    'data': ReadonlyArray<SupplierProductResponse>;
}
export interface SupplierInformation {
    'id': string;
    'name': string;
}
export interface SupplierProductIdPair {
    'id': string;
    'productName': string;
    'supplierId': string;
}
export interface SupplierProductResponse {
    'emissionFactor'?: number;
    'emissionRequestReference': string;
    'emissionValuesLocation'?: EmissionValuesLocation;
    'internalReference'?: string;
    'lastUpdated': string;
    'name': string;
    'productId': string;
}
export interface SupplierResponse {
    'id': string;
    'metadata': SupplierResponseMetadata;
    'name': string;
}
export interface SupplierResponseMetadata {
    'totalNumberOfProducts': number;
}
export interface SuppliersMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface SuppliersResponse {
    'data': ReadonlyArray<SupplierResponse>;
    'metadata': SuppliersMetadataResponse;
}
export interface TemplateCreateRequest {
    'description'?: string;
    'emissionData'?: DraftEmissionRequestFormData;
    'formData'?: { [key: string]: any; };
    'formTemplateId'?: string;
    'internalReference'?: string;
    'manufacturerPartId'?: string;
    'name': string;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'unit': EmissionValueAnsweredUnit;
}


export interface TemplateDetailsResponse {
    'createdAt'?: string;
    'description'?: string;
    'emissionData'?: DraftEmissionRequestFormData;
    'featureFlags'?: EmissionRequestProductFeatureFlags;
    'formData'?: { [key: string]: any; };
    'formSchema'?: { [key: string]: any; };
    'formTemplateVersionId'?: string;
    'id': string;
    'internalReference'?: string;
    'isPactCompliant'?: boolean;
    'lastUpdated'?: string;
    'manufacturerPartId'?: string;
    'name': string;
    'pactDqrScore'?: number;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'sanityChecksScore'?: number;
    'totalEmissionsValue'?: number;
    'unit': EmissionValueAnsweredUnit;
}


export interface TemplateImportResponse {
    'addedTemplates': ReadonlyArray<TemplateDetailsResponse>;
    'violations': ReadonlyArray<TemplateImportViolation>;
}
export interface TemplateImportViolation {
    'isError': boolean;
    'lineNumber': number;
    'reference': string;
    'violationType': TemplateImportViolationViolationTypeEnum;
}

export const TemplateImportViolationViolationTypeEnum = {
    INVALID_FILE_FORMAT: 'INVALID_FILE_FORMAT',
    INVALID_HEADER: 'INVALID_HEADER',
    INVALID_VALUE: 'INVALID_VALUE',
    MISSING_PRODUCT_NAME: 'MISSING_PRODUCT_NAME',
    MISSING_PRODUCT_REFERENCE_NUMBER: 'MISSING_PRODUCT_REFERENCE_NUMBER',
    INVALID_JSON_FORMAT: 'INVALID_JSON_FORMAT',
    INVALID_PACT_FORMAT: 'INVALID_PACT_FORMAT',
    DUPLICATED_REFERENCE_IN_FILE: 'DUPLICATED_REFERENCE_IN_FILE',
    DUPLICATED_REFERENCE_IN_SYSTEM: 'DUPLICATED_REFERENCE_IN_SYSTEM'
} as const;

export type TemplateImportViolationViolationTypeEnum = typeof TemplateImportViolationViolationTypeEnum[keyof typeof TemplateImportViolationViolationTypeEnum];

export interface TemplateListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
    'totalEmissionsValueOfAllTemplates': number;
}
export interface TemplateListResponse {
    'data': ReadonlyArray<TemplateResponse>;
    'metadata': TemplateListMetadataResponse;
}
export interface TemplatePrefillResponse {
    'formData'?: { [key: string]: any; };
    'reason'?: string;
    'translatable': boolean;
}
export interface TemplateResponse {
    'createdAt'?: string;
    'description'?: string;
    'emissionValuesLocation'?: DraftEmissionValuesLocation;
    'formTemplateName'?: string;
    'hasFormSchema': boolean;
    'id': string;
    'internalReference'?: string;
    'isPactCompliant'?: boolean;
    'lastUpdated'?: string;
    'manufacturerPartId'?: string;
    'name': string;
    'pactDqrScore'?: number;
    'productOrServiceCategory'?: ProductOrServiceCategory;
    'sanityChecksScore'?: number;
    'totalEmissionsValue'?: number;
    'unit': EmissionValueAnsweredUnit;
}


export interface TestOutboundRequest {
    'authUrl': string;
    'clientId': string;
    'clientSecret'?: string;
    'footprintsUrl': string;
}
export interface TokenUsage {
    'inputTokens': number;
    'outputTokens': number;
}
export interface ToolResultMessage {
    'content': ReadonlyArray<{ [key: string]: any; }>;
    'role': string;
}

export const TransportEnergy = {
    FOSSIL_FUEL: 'FOSSIL_FUEL',
    BIO_FUEL: 'BIO_FUEL',
    ELECTRICITY: 'ELECTRICITY',
    HYDROGEN: 'HYDROGEN',
    HYBRID: 'HYBRID'
} as const;

export type TransportEnergy = typeof TransportEnergy[keyof typeof TransportEnergy];



export const TransportMode = {
    TRUCK: 'TRUCK',
    TRAIN: 'TRAIN',
    BOAT: 'BOAT',
    PLANE: 'PLANE',
    INTERMODAL: 'INTERMODAL'
} as const;

export type TransportMode = typeof TransportMode[keyof typeof TransportMode];



export const TransportTemperature = {
    DRY: 'DRY',
    REFRIGERATED: 'REFRIGERATED',
    FROZEN: 'FROZEN',
    HEATED: 'HEATED'
} as const;

export type TransportTemperature = typeof TransportTemperature[keyof typeof TransportTemperature];


export interface TriggerSyncRequest {
    'footprintIds'?: ReadonlyArray<string>;
}
export interface UUIDListRequest {
    'ids': ReadonlyArray<string>;
}
export interface UpdateCorporateAllocationDataRequest {
    'answeredAllocationData'?: CorporateAllocationData;
}
export interface UpdateEmissionDraftDataRequest {
    'emissionDraftData'?: DraftEmissionRequestFormData;
}
export interface UpdateFormDataRequest {
    'formData'?: { [key: string]: any; };
}
export interface UpdateOrganizationNameRequest {
    'name'?: string;
    'senderNameForSuppliers'?: string;
}
export interface UpdateUserAccessLevelRequest {
    'accessLevel': UserAccessLevel;
    'email': string;
}



export const UserAccessLevel = {
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR'
} as const;

export type UserAccessLevel = typeof UserAccessLevel[keyof typeof UserAccessLevel];


export interface UserAccessRequestCreateRequest {
    'userEmail': string;
    'userFullName': string;
    'userJobTitle'?: string;
    'userPassword'?: string;
}
export interface UserCreateRequest {
    'accessManagementToken': string;
    'userEmail': string;
    'userFullName': string;
    'userJobTitle'?: string;
    'userPassword': string;
}
export interface UserInvitationListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface UserInvitationListResponse {
    'data': ReadonlyArray<UserInvitationResponse>;
    'metadata': UserInvitationListMetadataResponse;
}
export interface UserInvitationResponse {
    'createdAt': string;
    'recipientEmail': string;
}
export interface UserListMetadataResponse {
    'count': number;
    'pageNumber': number;
    'pageSize': number;
}
export interface UserListResponse {
    'data': ReadonlyArray<UserResponse>;
    'metadata': UserListMetadataResponse;
}
export interface UserResetPasswordRequest {
    'userEmail': string;
}
export interface UserResponse {
    'accessLevel': UserAccessLevel;
    'email': string;
    'emissionDataRejected': boolean;
    'emissionRequestDeclined': boolean;
    'emissionRequestReceived': boolean;
    'emissionRequestReviewReady': boolean;
    'fullName': string;
    'isNotifiedOnSupplierInvitationUpdates': boolean;
    'jobTitle'?: string;
}


export interface UserUpdatePasswordRequest {
    'accessManagementToken': string;
    'userEmail': string;
    'userPassword': string;
}
export interface UserUpdateRequest {
    'connectionRequestAccepted': boolean;
    'connectionRequestDeclined': boolean;
    'connectionRequestReceived': boolean;
    'emissionDataRejected': boolean;
    'emissionRequestDeclined': boolean;
    'emissionRequestReceived': boolean;
    'emissionRequestReviewReady': boolean;
    'isNotifiedOnSupplierInvitationUpdates': boolean;
}
export interface VerificationAttachment {
    'id': string;
    'name': string;
}
export interface VerificationData {
    'additionalVerificationProviderDetails'?: string;
    'additionalVerificationStandardDetails'?: string;
    'isDataVerified'?: boolean;
    'isProductVerified'?: boolean;
    'isToolVerified'?: boolean;
    'verificationAttachments'?: ReadonlyArray<VerificationAttachment>;
    'verificationProvider'?: VerificationProvider;
    'verificationStandard'?: Standard;
}



export const VerificationProvider = {
    LRQA: 'LRQA',
    TOITU_ENVIROCARE: 'TOITU_ENVIROCARE',
    JMA: 'JMA',
    APEX: 'APEX',
    PROVIDER_3_R: 'PROVIDER_3R',
    AEC: 'AEC',
    CARBON_INTELLIGENCE: 'CARBON_INTELLIGENCE',
    CONSULTORA_AMBIENTAL_E3: 'CONSULTORA_AMBIENTAL_E3',
    ENKING_INTERNATIONAL: 'ENKING_INTERNATIONAL',
    ENLIGHTEN: 'ENLIGHTEN',
    ISOS_GROUP: 'ISOS_GROUP',
    KERAMIDA: 'KERAMIDA',
    KPMG: 'KPMG',
    LUCIDEON: 'LUCIDEON',
    OPTERA: 'OPTERA',
    PETERSON_CONTROL_UNION: 'PETERSON_CONTROL_UNION',
    POSITION_GREEN: 'POSITION_GREEN',
    RIO: 'RIO',
    OTHER: 'OTHER'
} as const;

export type VerificationProvider = typeof VerificationProvider[keyof typeof VerificationProvider];


export interface Volume {
    'type': 'VOLUME';
    'value': number;
    'unit': QuantityUnit;
}


export interface Weight {
    'type': 'WEIGHT';
    'value': number;
    'unit': QuantityUnit;
}



/**
 * AdminInvitedSupplierControllerApi - axios parameter creator
 */
export const AdminInvitedSupplierControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Migrate legacy invited suppliers onto resolved registry organisations
         * @param {MigrateLegacyInvitedSuppliersRequest} migrateLegacyInvitedSuppliersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrate: async (migrateLegacyInvitedSuppliersRequest: MigrateLegacyInvitedSuppliersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'migrateLegacyInvitedSuppliersRequest' is not null or undefined
            assertParamExists('migrate', 'migrateLegacyInvitedSuppliersRequest', migrateLegacyInvitedSuppliersRequest)
            const localVarPath = `/api/admin/invited-suppliers/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(migrateLegacyInvitedSuppliersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminInvitedSupplierControllerApi - functional programming interface
 */
export const AdminInvitedSupplierControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminInvitedSupplierControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Migrate legacy invited suppliers onto resolved registry organisations
         * @param {MigrateLegacyInvitedSuppliersRequest} migrateLegacyInvitedSuppliersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrate(migrateLegacyInvitedSuppliersRequest: MigrateLegacyInvitedSuppliersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyInvitedSupplierMigrationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrate(migrateLegacyInvitedSuppliersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInvitedSupplierControllerApi.migrate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminInvitedSupplierControllerApi - factory interface
 */
export const AdminInvitedSupplierControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminInvitedSupplierControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Migrate legacy invited suppliers onto resolved registry organisations
         * @param {MigrateLegacyInvitedSuppliersRequest} migrateLegacyInvitedSuppliersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrate(migrateLegacyInvitedSuppliersRequest: MigrateLegacyInvitedSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<LegacyInvitedSupplierMigrationResult> {
            return localVarFp.migrate(migrateLegacyInvitedSuppliersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminInvitedSupplierControllerApi - object-oriented interface
 */
export class AdminInvitedSupplierControllerApi extends BaseAPI {
    /**
     * 
     * @summary Migrate legacy invited suppliers onto resolved registry organisations
     * @param {MigrateLegacyInvitedSuppliersRequest} migrateLegacyInvitedSuppliersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public migrate(migrateLegacyInvitedSuppliersRequest: MigrateLegacyInvitedSuppliersRequest, options?: RawAxiosRequestConfig) {
        return AdminInvitedSupplierControllerApiFp(this.configuration).migrate(migrateLegacyInvitedSuppliersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminUserControllerApi - axios parameter creator
 */
export const AdminUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete users by email
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: async (emailListRequest: EmailListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('deleteUsers', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserControllerApi - functional programming interface
 */
export const AdminUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete users by email
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsers(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsers(emailListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserControllerApi.deleteUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUserControllerApi - factory interface
 */
export const AdminUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete users by email
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUsers(emailListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserControllerApi - object-oriented interface
 */
export class AdminUserControllerApi extends BaseAPI {
    /**
     * 
     * @summary Delete users by email
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsers(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).deleteUsers(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatenaXProductPartnersControllerApi - axios parameter creator
 */
export const CatenaXProductPartnersControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the partner BPNLs that can discover this product over Catena-X (read from the DTR).
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getPartners', 'templateId', templateId)
            const localVarPath = `/api/customers/products/{templateId}/catena-x-partners`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the partner BPNLs that can discover this product over Catena-X (persisted to the DTR).
         * @param {string} templateId 
         * @param {CatenaXProductPartnersRequest} catenaXProductPartnersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartners: async (templateId: string, catenaXProductPartnersRequest: CatenaXProductPartnersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('setPartners', 'templateId', templateId)
            // verify required parameter 'catenaXProductPartnersRequest' is not null or undefined
            assertParamExists('setPartners', 'catenaXProductPartnersRequest', catenaXProductPartnersRequest)
            const localVarPath = `/api/customers/products/{templateId}/catena-x-partners`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catenaXProductPartnersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatenaXProductPartnersControllerApi - functional programming interface
 */
export const CatenaXProductPartnersControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatenaXProductPartnersControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the partner BPNLs that can discover this product over Catena-X (read from the DTR).
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartners(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatenaXProductPartnersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartners(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatenaXProductPartnersControllerApi.getPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the partner BPNLs that can discover this product over Catena-X (persisted to the DTR).
         * @param {string} templateId 
         * @param {CatenaXProductPartnersRequest} catenaXProductPartnersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPartners(templateId: string, catenaXProductPartnersRequest: CatenaXProductPartnersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPartners(templateId, catenaXProductPartnersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatenaXProductPartnersControllerApi.setPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatenaXProductPartnersControllerApi - factory interface
 */
export const CatenaXProductPartnersControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatenaXProductPartnersControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List the partner BPNLs that can discover this product over Catena-X (read from the DTR).
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners(templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CatenaXProductPartnersResponse> {
            return localVarFp.getPartners(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the partner BPNLs that can discover this product over Catena-X (persisted to the DTR).
         * @param {string} templateId 
         * @param {CatenaXProductPartnersRequest} catenaXProductPartnersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartners(templateId: string, catenaXProductPartnersRequest: CatenaXProductPartnersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPartners(templateId, catenaXProductPartnersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatenaXProductPartnersControllerApi - object-oriented interface
 */
export class CatenaXProductPartnersControllerApi extends BaseAPI {
    /**
     * 
     * @summary List the partner BPNLs that can discover this product over Catena-X (read from the DTR).
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPartners(templateId: string, options?: RawAxiosRequestConfig) {
        return CatenaXProductPartnersControllerApiFp(this.configuration).getPartners(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the partner BPNLs that can discover this product over Catena-X (persisted to the DTR).
     * @param {string} templateId 
     * @param {CatenaXProductPartnersRequest} catenaXProductPartnersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setPartners(templateId: string, catenaXProductPartnersRequest: CatenaXProductPartnersRequest, options?: RawAxiosRequestConfig) {
        return CatenaXProductPartnersControllerApiFp(this.configuration).setPartners(templateId, catenaXProductPartnersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatenaXShareControllerApi - axios parameter creator
 */
export const CatenaXShareControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Proactively share PCFs with Catena-X partners (by BPNL), making them discoverable on the product twins (CX-0136).
         * @param {CatenaXShareRequest} catenaXShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        share1: async (catenaXShareRequest: CatenaXShareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catenaXShareRequest' is not null or undefined
            assertParamExists('share1', 'catenaXShareRequest', catenaXShareRequest)
            const localVarPath = `/api/customers/catena-x-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catenaXShareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatenaXShareControllerApi - functional programming interface
 */
export const CatenaXShareControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatenaXShareControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Proactively share PCFs with Catena-X partners (by BPNL), making them discoverable on the product twins (CX-0136).
         * @param {CatenaXShareRequest} catenaXShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async share1(catenaXShareRequest: CatenaXShareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.share1(catenaXShareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatenaXShareControllerApi.share1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatenaXShareControllerApi - factory interface
 */
export const CatenaXShareControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatenaXShareControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Proactively share PCFs with Catena-X partners (by BPNL), making them discoverable on the product twins (CX-0136).
         * @param {CatenaXShareRequest} catenaXShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        share1(catenaXShareRequest: CatenaXShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.share1(catenaXShareRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatenaXShareControllerApi - object-oriented interface
 */
export class CatenaXShareControllerApi extends BaseAPI {
    /**
     * 
     * @summary Proactively share PCFs with Catena-X partners (by BPNL), making them discoverable on the product twins (CX-0136).
     * @param {CatenaXShareRequest} catenaXShareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public share1(catenaXShareRequest: CatenaXShareRequest, options?: RawAxiosRequestConfig) {
        return CatenaXShareControllerApiFp(this.configuration).share1(catenaXShareRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConnectedOrganizationControllerApi - axios parameter creator
 */
export const ConnectedOrganizationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new connected organization
         * @param {ConnectedOrganizationRequest} connectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectedOrganization: async (connectedOrganizationRequest: ConnectedOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationRequest' is not null or undefined
            assertParamExists('createConnectedOrganization', 'connectedOrganizationRequest', connectedOrganizationRequest)
            const localVarPath = `/api/connected-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectedOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectedOrganization: async (connectedOrganizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('deleteConnectedOrganization', 'connectedOrganizationId', connectedOrganizationId)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk-delete connected organizations and unlink them as suppliers
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectedOrganizations: async (uUIDListRequest: UUIDListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uUIDListRequest' is not null or undefined
            assertParamExists('deleteConnectedOrganizations', 'uUIDListRequest', uUIDListRequest)
            const localVarPath = `/api/connected-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uUIDListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove PACT connector from a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePactConnector: async (connectedOrganizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('deletePactConnector', 'connectedOrganizationId', connectedOrganizationId)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}/connectors/pact`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export all connected organizations for current organisation as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConnectedOrganizations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connected-organizations/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a connected organization by ID
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedOrganization: async (connectedOrganizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('getConnectedOrganization', 'connectedOrganizationId', connectedOrganizationId)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List available PACT footprints from connected organization without syncing
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedOrganizationFootprints: async (connectedOrganizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('listConnectedOrganizationFootprints', 'connectedOrganizationId', connectedOrganizationId)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}/connectors/pact/footprints`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List connected organizations for current organisation
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {ListConnectedOrganizationsSortByEnum} [sortBy] 
         * @param {ListConnectedOrganizationsSortDirectionEnum} [sortDirection] 
         * @param {string} [textSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedOrganizations: async (pageNumber?: number, pageSize?: number, sortBy?: ListConnectedOrganizationsSortByEnum, sortDirection?: ListConnectedOrganizationsSortDirectionEnum, textSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connected-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (textSearch !== undefined) {
                localVarQueryParameter['textSearch'] = textSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches registry for an org with the given email domain. Creates a ghost org if none found. Returns existing connected organization if already configured.
         * @summary Find or create a connected organization by email domain (ghost org flow)
         * @param {ResolveConnectedOrganizationRequest} resolveConnectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveConnectedOrganization: async (resolveConnectedOrganizationRequest: ResolveConnectedOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveConnectedOrganizationRequest' is not null or undefined
            assertParamExists('resolveConnectedOrganization', 'resolveConnectedOrganizationRequest', resolveConnectedOrganizationRequest)
            const localVarPath = `/api/connected-organizations/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveConnectedOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test outbound PACT credentials without saving
         * @param {string} connectedOrganizationId 
         * @param {TestOutboundRequest} testOutboundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOutboundConnection: async (connectedOrganizationId: string, testOutboundRequest: TestOutboundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('testOutboundConnection', 'connectedOrganizationId', connectedOrganizationId)
            // verify required parameter 'testOutboundRequest' is not null or undefined
            assertParamExists('testOutboundConnection', 'testOutboundRequest', testOutboundRequest)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}/connectors/pact/test`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testOutboundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger an immediate PACT footprint sync for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {TriggerSyncRequest} [triggerSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSync: async (connectedOrganizationId: string, triggerSyncRequest?: TriggerSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('triggerSync', 'connectedOrganizationId', connectedOrganizationId)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}/connectors/pact/sync`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(triggerSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update connected organization metadata
         * @param {string} connectedOrganizationId 
         * @param {ConnectedOrganizationUpdateRequest} connectedOrganizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectedOrganization: async (connectedOrganizationId: string, connectedOrganizationUpdateRequest: ConnectedOrganizationUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('updateConnectedOrganization', 'connectedOrganizationId', connectedOrganizationId)
            // verify required parameter 'connectedOrganizationUpdateRequest' is not null or undefined
            assertParamExists('updateConnectedOrganization', 'connectedOrganizationUpdateRequest', connectedOrganizationUpdateRequest)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectedOrganizationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert PACT connector config for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {PactConnectorRequest} pactConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPactConnector: async (connectedOrganizationId: string, pactConnectorRequest: PactConnectorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedOrganizationId' is not null or undefined
            assertParamExists('upsertPactConnector', 'connectedOrganizationId', connectedOrganizationId)
            // verify required parameter 'pactConnectorRequest' is not null or undefined
            assertParamExists('upsertPactConnector', 'pactConnectorRequest', pactConnectorRequest)
            const localVarPath = `/api/connected-organizations/{connectedOrganizationId}/connectors/pact`
                .replace(`{${"connectedOrganizationId"}}`, encodeURIComponent(String(connectedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pactConnectorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectedOrganizationControllerApi - functional programming interface
 */
export const ConnectedOrganizationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectedOrganizationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new connected organization
         * @param {ConnectedOrganizationRequest} connectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectedOrganization(connectedOrganizationRequest: ConnectedOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectedOrganization(connectedOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.createConnectedOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnectedOrganization(connectedOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.deleteConnectedOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk-delete connected organizations and unlink them as suppliers
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnectedOrganizations(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnectedOrganizations(uUIDListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.deleteConnectedOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove PACT connector from a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePactConnector(connectedOrganizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePactConnector(connectedOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.deletePactConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export all connected organizations for current organisation as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportConnectedOrganizations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportConnectedOrganizations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.exportConnectedOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a connected organization by ID
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectedOrganization(connectedOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.getConnectedOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List available PACT footprints from connected organization without syncing
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectedOrganizationFootprints(connectedOrganizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<PactFootprintPreviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectedOrganizationFootprints(connectedOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.listConnectedOrganizationFootprints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List connected organizations for current organisation
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {ListConnectedOrganizationsSortByEnum} [sortBy] 
         * @param {ListConnectedOrganizationsSortDirectionEnum} [sortDirection] 
         * @param {string} [textSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectedOrganizations(pageNumber?: number, pageSize?: number, sortBy?: ListConnectedOrganizationsSortByEnum, sortDirection?: ListConnectedOrganizationsSortDirectionEnum, textSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectedOrganizations(pageNumber, pageSize, sortBy, sortDirection, textSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.listConnectedOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches registry for an org with the given email domain. Creates a ghost org if none found. Returns existing connected organization if already configured.
         * @summary Find or create a connected organization by email domain (ghost org flow)
         * @param {ResolveConnectedOrganizationRequest} resolveConnectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveConnectedOrganization(resolveConnectedOrganizationRequest: ResolveConnectedOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveConnectedOrganization(resolveConnectedOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.resolveConnectedOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test outbound PACT credentials without saving
         * @param {string} connectedOrganizationId 
         * @param {TestOutboundRequest} testOutboundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testOutboundConnection(connectedOrganizationId: string, testOutboundRequest: TestOutboundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testOutboundConnection(connectedOrganizationId, testOutboundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.testOutboundConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger an immediate PACT footprint sync for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {TriggerSyncRequest} [triggerSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSync(connectedOrganizationId: string, triggerSyncRequest?: TriggerSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSync(connectedOrganizationId, triggerSyncRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.triggerSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update connected organization metadata
         * @param {string} connectedOrganizationId 
         * @param {ConnectedOrganizationUpdateRequest} connectedOrganizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConnectedOrganization(connectedOrganizationId: string, connectedOrganizationUpdateRequest: ConnectedOrganizationUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnectedOrganization(connectedOrganizationId, connectedOrganizationUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.updateConnectedOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upsert PACT connector config for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {PactConnectorRequest} pactConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertPactConnector(connectedOrganizationId: string, pactConnectorRequest: PactConnectorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertPactConnector(connectedOrganizationId, pactConnectorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectedOrganizationControllerApi.upsertPactConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectedOrganizationControllerApi - factory interface
 */
export const ConnectedOrganizationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectedOrganizationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new connected organization
         * @param {ConnectedOrganizationRequest} connectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectedOrganization(connectedOrganizationRequest: ConnectedOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationResponse> {
            return localVarFp.createConnectedOrganization(connectedOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteConnectedOrganization(connectedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk-delete connected organizations and unlink them as suppliers
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectedOrganizations(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteConnectedOrganizations(uUIDListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove PACT connector from a connected organization
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePactConnector(connectedOrganizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePactConnector(connectedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export all connected organizations for current organisation as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConnectedOrganizations(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportConnectedOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a connected organization by ID
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationResponse> {
            return localVarFp.getConnectedOrganization(connectedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List available PACT footprints from connected organization without syncing
         * @param {string} connectedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedOrganizationFootprints(connectedOrganizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<PactFootprintPreviewResponse>> {
            return localVarFp.listConnectedOrganizationFootprints(connectedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List connected organizations for current organisation
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {ListConnectedOrganizationsSortByEnum} [sortBy] 
         * @param {ListConnectedOrganizationsSortDirectionEnum} [sortDirection] 
         * @param {string} [textSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedOrganizations(pageNumber?: number, pageSize?: number, sortBy?: ListConnectedOrganizationsSortByEnum, sortDirection?: ListConnectedOrganizationsSortDirectionEnum, textSearch?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationsResponse> {
            return localVarFp.listConnectedOrganizations(pageNumber, pageSize, sortBy, sortDirection, textSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches registry for an org with the given email domain. Creates a ghost org if none found. Returns existing connected organization if already configured.
         * @summary Find or create a connected organization by email domain (ghost org flow)
         * @param {ResolveConnectedOrganizationRequest} resolveConnectedOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveConnectedOrganization(resolveConnectedOrganizationRequest: ResolveConnectedOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationResponse> {
            return localVarFp.resolveConnectedOrganization(resolveConnectedOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test outbound PACT credentials without saving
         * @param {string} connectedOrganizationId 
         * @param {TestOutboundRequest} testOutboundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOutboundConnection(connectedOrganizationId: string, testOutboundRequest: TestOutboundRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testOutboundConnection(connectedOrganizationId, testOutboundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger an immediate PACT footprint sync for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {TriggerSyncRequest} [triggerSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSync(connectedOrganizationId: string, triggerSyncRequest?: TriggerSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggerSync(connectedOrganizationId, triggerSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update connected organization metadata
         * @param {string} connectedOrganizationId 
         * @param {ConnectedOrganizationUpdateRequest} connectedOrganizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectedOrganization(connectedOrganizationId: string, connectedOrganizationUpdateRequest: ConnectedOrganizationUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationResponse> {
            return localVarFp.updateConnectedOrganization(connectedOrganizationId, connectedOrganizationUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert PACT connector config for a connected organization
         * @param {string} connectedOrganizationId 
         * @param {PactConnectorRequest} pactConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPactConnector(connectedOrganizationId: string, pactConnectorRequest: PactConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectedOrganizationResponse> {
            return localVarFp.upsertPactConnector(connectedOrganizationId, pactConnectorRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConnectedOrganizationControllerApi - object-oriented interface
 */
export class ConnectedOrganizationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create a new connected organization
     * @param {ConnectedOrganizationRequest} connectedOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createConnectedOrganization(connectedOrganizationRequest: ConnectedOrganizationRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).createConnectedOrganization(connectedOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a connected organization
     * @param {string} connectedOrganizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).deleteConnectedOrganization(connectedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk-delete connected organizations and unlink them as suppliers
     * @param {UUIDListRequest} uUIDListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConnectedOrganizations(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).deleteConnectedOrganizations(uUIDListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove PACT connector from a connected organization
     * @param {string} connectedOrganizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePactConnector(connectedOrganizationId: string, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).deletePactConnector(connectedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export all connected organizations for current organisation as CSV
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportConnectedOrganizations(options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).exportConnectedOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a connected organization by ID
     * @param {string} connectedOrganizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConnectedOrganization(connectedOrganizationId: string, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).getConnectedOrganization(connectedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List available PACT footprints from connected organization without syncing
     * @param {string} connectedOrganizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConnectedOrganizationFootprints(connectedOrganizationId: string, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).listConnectedOrganizationFootprints(connectedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List connected organizations for current organisation
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {ListConnectedOrganizationsSortByEnum} [sortBy] 
     * @param {ListConnectedOrganizationsSortDirectionEnum} [sortDirection] 
     * @param {string} [textSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConnectedOrganizations(pageNumber?: number, pageSize?: number, sortBy?: ListConnectedOrganizationsSortByEnum, sortDirection?: ListConnectedOrganizationsSortDirectionEnum, textSearch?: string, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).listConnectedOrganizations(pageNumber, pageSize, sortBy, sortDirection, textSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches registry for an org with the given email domain. Creates a ghost org if none found. Returns existing connected organization if already configured.
     * @summary Find or create a connected organization by email domain (ghost org flow)
     * @param {ResolveConnectedOrganizationRequest} resolveConnectedOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolveConnectedOrganization(resolveConnectedOrganizationRequest: ResolveConnectedOrganizationRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).resolveConnectedOrganization(resolveConnectedOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test outbound PACT credentials without saving
     * @param {string} connectedOrganizationId 
     * @param {TestOutboundRequest} testOutboundRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testOutboundConnection(connectedOrganizationId: string, testOutboundRequest: TestOutboundRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).testOutboundConnection(connectedOrganizationId, testOutboundRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger an immediate PACT footprint sync for a connected organization
     * @param {string} connectedOrganizationId 
     * @param {TriggerSyncRequest} [triggerSyncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerSync(connectedOrganizationId: string, triggerSyncRequest?: TriggerSyncRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).triggerSync(connectedOrganizationId, triggerSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update connected organization metadata
     * @param {string} connectedOrganizationId 
     * @param {ConnectedOrganizationUpdateRequest} connectedOrganizationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConnectedOrganization(connectedOrganizationId: string, connectedOrganizationUpdateRequest: ConnectedOrganizationUpdateRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).updateConnectedOrganization(connectedOrganizationId, connectedOrganizationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert PACT connector config for a connected organization
     * @param {string} connectedOrganizationId 
     * @param {PactConnectorRequest} pactConnectorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertPactConnector(connectedOrganizationId: string, pactConnectorRequest: PactConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectedOrganizationControllerApiFp(this.configuration).upsertPactConnector(connectedOrganizationId, pactConnectorRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListConnectedOrganizationsSortByEnum = {
    DEFAULT: 'DEFAULT',
    PRODUCTS_COUNT: 'PRODUCTS_COUNT'
} as const;
export type ListConnectedOrganizationsSortByEnum = typeof ListConnectedOrganizationsSortByEnum[keyof typeof ListConnectedOrganizationsSortByEnum];
export const ListConnectedOrganizationsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListConnectedOrganizationsSortDirectionEnum = typeof ListConnectedOrganizationsSortDirectionEnum[keyof typeof ListConnectedOrganizationsSortDirectionEnum];


/**
 * ContactControllerApi - axios parameter creator
 */
export const ContactControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit a contact request to the sales team
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactRequest: async (contactRequest: ContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactRequest' is not null or undefined
            assertParamExists('submitContactRequest', 'contactRequest', contactRequest)
            const localVarPath = `/api/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactControllerApi - functional programming interface
 */
export const ContactControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit a contact request to the sales team
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitContactRequest(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitContactRequest(contactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactControllerApi.submitContactRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactControllerApi - factory interface
 */
export const ContactControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit a contact request to the sales team
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactRequest(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitContactRequest(contactRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactControllerApi - object-oriented interface
 */
export class ContactControllerApi extends BaseAPI {
    /**
     * 
     * @summary Submit a contact request to the sales team
     * @param {ContactRequest} contactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitContactRequest(contactRequest: ContactRequest, options?: RawAxiosRequestConfig) {
        return ContactControllerApiFp(this.configuration).submitContactRequest(contactRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CorpoControllerApi - axios parameter creator
 */
export const CorpoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierProducts: async (supplierId: string, pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listSupplierProducts', 'supplierId', supplierId)
            const localVarPath = `/api/corpo/suppliers/{supplierId}/products`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers1: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpo/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorpoControllerApi - functional programming interface
 */
export const CorpoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CorpoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorpoEmissionProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupplierProducts(supplierId, pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorpoControllerApi.listSupplierProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSuppliers1(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorpoSuppliersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSuppliers1(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorpoControllerApi.listSuppliers1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CorpoControllerApi - factory interface
 */
export const CorpoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CorpoControllerApiFp(configuration)
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CorpoEmissionProductListResponse> {
            return localVarFp.listSupplierProducts(supplierId, pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers1(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CorpoSuppliersResponse> {
            return localVarFp.listSuppliers1(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorpoControllerApi - object-oriented interface
 */
export class CorpoControllerApi extends BaseAPI {
    /**
     *  List of products associated with a supplier 
     * @summary List of supplier products
     * @param {string} supplierId 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return CorpoControllerApiFp(this.configuration).listSupplierProducts(supplierId, pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of suppliers for a specific organisation
     * @summary List of suppliers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSuppliers1(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return CorpoControllerApiFp(this.configuration).listSuppliers1(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CorporateDataControllerApi - axios parameter creator
 */
export const CorporateDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCorporateDataRequest: async (reference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('acceptCorporateDataRequest', 'reference', reference)
            const localVarPath = `/api/corporate-data/requests/{reference}/accept`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCorporateDataRequest: async (reference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('cancelCorporateDataRequest', 'reference', reference)
            const localVarPath = `/api/corporate-data/requests/{reference}/cancel`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request corporate data for multiple suppliers
         * @param {CreateCorporateDataRequestsRequest} createCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCorporateDataRequests: async (createCorporateDataRequestsRequest: CreateCorporateDataRequestsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCorporateDataRequestsRequest' is not null or undefined
            assertParamExists('createCorporateDataRequests', 'createCorporateDataRequestsRequest', createCorporateDataRequestsRequest)
            const localVarPath = `/api/corporate-data/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCorporateDataRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineCorporateDataRequest: async (reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('declineCorporateDataRequest', 'reference', reference)
            // verify required parameter 'corporateDataRejectionRequest' is not null or undefined
            assertParamExists('declineCorporateDataRequest', 'corporateDataRejectionRequest', corporateDataRejectionRequest)
            const localVarPath = `/api/corporate-data/requests/{reference}/decline`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(corporateDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get corporate data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corporate-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequestByReference: async (reference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('getCorporateDataRequestByReference', 'reference', reference)
            const localVarPath = `/api/corporate-data/requests/{reference}`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequestDetailByReference: async (reference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('getCorporateDataRequestDetailByReference', 'reference', reference)
            const localVarPath = `/api/corporate-data/requests/{reference}/detail`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get corporate data requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [corporateDataRequestStatus] 
         * @param {GetCorporateDataRequestsSortByEnum} [sortBy] 
         * @param {GetCorporateDataRequestsSortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<number>} [reportingYears] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {boolean} [received] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequests: async (pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, supplierIds?: ReadonlyArray<string>, corporateDataRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetCorporateDataRequestsSortByEnum, sortDirection?: GetCorporateDataRequestsSortDirectionEnum, reportingYears?: ReadonlyArray<number>, lastUpdatedFrom?: string, lastUpdatedTo?: string, received?: boolean, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corporate-data/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (customerIds) {
                localVarQueryParameter['customerIds'] = customerIds;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }

            if (corporateDataRequestStatus) {
                localVarQueryParameter['corporateDataRequestStatus'] = corporateDataRequestStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (reportingYears) {
                localVarQueryParameter['reportingYears'] = reportingYears;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (received !== undefined) {
                localVarQueryParameter['received'] = received;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get distinct year values from received requests - used to create a request filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctRequestYears: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corporate-data/requests/filters/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prefill corporate data from attachments with streaming
         * @param {PrefillCorporateDataRequest} prefillCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefillCorporateDataFromAttachments: async (prefillCorporateDataRequest: PrefillCorporateDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefillCorporateDataRequest' is not null or undefined
            assertParamExists('prefillCorporateDataFromAttachments', 'prefillCorporateDataRequest', prefillCorporateDataRequest)
            const localVarPath = `/api/corporate-data/prefill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prefillCorporateDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCorporateDataRequest: async (reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('rejectCorporateDataRequest', 'reference', reference)
            // verify required parameter 'corporateDataRejectionRequest' is not null or undefined
            assertParamExists('rejectCorporateDataRequest', 'corporateDataRejectionRequest', corporateDataRejectionRequest)
            const localVarPath = `/api/corporate-data/requests/{reference}/reject`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(corporateDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request clarification on corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestClarificationCorporateDataRequest: async (reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('requestClarificationCorporateDataRequest', 'reference', reference)
            // verify required parameter 'corporateDataRejectionRequest' is not null or undefined
            assertParamExists('requestClarificationCorporateDataRequest', 'corporateDataRejectionRequest', corporateDataRejectionRequest)
            const localVarPath = `/api/corporate-data/requests/{reference}/request-clarification`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(corporateDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Corporate Data Requests
         * @param {ResendCorporateDataRequestsRequest} resendCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendCorporateDataRequests: async (resendCorporateDataRequestsRequest: ResendCorporateDataRequestsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendCorporateDataRequestsRequest' is not null or undefined
            assertParamExists('resendCorporateDataRequests', 'resendCorporateDataRequestsRequest', resendCorporateDataRequestsRequest)
            const localVarPath = `/api/corporate-data/requests/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendCorporateDataRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Share corporate data for a request
         * @param {string} reference 
         * @param {UpdateCorporateAllocationDataRequest} updateCorporateAllocationDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareCorporateData: async (reference: string, updateCorporateAllocationDataRequest: UpdateCorporateAllocationDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('shareCorporateData', 'reference', reference)
            // verify required parameter 'updateCorporateAllocationDataRequest' is not null or undefined
            assertParamExists('shareCorporateData', 'updateCorporateAllocationDataRequest', updateCorporateAllocationDataRequest)
            const localVarPath = `/api/corporate-data/requests/{reference}/share`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCorporateAllocationDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert corporate data
         * @param {CorporateDataDto} corporateDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCorporateData: async (corporateDataDto: CorporateDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'corporateDataDto' is not null or undefined
            assertParamExists('upsertCorporateData', 'corporateDataDto', corporateDataDto)
            const localVarPath = `/api/corporate-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(corporateDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorporateDataControllerApi - functional programming interface
 */
export const CorporateDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CorporateDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptCorporateDataRequest(reference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.acceptCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCorporateDataRequest(reference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.cancelCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request corporate data for multiple suppliers
         * @param {CreateCorporateDataRequestsRequest} createCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCorporateDataRequests(createCorporateDataRequestsRequest: CreateCorporateDataRequestsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<CorporateDataRequestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCorporateDataRequests(createCorporateDataRequestsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.createCorporateDataRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decline corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineCorporateDataRequest(reference, corporateDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.declineCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get corporate data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorporateData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<CorporateDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCorporateData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.getCorporateData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorporateDataRequestByReference(reference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCorporateDataRequestByReference(reference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.getCorporateDataRequestByReference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorporateDataRequestDetailByReference(reference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCorporateDataRequestDetailByReference(reference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.getCorporateDataRequestDetailByReference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get corporate data requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [corporateDataRequestStatus] 
         * @param {GetCorporateDataRequestsSortByEnum} [sortBy] 
         * @param {GetCorporateDataRequestsSortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<number>} [reportingYears] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {boolean} [received] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorporateDataRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, supplierIds?: ReadonlyArray<string>, corporateDataRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetCorporateDataRequestsSortByEnum, sortDirection?: GetCorporateDataRequestsSortDirectionEnum, reportingYears?: ReadonlyArray<number>, lastUpdatedFrom?: string, lastUpdatedTo?: string, received?: boolean, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCorporateDataRequests(pageNumber, limit, customerIds, supplierIds, corporateDataRequestStatus, sortBy, sortDirection, reportingYears, lastUpdatedFrom, lastUpdatedTo, received, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.getCorporateDataRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get distinct year values from received requests - used to create a request filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistinctRequestYears(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistinctRequestYears(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.getDistinctRequestYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prefill corporate data from attachments with streaming
         * @param {PrefillCorporateDataRequest} prefillCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prefillCorporateDataFromAttachments(prefillCorporateDataRequest: PrefillCorporateDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SseEmitter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prefillCorporateDataFromAttachments(prefillCorporateDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.prefillCorporateDataFromAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCorporateDataRequest(reference, corporateDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.rejectCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request clarification on corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestClarificationCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestClarificationCorporateDataRequest(reference, corporateDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.requestClarificationCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend Corporate Data Requests
         * @param {ResendCorporateDataRequestsRequest} resendCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendCorporateDataRequests(resendCorporateDataRequestsRequest: ResendCorporateDataRequestsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendCorporateDataRequests(resendCorporateDataRequestsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.resendCorporateDataRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Share corporate data for a request
         * @param {string} reference 
         * @param {UpdateCorporateAllocationDataRequest} updateCorporateAllocationDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareCorporateData(reference: string, updateCorporateAllocationDataRequest: UpdateCorporateAllocationDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareCorporateData(reference, updateCorporateAllocationDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.shareCorporateData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upsert corporate data
         * @param {CorporateDataDto} corporateDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertCorporateData(corporateDataDto: CorporateDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertCorporateData(corporateDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataControllerApi.upsertCorporateData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CorporateDataControllerApi - factory interface
 */
export const CorporateDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CorporateDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.acceptCorporateDataRequest(reference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel corporate data request
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelCorporateDataRequest(reference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request corporate data for multiple suppliers
         * @param {CreateCorporateDataRequestsRequest} createCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCorporateDataRequests(createCorporateDataRequestsRequest: CreateCorporateDataRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<CorporateDataRequestResponse>> {
            return localVarFp.createCorporateDataRequests(createCorporateDataRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.declineCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get corporate data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateData(options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<CorporateDataResponse>> {
            return localVarFp.getCorporateData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequestByReference(reference: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestResponse> {
            return localVarFp.getCorporateDataRequestByReference(reference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get corporate data by reference
         * @param {string} reference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequestDetailByReference(reference: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.getCorporateDataRequestDetailByReference(reference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get corporate data requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [corporateDataRequestStatus] 
         * @param {GetCorporateDataRequestsSortByEnum} [sortBy] 
         * @param {GetCorporateDataRequestsSortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<number>} [reportingYears] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {boolean} [received] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateDataRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, supplierIds?: ReadonlyArray<string>, corporateDataRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetCorporateDataRequestsSortByEnum, sortDirection?: GetCorporateDataRequestsSortDirectionEnum, reportingYears?: ReadonlyArray<number>, lastUpdatedFrom?: string, lastUpdatedTo?: string, received?: boolean, searchQuery?: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestListResponse> {
            return localVarFp.getCorporateDataRequests(pageNumber, limit, customerIds, supplierIds, corporateDataRequestStatus, sortBy, sortDirection, reportingYears, lastUpdatedFrom, lastUpdatedTo, received, searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get distinct year values from received requests - used to create a request filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctRequestYears(options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<number>> {
            return localVarFp.getDistinctRequestYears(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prefill corporate data from attachments with streaming
         * @param {PrefillCorporateDataRequest} prefillCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefillCorporateDataFromAttachments(prefillCorporateDataRequest: PrefillCorporateDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<SseEmitter> {
            return localVarFp.prefillCorporateDataFromAttachments(prefillCorporateDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.rejectCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request clarification on corporate data request
         * @param {string} reference 
         * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestClarificationCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.requestClarificationCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Corporate Data Requests
         * @param {ResendCorporateDataRequestsRequest} resendCorporateDataRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendCorporateDataRequests(resendCorporateDataRequestsRequest: ResendCorporateDataRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendCorporateDataRequests(resendCorporateDataRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Share corporate data for a request
         * @param {string} reference 
         * @param {UpdateCorporateAllocationDataRequest} updateCorporateAllocationDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareCorporateData(reference: string, updateCorporateAllocationDataRequest: UpdateCorporateAllocationDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataRequestDetailResponse> {
            return localVarFp.shareCorporateData(reference, updateCorporateAllocationDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert corporate data
         * @param {CorporateDataDto} corporateDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCorporateData(corporateDataDto: CorporateDataDto, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataResponse> {
            return localVarFp.upsertCorporateData(corporateDataDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorporateDataControllerApi - object-oriented interface
 */
export class CorporateDataControllerApi extends BaseAPI {
    /**
     * 
     * @summary Accept corporate data request
     * @param {string} reference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).acceptCorporateDataRequest(reference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel corporate data request
     * @param {string} reference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelCorporateDataRequest(reference: string, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).cancelCorporateDataRequest(reference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request corporate data for multiple suppliers
     * @param {CreateCorporateDataRequestsRequest} createCorporateDataRequestsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCorporateDataRequests(createCorporateDataRequestsRequest: CreateCorporateDataRequestsRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).createCorporateDataRequests(createCorporateDataRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline corporate data request
     * @param {string} reference 
     * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).declineCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get corporate data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCorporateData(options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).getCorporateData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get corporate data by reference
     * @param {string} reference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCorporateDataRequestByReference(reference: string, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).getCorporateDataRequestByReference(reference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get corporate data by reference
     * @param {string} reference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCorporateDataRequestDetailByReference(reference: string, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).getCorporateDataRequestDetailByReference(reference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get corporate data requests
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<string>} [customerIds] 
     * @param {ReadonlyArray<string>} [supplierIds] 
     * @param {ReadonlyArray<DataRequestStatus>} [corporateDataRequestStatus] 
     * @param {GetCorporateDataRequestsSortByEnum} [sortBy] 
     * @param {GetCorporateDataRequestsSortDirectionEnum} [sortDirection] 
     * @param {ReadonlyArray<number>} [reportingYears] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {boolean} [received] 
     * @param {string} [searchQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCorporateDataRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, supplierIds?: ReadonlyArray<string>, corporateDataRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetCorporateDataRequestsSortByEnum, sortDirection?: GetCorporateDataRequestsSortDirectionEnum, reportingYears?: ReadonlyArray<number>, lastUpdatedFrom?: string, lastUpdatedTo?: string, received?: boolean, searchQuery?: string, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).getCorporateDataRequests(pageNumber, limit, customerIds, supplierIds, corporateDataRequestStatus, sortBy, sortDirection, reportingYears, lastUpdatedFrom, lastUpdatedTo, received, searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get distinct year values from received requests - used to create a request filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDistinctRequestYears(options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).getDistinctRequestYears(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prefill corporate data from attachments with streaming
     * @param {PrefillCorporateDataRequest} prefillCorporateDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public prefillCorporateDataFromAttachments(prefillCorporateDataRequest: PrefillCorporateDataRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).prefillCorporateDataFromAttachments(prefillCorporateDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject corporate data request
     * @param {string} reference 
     * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).rejectCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request clarification on corporate data request
     * @param {string} reference 
     * @param {CorporateDataRejectionRequest} corporateDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestClarificationCorporateDataRequest(reference: string, corporateDataRejectionRequest: CorporateDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).requestClarificationCorporateDataRequest(reference, corporateDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Corporate Data Requests
     * @param {ResendCorporateDataRequestsRequest} resendCorporateDataRequestsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendCorporateDataRequests(resendCorporateDataRequestsRequest: ResendCorporateDataRequestsRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).resendCorporateDataRequests(resendCorporateDataRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Share corporate data for a request
     * @param {string} reference 
     * @param {UpdateCorporateAllocationDataRequest} updateCorporateAllocationDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public shareCorporateData(reference: string, updateCorporateAllocationDataRequest: UpdateCorporateAllocationDataRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).shareCorporateData(reference, updateCorporateAllocationDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert corporate data
     * @param {CorporateDataDto} corporateDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertCorporateData(corporateDataDto: CorporateDataDto, options?: RawAxiosRequestConfig) {
        return CorporateDataControllerApiFp(this.configuration).upsertCorporateData(corporateDataDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetCorporateDataRequestsSortByEnum = {
    UPDATED_AT: 'UPDATED_AT',
    CREATED_AT: 'CREATED_AT',
    REPORTING_YEAR: 'REPORTING_YEAR',
    STATUS: 'STATUS'
} as const;
export type GetCorporateDataRequestsSortByEnum = typeof GetCorporateDataRequestsSortByEnum[keyof typeof GetCorporateDataRequestsSortByEnum];
export const GetCorporateDataRequestsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetCorporateDataRequestsSortDirectionEnum = typeof GetCorporateDataRequestsSortDirectionEnum[keyof typeof GetCorporateDataRequestsSortDirectionEnum];


/**
 * CorporateDataFederationControllerApi - axios parameter creator
 */
export const CorporateDataFederationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Federate Corporate Data Request
         * @param {FederateCorporateDataRequest} federateCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateCorporateDataRequest: async (federateCorporateDataRequest: FederateCorporateDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateCorporateDataRequest' is not null or undefined
            assertParamExists('federateCorporateDataRequest', 'federateCorporateDataRequest', federateCorporateDataRequest)
            const localVarPath = `/api/federation/corporate-data-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateCorporateDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Receive federated corporate data response
         * @param {FederateCorporateDataResponse} federateCorporateDataResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCorporateDataResponse: async (federateCorporateDataResponse: FederateCorporateDataResponse, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateCorporateDataResponse' is not null or undefined
            assertParamExists('receiveCorporateDataResponse', 'federateCorporateDataResponse', federateCorporateDataResponse)
            const localVarPath = `/api/federation/corporate-data-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateCorporateDataResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Receive federated corporate data status update
         * @param {FederateCorporateDataStatusUpdate} federateCorporateDataStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCorporateDataStatusUpdate: async (federateCorporateDataStatusUpdate: FederateCorporateDataStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateCorporateDataStatusUpdate' is not null or undefined
            assertParamExists('receiveCorporateDataStatusUpdate', 'federateCorporateDataStatusUpdate', federateCorporateDataStatusUpdate)
            const localVarPath = `/api/federation/corporate-data-requests/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateCorporateDataStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorporateDataFederationControllerApi - functional programming interface
 */
export const CorporateDataFederationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CorporateDataFederationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Federate Corporate Data Request
         * @param {FederateCorporateDataRequest} federateCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateCorporateDataRequest(federateCorporateDataRequest: FederateCorporateDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateCorporateDataRequest(federateCorporateDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataFederationControllerApi.federateCorporateDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Receive federated corporate data response
         * @param {FederateCorporateDataResponse} federateCorporateDataResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveCorporateDataResponse(federateCorporateDataResponse: FederateCorporateDataResponse, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveCorporateDataResponse(federateCorporateDataResponse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataFederationControllerApi.receiveCorporateDataResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Receive federated corporate data status update
         * @param {FederateCorporateDataStatusUpdate} federateCorporateDataStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate: FederateCorporateDataStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateDataDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CorporateDataFederationControllerApi.receiveCorporateDataStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CorporateDataFederationControllerApi - factory interface
 */
export const CorporateDataFederationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CorporateDataFederationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Federate Corporate Data Request
         * @param {FederateCorporateDataRequest} federateCorporateDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateCorporateDataRequest(federateCorporateDataRequest: FederateCorporateDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataDtoResponse> {
            return localVarFp.federateCorporateDataRequest(federateCorporateDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Receive federated corporate data response
         * @param {FederateCorporateDataResponse} federateCorporateDataResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCorporateDataResponse(federateCorporateDataResponse: FederateCorporateDataResponse, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataDtoResponse> {
            return localVarFp.receiveCorporateDataResponse(federateCorporateDataResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Receive federated corporate data status update
         * @param {FederateCorporateDataStatusUpdate} federateCorporateDataStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate: FederateCorporateDataStatusUpdate, options?: RawAxiosRequestConfig): AxiosPromise<CorporateDataDtoResponse> {
            return localVarFp.receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorporateDataFederationControllerApi - object-oriented interface
 */
export class CorporateDataFederationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Federate Corporate Data Request
     * @param {FederateCorporateDataRequest} federateCorporateDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public federateCorporateDataRequest(federateCorporateDataRequest: FederateCorporateDataRequest, options?: RawAxiosRequestConfig) {
        return CorporateDataFederationControllerApiFp(this.configuration).federateCorporateDataRequest(federateCorporateDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Receive federated corporate data response
     * @param {FederateCorporateDataResponse} federateCorporateDataResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public receiveCorporateDataResponse(federateCorporateDataResponse: FederateCorporateDataResponse, options?: RawAxiosRequestConfig) {
        return CorporateDataFederationControllerApiFp(this.configuration).receiveCorporateDataResponse(federateCorporateDataResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Receive federated corporate data status update
     * @param {FederateCorporateDataStatusUpdate} federateCorporateDataStatusUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate: FederateCorporateDataStatusUpdate, options?: RawAxiosRequestConfig) {
        return CorporateDataFederationControllerApiFp(this.configuration).receiveCorporateDataStatusUpdate(federateCorporateDataStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerControllerApi - axios parameter creator
 */
export const CustomerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListCustomersSortByEnum} [sortBy] 
         * @param {ListCustomersSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers: async (pageNumber?: number, limit?: number, sortBy?: ListCustomersSortByEnum, sortDirection?: ListCustomersSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerControllerApi - functional programming interface
 */
export const CustomerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListCustomersSortByEnum} [sortBy] 
         * @param {ListCustomersSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomers(pageNumber?: number, limit?: number, sortBy?: ListCustomersSortByEnum, sortDirection?: ListCustomersSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomers(pageNumber, limit, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerControllerApi.listCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerControllerApi - factory interface
 */
export const CustomerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListCustomersSortByEnum} [sortBy] 
         * @param {ListCustomersSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers(pageNumber?: number, limit?: number, sortBy?: ListCustomersSortByEnum, sortDirection?: ListCustomersSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationsResponse> {
            return localVarFp.listCustomers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerControllerApi - object-oriented interface
 */
export class CustomerControllerApi extends BaseAPI {
    /**
     * 
     * @summary List customers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ListCustomersSortByEnum} [sortBy] 
     * @param {ListCustomersSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCustomers(pageNumber?: number, limit?: number, sortBy?: ListCustomersSortByEnum, sortDirection?: ListCustomersSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return CustomerControllerApiFp(this.configuration).listCustomers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListCustomersSortByEnum = {
    DEFAULT: 'DEFAULT',
    PRODUCTS_CONNECTED: 'PRODUCTS_CONNECTED'
} as const;
export type ListCustomersSortByEnum = typeof ListCustomersSortByEnum[keyof typeof ListCustomersSortByEnum];
export const ListCustomersSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListCustomersSortDirectionEnum = typeof ListCustomersSortDirectionEnum[keyof typeof ListCustomersSortDirectionEnum];


/**
 * CustomerEmissionControllerApi - axios parameter creator
 */
export const CustomerEmissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductData: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('acceptEmissionProductData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('acceptEmissionProductData', 'productId', productId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/accept`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductDataProductIdOnly: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('acceptEmissionProductDataProductIdOnly', 'productId', productId)
            const localVarPath = `/api/customer/emission-requests/products/{productId}/accept`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createEmissionRequest: async (createEmissionRequest: CreateEmissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmissionRequest' is not null or undefined
            assertParamExists('createEmissionRequest', 'createEmissionRequest', createEmissionRequest)
            const localVarPath = `/api/customer/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsOfDataEmissionRequest: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('detailsOfDataEmissionRequest', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('detailsOfDataEmissionRequest', 'productId', productId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/details`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllEmissionRequests: async (fileName?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests/download/purchased`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment2: async (requestReference: string, productId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('downloadAttachment2', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('downloadAttachment2', 'productId', productId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment2', 'attachmentId', attachmentId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/attachments/{attachmentId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {DownloadEmissionRequestsForSuppliersFormatEnum} [format] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEmissionRequestsForSuppliers: async (supplierIds: ReadonlyArray<string>, fileName?: string, format?: DownloadEmissionRequestsForSuppliersFormatEnum, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierIds' is not null or undefined
            assertParamExists('downloadEmissionRequestsForSuppliers', 'supplierIds', supplierIds)
            const localVarPath = `/api/customer/emission-requests/download/purchased/{supplierIds}`
                .replace(`{${"supplierIds"}}`, encodeURIComponent(String(supplierIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReceivedEmissionRequests: async (fileName?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests/download/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetSentEmissionRequestsProductRequestAggregatedStatusEnum} [productRequestAggregatedStatus] 
         * @param {GetSentEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentEmissionRequests: async (pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, productRequestAggregatedStatus?: GetSentEmissionRequestsProductRequestAggregatedStatusEnum, sortDirection?: GetSentEmissionRequestsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (productRequestAggregatedStatus !== undefined) {
                localVarQueryParameter['productRequestAggregatedStatus'] = productRequestAggregatedStatus;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductData: async (requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'productId', productId)
            // verify required parameter 'emissionDataRejectionRequest' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'emissionDataRejectionRequest', emissionDataRejectionRequest)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/reject`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductDataProductIdOnly: async (productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('rejectEmissionProductDataProductIdOnly', 'productId', productId)
            // verify required parameter 'emissionDataRejectionRequest' is not null or undefined
            assertParamExists('rejectEmissionProductDataProductIdOnly', 'emissionDataRejectionRequest', emissionDataRejectionRequest)
            const localVarPath = `/api/customer/emission-requests/products/{productId}/reject`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerEmissionControllerApi - functional programming interface
 */
export const CustomerEmissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerEmissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptEmissionProductData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptEmissionProductData(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.acceptEmissionProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptEmissionProductDataProductIdOnly(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptEmissionProductDataProductIdOnly(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.acceptEmissionProductDataProductIdOnly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmissionRequest(createEmissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.createEmissionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailsOfDataEmissionRequest(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.detailsOfDataEmissionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllEmissionRequests(fileName, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.downloadAllEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment2(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment2(requestReference, productId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.downloadAttachment2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {DownloadEmissionRequestsForSuppliersFormatEnum} [format] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: DownloadEmissionRequestsForSuppliersFormatEnum, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.downloadEmissionRequestsForSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReceivedEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReceivedEmissionRequests(fileName, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.downloadReceivedEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetSentEmissionRequestsProductRequestAggregatedStatusEnum} [productRequestAggregatedStatus] 
         * @param {GetSentEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, productRequestAggregatedStatus?: GetSentEmissionRequestsProductRequestAggregatedStatusEnum, sortDirection?: GetSentEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.getSentEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.rejectEmissionProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectEmissionProductDataProductIdOnly(productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectEmissionProductDataProductIdOnly(productId, emissionDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerEmissionControllerApi.rejectEmissionProductDataProductIdOnly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerEmissionControllerApi - factory interface
 */
export const CustomerEmissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerEmissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptEmissionProductData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductDataProductIdOnly(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptEmissionProductDataProductIdOnly(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.createEmissionRequest(createEmissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.detailsOfDataEmissionRequest(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAllEmissionRequests(fileName, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment2(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAttachment2(requestReference, productId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {DownloadEmissionRequestsForSuppliersFormatEnum} [format] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: DownloadEmissionRequestsForSuppliersFormatEnum, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReceivedEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadReceivedEmissionRequests(fileName, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetSentEmissionRequestsProductRequestAggregatedStatusEnum} [productRequestAggregatedStatus] 
         * @param {GetSentEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, productRequestAggregatedStatus?: GetSentEmissionRequestsProductRequestAggregatedStatusEnum, sortDirection?: GetSentEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestSummaryResponse> {
            return localVarFp.getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product, using Product ID only
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductDataProductIdOnly(productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectEmissionProductDataProductIdOnly(productId, emissionDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerEmissionControllerApi - object-oriented interface
 */
export class CustomerEmissionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Accept the Emission Data for a Product
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptEmissionProductData(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).acceptEmissionProductData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept the Emission Data for a Product, using Product ID only
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptEmissionProductDataProductIdOnly(productId: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).acceptEmissionProductDataProductIdOnly(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Data Emission request
     * @param {CreateEmissionRequest} createEmissionRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).createEmissionRequest(createEmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Details of Product Emissions Data Request
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).detailsOfDataEmissionRequest(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {string} [fileName] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAllEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadAllEmissionRequests(fileName, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAttachment2(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadAttachment2(requestReference, productId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {ReadonlyArray<string>} supplierIds 
     * @param {string} [fileName] 
     * @param {DownloadEmissionRequestsForSuppliersFormatEnum} [format] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: DownloadEmissionRequestsForSuppliersFormatEnum, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {string} [fileName] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadReceivedEmissionRequests(fileName?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadReceivedEmissionRequests(fileName, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Summary of Emission Requests sent
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
     * @param {GetSentEmissionRequestsProductRequestAggregatedStatusEnum} [productRequestAggregatedStatus] 
     * @param {GetSentEmissionRequestsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, productRequestAggregatedStatus?: GetSentEmissionRequestsProductRequestAggregatedStatusEnum, sortDirection?: GetSentEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject the Emission Data for a Product
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject the Emission Data for a Product, using Product ID only
     * @param {string} productId 
     * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectEmissionProductDataProductIdOnly(productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return CustomerEmissionControllerApiFp(this.configuration).rejectEmissionProductDataProductIdOnly(productId, emissionDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const DownloadEmissionRequestsForSuppliersFormatEnum = {
    CSV: 'CSV',
    EXCEL: 'EXCEL',
    PATHFINDER: 'PATHFINDER'
} as const;
export type DownloadEmissionRequestsForSuppliersFormatEnum = typeof DownloadEmissionRequestsForSuppliersFormatEnum[keyof typeof DownloadEmissionRequestsForSuppliersFormatEnum];
export const GetSentEmissionRequestsProductRequestAggregatedStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
} as const;
export type GetSentEmissionRequestsProductRequestAggregatedStatusEnum = typeof GetSentEmissionRequestsProductRequestAggregatedStatusEnum[keyof typeof GetSentEmissionRequestsProductRequestAggregatedStatusEnum];
export const GetSentEmissionRequestsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetSentEmissionRequestsSortDirectionEnum = typeof GetSentEmissionRequestsSortDirectionEnum[keyof typeof GetSentEmissionRequestsSortDirectionEnum];


/**
 * CustomerProductControllerApi - axios parameter creator
 */
export const CustomerProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (productCreateRequest: ProductCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCreateRequest' is not null or undefined
            assertParamExists('createProduct', 'productCreateRequest', productCreateRequest)
            const localVarPath = `/api/customer/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import products from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts: async (file: File, allowWarnings?: boolean, dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importProducts', 'file', file)
            const localVarPath = `/api/customer/products/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (allowWarnings !== undefined) {
                localVarQueryParameter['allowWarnings'] = allowWarnings;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerProductControllerApi - functional programming interface
 */
export const CustomerProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(productCreateRequest: ProductCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(productCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerProductControllerApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import products from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProducts(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProducts(file, allowWarnings, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerProductControllerApi.importProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerProductControllerApi - factory interface
 */
export const CustomerProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(productCreateRequest: ProductCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductResponse> {
            return localVarFp.createProduct(productCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import products from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ProductImportResponse> {
            return localVarFp.importProducts(file, allowWarnings, dryRun, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerProductControllerApi - object-oriented interface
 */
export class CustomerProductControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create product
     * @param {ProductCreateRequest} productCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProduct(productCreateRequest: ProductCreateRequest, options?: RawAxiosRequestConfig) {
        return CustomerProductControllerApiFp(this.configuration).createProduct(productCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import products from file
     * @param {File} file 
     * @param {boolean} [allowWarnings] 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importProducts(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig) {
        return CustomerProductControllerApiFp(this.configuration).importProducts(file, allowWarnings, dryRun, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerShareControllerApi - axios parameter creator
 */
export const CustomerShareControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Share PCFs with a customer by emailing them an invitation to join the Product Ecosystem.
         * @param {CustomerShareRequest} customerShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        share: async (customerShareRequest: CustomerShareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerShareRequest' is not null or undefined
            assertParamExists('share', 'customerShareRequest', customerShareRequest)
            const localVarPath = `/api/customers/shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerShareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerShareControllerApi - functional programming interface
 */
export const CustomerShareControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerShareControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Share PCFs with a customer by emailing them an invitation to join the Product Ecosystem.
         * @param {CustomerShareRequest} customerShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async share(customerShareRequest: CustomerShareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.share(customerShareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerShareControllerApi.share']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerShareControllerApi - factory interface
 */
export const CustomerShareControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerShareControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Share PCFs with a customer by emailing them an invitation to join the Product Ecosystem.
         * @param {CustomerShareRequest} customerShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        share(customerShareRequest: CustomerShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.share(customerShareRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerShareControllerApi - object-oriented interface
 */
export class CustomerShareControllerApi extends BaseAPI {
    /**
     * 
     * @summary Share PCFs with a customer by emailing them an invitation to join the Product Ecosystem.
     * @param {CustomerShareRequest} customerShareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public share(customerShareRequest: CustomerShareRequest, options?: RawAxiosRequestConfig) {
        return CustomerShareControllerApiFp(this.configuration).share(customerShareRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerSupplierControllerApi - axios parameter creator
 */
export const CustomerSupplierControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliers: async (uUIDListRequest: UUIDListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uUIDListRequest' is not null or undefined
            assertParamExists('deleteSuppliers', 'uUIDListRequest', uUIDListRequest)
            const localVarPath = `/api/customer/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uUIDListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: async (supplierId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/customer/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {ListProductEmissionRequestsSortByEnum} [sortBy] 
         * @param {ListProductEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listProductEmissionRequests: async (supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: ListProductEmissionRequestsSortByEnum, sortDirection?: ListProductEmissionRequestsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listProductEmissionRequests', 'supplierId', supplierId)
            const localVarPath = `/api/customer/suppliers/{supplierId}/linked-products-with-emission-requests`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (emissionDataVerified) {
                localVarQueryParameter['emissionDataVerified'] = emissionDataVerified;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (emissionValueConfidence) {
                localVarQueryParameter['emissionValueConfidence'] = emissionValueConfidence;
            }

            if (emissionValueGranularity) {
                localVarQueryParameter['emissionValueGranularity'] = emissionValueGranularity;
            }

            if (shareOfPrimaryDataInEmissionFactorFrom !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorFrom'] = shareOfPrimaryDataInEmissionFactorFrom;
            }

            if (shareOfPrimaryDataInEmissionFactorTo !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorTo'] = shareOfPrimaryDataInEmissionFactorTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListSuppliersSortByEnum} [sortBy] 
         * @param {ListSuppliersSortDirectionEnum} [sortDirection] 
         * @param {string} [filterSupplierEmailDomain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers: async (pageNumber?: number, limit?: number, sortBy?: ListSuppliersSortByEnum, sortDirection?: ListSuppliersSortDirectionEnum, filterSupplierEmailDomain?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (filterSupplierEmailDomain !== undefined) {
                localVarQueryParameter['filterSupplierEmailDomain'] = filterSupplierEmailDomain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerSupplierControllerApi - functional programming interface
 */
export const CustomerSupplierControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerSupplierControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSuppliers(uUIDListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerSupplierControllerApi.deleteSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplier(supplierId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplier(supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerSupplierControllerApi.getSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {ListProductEmissionRequestsSortByEnum} [sortBy] 
         * @param {ListProductEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: ListProductEmissionRequestsSortByEnum, sortDirection?: ListProductEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerSupplierControllerApi.listProductEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListSuppliersSortByEnum} [sortBy] 
         * @param {ListSuppliersSortDirectionEnum} [sortDirection] 
         * @param {string} [filterSupplierEmailDomain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSuppliers(pageNumber?: number, limit?: number, sortBy?: ListSuppliersSortByEnum, sortDirection?: ListSuppliersSortDirectionEnum, filterSupplierEmailDomain?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuppliersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSuppliers(pageNumber, limit, sortBy, sortDirection, filterSupplierEmailDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerSupplierControllerApi.listSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerSupplierControllerApi - factory interface
 */
export const CustomerSupplierControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerSupplierControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSuppliers(uUIDListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier(supplierId: string, options?: RawAxiosRequestConfig): AxiosPromise<SupplierResponse> {
            return localVarFp.getSupplier(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {ListProductEmissionRequestsSortByEnum} [sortBy] 
         * @param {ListProductEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: ListProductEmissionRequestsSortByEnum, sortDirection?: ListProductEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<ProductEmissionDataRequestListResponse> {
            return localVarFp.listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListSuppliersSortByEnum} [sortBy] 
         * @param {ListSuppliersSortDirectionEnum} [sortDirection] 
         * @param {string} [filterSupplierEmailDomain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers(pageNumber?: number, limit?: number, sortBy?: ListSuppliersSortByEnum, sortDirection?: ListSuppliersSortDirectionEnum, filterSupplierEmailDomain?: string, options?: RawAxiosRequestConfig): AxiosPromise<SuppliersResponse> {
            return localVarFp.listSuppliers(pageNumber, limit, sortBy, sortDirection, filterSupplierEmailDomain, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerSupplierControllerApi - object-oriented interface
 */
export class CustomerSupplierControllerApi extends BaseAPI {
    /**
     * 
     * @summary Cancel pending emission requests and delete link between customer and supplier
     * @param {UUIDListRequest} uUIDListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: RawAxiosRequestConfig) {
        return CustomerSupplierControllerApiFp(this.configuration).deleteSuppliers(uUIDListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Supplier by Id
     * @param {string} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupplier(supplierId: string, options?: RawAxiosRequestConfig) {
        return CustomerSupplierControllerApiFp(this.configuration).getSupplier(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List products with emissions request information
     * @param {string} supplierId 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {string} [productInternalReference] 
     * @param {string} [productName] 
     * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
     * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
     * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
     * @param {ListProductEmissionRequestsSortByEnum} [sortBy] 
     * @param {ListProductEmissionRequestsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: ListProductEmissionRequestsSortByEnum, sortDirection?: ListProductEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return CustomerSupplierControllerApiFp(this.configuration).listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List suppliers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ListSuppliersSortByEnum} [sortBy] 
     * @param {ListSuppliersSortDirectionEnum} [sortDirection] 
     * @param {string} [filterSupplierEmailDomain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSuppliers(pageNumber?: number, limit?: number, sortBy?: ListSuppliersSortByEnum, sortDirection?: ListSuppliersSortDirectionEnum, filterSupplierEmailDomain?: string, options?: RawAxiosRequestConfig) {
        return CustomerSupplierControllerApiFp(this.configuration).listSuppliers(pageNumber, limit, sortBy, sortDirection, filterSupplierEmailDomain, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListProductEmissionRequestsSortByEnum = {
    PRODUCT_REQUEST_STATUS: 'PRODUCT_REQUEST_STATUS',
    INTERNAL_REFERENCE: 'INTERNAL_REFERENCE',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT',
    PRODUCT_UPDATED_AT: 'PRODUCT_UPDATED_AT',
    EMISSION_VALUE: 'EMISSION_VALUE'
} as const;
export type ListProductEmissionRequestsSortByEnum = typeof ListProductEmissionRequestsSortByEnum[keyof typeof ListProductEmissionRequestsSortByEnum];
export const ListProductEmissionRequestsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListProductEmissionRequestsSortDirectionEnum = typeof ListProductEmissionRequestsSortDirectionEnum[keyof typeof ListProductEmissionRequestsSortDirectionEnum];
export const ListSuppliersSortByEnum = {
    DEFAULT: 'DEFAULT',
    PRODUCTS_CONNECTED: 'PRODUCTS_CONNECTED'
} as const;
export type ListSuppliersSortByEnum = typeof ListSuppliersSortByEnum[keyof typeof ListSuppliersSortByEnum];
export const ListSuppliersSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListSuppliersSortDirectionEnum = typeof ListSuppliersSortDirectionEnum[keyof typeof ListSuppliersSortDirectionEnum];


/**
 * DataRequestFederationControllerApi - axios parameter creator
 */
export const DataRequestFederationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionData: async (federateEmissionDataRequest: FederateEmissionDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateEmissionDataRequest' is not null or undefined
            assertParamExists('federateEmissionData', 'federateEmissionDataRequest', federateEmissionDataRequest)
            const localVarPath = `/api/federation/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionDataStatusUpdate: async (organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('federateEmissionDataStatusUpdate', 'organisationId', organisationId)
            // verify required parameter 'federateEmissionStatusUpdateRequest' is not null or undefined
            assertParamExists('federateEmissionDataStatusUpdate', 'federateEmissionStatusUpdateRequest', federateEmissionStatusUpdateRequest)
            const localVarPath = `/api/federation/emission-requests/organisation/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionRequest: async (federateEmissionRequest: FederateEmissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateEmissionRequest' is not null or undefined
            assertParamExists('federateEmissionRequest', 'federateEmissionRequest', federateEmissionRequest)
            const localVarPath = `/api/federation/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataRequestFederationControllerApi - functional programming interface
 */
export const DataRequestFederationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataRequestFederationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionData(federateEmissionDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataRequestFederationControllerApi.federateEmissionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataRequestFederationControllerApi.federateEmissionDataStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionRequest(federateEmissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataRequestFederationControllerApi.federateEmissionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataRequestFederationControllerApi - factory interface
 */
export const DataRequestFederationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataRequestFederationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionData(federateEmissionDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionRequest(federateEmissionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataRequestFederationControllerApi - object-oriented interface
 */
export class DataRequestFederationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Federate Emission Data
     * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: RawAxiosRequestConfig) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionData(federateEmissionDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Federate Emission Data Product Status Update
     * @param {string} organisationId 
     * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Federate Emission Request
     * @param {FederateEmissionRequest} federateEmissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: RawAxiosRequestConfig) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionRequest(federateEmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FootprintControllerApi - axios parameter creator
 */
export const FootprintControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFootprint', 'id', id)
            const localVarPath = `/api/3/footprints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [geography] 
         * @param {ReadonlyArray<string>} [classification] 
         * @param {string} [status] 
         * @param {string} [validOn] 
         * @param {string} [validAfter] 
         * @param {string} [validBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints: async (pageNumber?: number, limit?: number, productId?: ReadonlyArray<string>, companyId?: ReadonlyArray<string>, geography?: ReadonlyArray<string>, classification?: ReadonlyArray<string>, status?: string, validOn?: string, validAfter?: string, validBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/3/footprints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }

            if (companyId) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (geography) {
                localVarQueryParameter['geography'] = geography;
            }

            if (classification) {
                localVarQueryParameter['classification'] = classification;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (validOn !== undefined) {
                localVarQueryParameter['validOn'] = validOn;
            }

            if (validAfter !== undefined) {
                localVarQueryParameter['validAfter'] = validAfter;
            }

            if (validBefore !== undefined) {
                localVarQueryParameter['validBefore'] = validBefore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CloudEventPayload} cloudEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveEvent: async (cloudEventPayload: CloudEventPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cloudEventPayload' is not null or undefined
            assertParamExists('receiveEvent', 'cloudEventPayload', cloudEventPayload)
            const localVarPath = `/api/3/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloudEventPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FootprintControllerApi - functional programming interface
 */
export const FootprintControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FootprintControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFootprint(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFootprintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFootprint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintControllerApi.getFootprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [geography] 
         * @param {ReadonlyArray<string>} [classification] 
         * @param {string} [status] 
         * @param {string} [validOn] 
         * @param {string} [validAfter] 
         * @param {string} [validBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFootprints(pageNumber?: number, limit?: number, productId?: ReadonlyArray<string>, companyId?: ReadonlyArray<string>, geography?: ReadonlyArray<string>, classification?: ReadonlyArray<string>, status?: string, validOn?: string, validAfter?: string, validBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FootprintListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFootprints(pageNumber, limit, productId, companyId, geography, classification, status, validOn, validAfter, validBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintControllerApi.listFootprints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CloudEventPayload} cloudEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveEvent(cloudEventPayload: CloudEventPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveEvent(cloudEventPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintControllerApi.receiveEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FootprintControllerApi - factory interface
 */
export const FootprintControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FootprintControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetFootprintResponse> {
            return localVarFp.getFootprint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [geography] 
         * @param {ReadonlyArray<string>} [classification] 
         * @param {string} [status] 
         * @param {string} [validOn] 
         * @param {string} [validAfter] 
         * @param {string} [validBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints(pageNumber?: number, limit?: number, productId?: ReadonlyArray<string>, companyId?: ReadonlyArray<string>, geography?: ReadonlyArray<string>, classification?: ReadonlyArray<string>, status?: string, validOn?: string, validAfter?: string, validBefore?: string, options?: RawAxiosRequestConfig): AxiosPromise<FootprintListResponse> {
            return localVarFp.listFootprints(pageNumber, limit, productId, companyId, geography, classification, status, validOn, validAfter, validBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CloudEventPayload} cloudEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveEvent(cloudEventPayload: CloudEventPayload, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.receiveEvent(cloudEventPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FootprintControllerApi - object-oriented interface
 */
export class FootprintControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFootprint(id: string, options?: RawAxiosRequestConfig) {
        return FootprintControllerApiFp(this.configuration).getFootprint(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<string>} [productId] 
     * @param {ReadonlyArray<string>} [companyId] 
     * @param {ReadonlyArray<string>} [geography] 
     * @param {ReadonlyArray<string>} [classification] 
     * @param {string} [status] 
     * @param {string} [validOn] 
     * @param {string} [validAfter] 
     * @param {string} [validBefore] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listFootprints(pageNumber?: number, limit?: number, productId?: ReadonlyArray<string>, companyId?: ReadonlyArray<string>, geography?: ReadonlyArray<string>, classification?: ReadonlyArray<string>, status?: string, validOn?: string, validAfter?: string, validBefore?: string, options?: RawAxiosRequestConfig) {
        return FootprintControllerApiFp(this.configuration).listFootprints(pageNumber, limit, productId, companyId, geography, classification, status, validOn, validAfter, validBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CloudEventPayload} cloudEventPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public receiveEvent(cloudEventPayload: CloudEventPayload, options?: RawAxiosRequestConfig) {
        return FootprintControllerApiFp(this.configuration).receiveEvent(cloudEventPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FootprintV2ControllerApi - axios parameter creator
 */
export const FootprintV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFootprint1', 'id', id)
            const localVarPath = `/api/2/footprints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListFootprints1SortByEnum} [sortBy] 
         * @param {ListFootprints1SortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints1: async (pageNumber?: number, limit?: number, sortBy?: ListFootprints1SortByEnum, sortDirection?: ListFootprints1SortDirectionEnum, companyId?: ReadonlyArray<string>, productId?: ReadonlyArray<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/2/footprints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (companyId) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (productId) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FootprintV2ControllerApi - functional programming interface
 */
export const FootprintV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FootprintV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintV2ControllerApi.getEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFootprint1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFootprintResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFootprint1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintV2ControllerApi.getFootprint1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListFootprints1SortByEnum} [sortBy] 
         * @param {ListFootprints1SortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFootprints1(pageNumber?: number, limit?: number, sortBy?: ListFootprints1SortByEnum, sortDirection?: ListFootprints1SortDirectionEnum, companyId?: ReadonlyArray<string>, productId?: ReadonlyArray<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FootprintListResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFootprints1(pageNumber, limit, sortBy, sortDirection, companyId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FootprintV2ControllerApi.listFootprints1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FootprintV2ControllerApi - factory interface
 */
export const FootprintV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FootprintV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetFootprintResponseV2> {
            return localVarFp.getFootprint1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ListFootprints1SortByEnum} [sortBy] 
         * @param {ListFootprints1SortDirectionEnum} [sortDirection] 
         * @param {ReadonlyArray<string>} [companyId] 
         * @param {ReadonlyArray<string>} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints1(pageNumber?: number, limit?: number, sortBy?: ListFootprints1SortByEnum, sortDirection?: ListFootprints1SortDirectionEnum, companyId?: ReadonlyArray<string>, productId?: ReadonlyArray<string>, options?: RawAxiosRequestConfig): AxiosPromise<FootprintListResponseV2> {
            return localVarFp.listFootprints1(pageNumber, limit, sortBy, sortDirection, companyId, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FootprintV2ControllerApi - object-oriented interface
 */
export class FootprintV2ControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvents(options?: RawAxiosRequestConfig) {
        return FootprintV2ControllerApiFp(this.configuration).getEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFootprint1(id: string, options?: RawAxiosRequestConfig) {
        return FootprintV2ControllerApiFp(this.configuration).getFootprint1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ListFootprints1SortByEnum} [sortBy] 
     * @param {ListFootprints1SortDirectionEnum} [sortDirection] 
     * @param {ReadonlyArray<string>} [companyId] 
     * @param {ReadonlyArray<string>} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listFootprints1(pageNumber?: number, limit?: number, sortBy?: ListFootprints1SortByEnum, sortDirection?: ListFootprints1SortDirectionEnum, companyId?: ReadonlyArray<string>, productId?: ReadonlyArray<string>, options?: RawAxiosRequestConfig) {
        return FootprintV2ControllerApiFp(this.configuration).listFootprints1(pageNumber, limit, sortBy, sortDirection, companyId, productId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListFootprints1SortByEnum = {
    PRODUCT_REQUEST_STATUS: 'PRODUCT_REQUEST_STATUS',
    INTERNAL_REFERENCE: 'INTERNAL_REFERENCE',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT',
    PRODUCT_UPDATED_AT: 'PRODUCT_UPDATED_AT',
    EMISSION_VALUE: 'EMISSION_VALUE'
} as const;
export type ListFootprints1SortByEnum = typeof ListFootprints1SortByEnum[keyof typeof ListFootprints1SortByEnum];
export const ListFootprints1SortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListFootprints1SortDirectionEnum = typeof ListFootprints1SortDirectionEnum[keyof typeof ListFootprints1SortDirectionEnum];


/**
 * FormTemplateControllerApi - axios parameter creator
 */
export const FormTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate a specific version of a form template
         * @param {string} id 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateVersion: async (id: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateVersion', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('activateVersion', 'versionId', versionId)
            const localVarPath = `/api/form-templates/{id}/versions/{versionId}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new form template
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate1: async (createFormTemplateRequest: CreateFormTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormTemplateRequest' is not null or undefined
            assertParamExists('createTemplate1', 'createFormTemplateRequest', createFormTemplateRequest)
            const localVarPath = `/api/form-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new version for a form template
         * @param {string} id 
         * @param {CreateFormTemplateVersionRequest} createFormTemplateVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersion: async (id: string, createFormTemplateVersionRequest: CreateFormTemplateVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createVersion', 'id', id)
            // verify required parameter 'createFormTemplateVersionRequest' is not null or undefined
            assertParamExists('createVersion', 'createFormTemplateVersionRequest', createFormTemplateVersionRequest)
            const localVarPath = `/api/form-templates/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormTemplateVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a form template by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplate', 'id', id)
            const localVarPath = `/api/form-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all versions of a form template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listVersions', 'id', id)
            const localVarPath = `/api/form-templates/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a form template
         * @param {string} id 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate1: async (id: string, createFormTemplateRequest: CreateFormTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTemplate1', 'id', id)
            // verify required parameter 'createFormTemplateRequest' is not null or undefined
            assertParamExists('updateTemplate1', 'createFormTemplateRequest', createFormTemplateRequest)
            const localVarPath = `/api/form-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormTemplateControllerApi - functional programming interface
 */
export const FormTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate a specific version of a form template
         * @param {string} id 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateVersion(id: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTemplateVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateVersion(id, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.activateVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new form template
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate1(createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate1(createFormTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.createTemplate1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new version for a form template
         * @param {string} id 
         * @param {CreateFormTemplateVersionRequest} createFormTemplateVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVersion(id: string, createFormTemplateVersionRequest: CreateFormTemplateVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTemplateVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVersion(id, createFormTemplateVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.createVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a form template by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<FormTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.listTemplates1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all versions of a form template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVersions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<FormTemplateVersionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVersions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.listVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a form template
         * @param {string} id 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate1(id: string, createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate1(id, createFormTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormTemplateControllerApi.updateTemplate1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormTemplateControllerApi - factory interface
 */
export const FormTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate a specific version of a form template
         * @param {string} id 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateVersion(id: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FormTemplateVersionResponse> {
            return localVarFp.activateVersion(id, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new form template
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate1(createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTemplateResponse> {
            return localVarFp.createTemplate1(createFormTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new version for a form template
         * @param {string} id 
         * @param {CreateFormTemplateVersionRequest} createFormTemplateVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersion(id: string, createFormTemplateVersionRequest: CreateFormTemplateVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTemplateVersionResponse> {
            return localVarFp.createVersion(id, createFormTemplateVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a form template by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FormTemplateResponse> {
            return localVarFp.getTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates1(options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<FormTemplateResponse>> {
            return localVarFp.listTemplates1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all versions of a form template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersions(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<FormTemplateVersionResponse>> {
            return localVarFp.listVersions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a form template
         * @param {string} id 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate1(id: string, createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTemplateResponse> {
            return localVarFp.updateTemplate1(id, createFormTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormTemplateControllerApi - object-oriented interface
 */
export class FormTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Activate a specific version of a form template
     * @param {string} id 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateVersion(id: string, versionId: string, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).activateVersion(id, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new form template
     * @param {CreateFormTemplateRequest} createFormTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTemplate1(createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).createTemplate1(createFormTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new version for a form template
     * @param {string} id 
     * @param {CreateFormTemplateVersionRequest} createFormTemplateVersionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createVersion(id: string, createFormTemplateVersionRequest: CreateFormTemplateVersionRequest, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).createVersion(id, createFormTemplateVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a form template by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTemplate(id: string, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).getTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all form templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTemplates1(options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).listTemplates1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all versions of a form template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listVersions(id: string, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).listVersions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a form template
     * @param {string} id 
     * @param {CreateFormTemplateRequest} createFormTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTemplate1(id: string, createFormTemplateRequest: CreateFormTemplateRequest, options?: RawAxiosRequestConfig) {
        return FormTemplateControllerApiFp(this.configuration).updateTemplate1(id, createFormTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LLMApi - axios parameter creator
 */
export const LLMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *              Send messages to Claude and receive responses. Supports conversation history             for multi-turn conversations. Uses Claude 4 Sonnet by default.              Available models:             - eu.anthropic.claude-sonnet-4-20250514-v1:0 (Claude 4 Sonnet - default)             - anthropic.claude-3-7-sonnet-20250219-v1:0 (Claude 3.7 Sonnet)             - us.anthropic.claude-3-5-sonnet-20241022-v2:0 (Claude 3.5 Sonnet V2)             - anthropic.claude-3-5-sonnet-20240620-v1:0 (Claude 3.5 Sonnet)             - anthropic.claude-3-haiku-20240307-v1:0 (Claude 3 Haiku - faster, cheaper)         
         * @summary Chat with Claude via AWS Bedrock
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat: async (chatRequest: ChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chat', 'chatRequest', chatRequest)
            const localVarPath = `/api/llm/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LLMApi - functional programming interface
 */
export const LLMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LLMApiAxiosParamCreator(configuration)
    return {
        /**
         *              Send messages to Claude and receive responses. Supports conversation history             for multi-turn conversations. Uses Claude 4 Sonnet by default.              Available models:             - eu.anthropic.claude-sonnet-4-20250514-v1:0 (Claude 4 Sonnet - default)             - anthropic.claude-3-7-sonnet-20250219-v1:0 (Claude 3.7 Sonnet)             - us.anthropic.claude-3-5-sonnet-20241022-v2:0 (Claude 3.5 Sonnet V2)             - anthropic.claude-3-5-sonnet-20240620-v1:0 (Claude 3.5 Sonnet)             - anthropic.claude-3-haiku-20240307-v1:0 (Claude 3 Haiku - faster, cheaper)         
         * @summary Chat with Claude via AWS Bedrock
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chat(chatRequest: ChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chat(chatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.chat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LLMApi - factory interface
 */
export const LLMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LLMApiFp(configuration)
    return {
        /**
         *              Send messages to Claude and receive responses. Supports conversation history             for multi-turn conversations. Uses Claude 4 Sonnet by default.              Available models:             - eu.anthropic.claude-sonnet-4-20250514-v1:0 (Claude 4 Sonnet - default)             - anthropic.claude-3-7-sonnet-20250219-v1:0 (Claude 3.7 Sonnet)             - us.anthropic.claude-3-5-sonnet-20241022-v2:0 (Claude 3.5 Sonnet V2)             - anthropic.claude-3-5-sonnet-20240620-v1:0 (Claude 3.5 Sonnet)             - anthropic.claude-3-haiku-20240307-v1:0 (Claude 3 Haiku - faster, cheaper)         
         * @summary Chat with Claude via AWS Bedrock
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat(chatRequest: ChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatResponse> {
            return localVarFp.chat(chatRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LLMApi - object-oriented interface
 */
export class LLMApi extends BaseAPI {
    /**
     *              Send messages to Claude and receive responses. Supports conversation history             for multi-turn conversations. Uses Claude 4 Sonnet by default.              Available models:             - eu.anthropic.claude-sonnet-4-20250514-v1:0 (Claude 4 Sonnet - default)             - anthropic.claude-3-7-sonnet-20250219-v1:0 (Claude 3.7 Sonnet)             - us.anthropic.claude-3-5-sonnet-20241022-v2:0 (Claude 3.5 Sonnet V2)             - anthropic.claude-3-5-sonnet-20240620-v1:0 (Claude 3.5 Sonnet)             - anthropic.claude-3-haiku-20240307-v1:0 (Claude 3 Haiku - faster, cheaper)         
     * @summary Chat with Claude via AWS Bedrock
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chat(chatRequest: ChatRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).chat(chatRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OpenIdDiscoveryControllerApi - axios parameter creator
 */
export const OpenIdDiscoveryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenIdConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/.well-known/openid-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenIdDiscoveryControllerApi - functional programming interface
 */
export const OpenIdDiscoveryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenIdDiscoveryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpenIdConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpenIdConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpenIdDiscoveryControllerApi.getOpenIdConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OpenIdDiscoveryControllerApi - factory interface
 */
export const OpenIdDiscoveryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenIdDiscoveryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenIdConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getOpenIdConfiguration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OpenIdDiscoveryControllerApi - object-oriented interface
 */
export class OpenIdDiscoveryControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOpenIdConfiguration(options?: RawAxiosRequestConfig) {
        return OpenIdDiscoveryControllerApiFp(this.configuration).getOpenIdConfiguration(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrgInvitationUpdateFederationControllerApi - axios parameter creator
 */
export const OrgInvitationUpdateFederationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateInvitationStatusUpdate: async (federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'federatedInvitationStatusUpdatedRequest' is not null or undefined
            assertParamExists('federateInvitationStatusUpdate', 'federatedInvitationStatusUpdatedRequest', federatedInvitationStatusUpdatedRequest)
            const localVarPath = `/api/federation/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federatedInvitationStatusUpdatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgInvitationUpdateFederationControllerApi - functional programming interface
 */
export const OrgInvitationUpdateFederationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrgInvitationUpdateFederationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgInvitationUpdateFederationControllerApi.federateInvitationStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrgInvitationUpdateFederationControllerApi - factory interface
 */
export const OrgInvitationUpdateFederationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrgInvitationUpdateFederationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgInvitationUpdateFederationControllerApi - object-oriented interface
 */
export class OrgInvitationUpdateFederationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Federate Invitation Status Update
     * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: RawAxiosRequestConfig) {
        return OrgInvitationUpdateFederationControllerApiFp(this.configuration).federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationAttachmentControllerApi - axios parameter creator
 */
export const OrganizationAttachmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachments: async (attachmentsDeleteRequest: AttachmentsDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentsDeleteRequest' is not null or undefined
            assertParamExists('deleteAttachments', 'attachmentsDeleteRequest', attachmentsDeleteRequest)
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads an attachment
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment1: async (attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment1', 'attachmentId', attachmentId)
            const localVarPath = `/api/organisation/attachments/{attachmentId}/download`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachments: async (pageNumber?: number, limit?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAttachment', 'file', file)
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationAttachmentControllerApi - functional programming interface
 */
export const OrganizationAttachmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationAttachmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentsDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachments(attachmentsDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationAttachmentControllerApi.deleteAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads an attachment
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment1(attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment1(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationAttachmentControllerApi.downloadAttachment1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAttachments(pageNumber, limit, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationAttachmentControllerApi.listAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationAttachmentControllerApi.uploadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationAttachmentControllerApi - factory interface
 */
export const OrganizationAttachmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationAttachmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentsDeleteResponse> {
            return localVarFp.deleteAttachments(attachmentsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads an attachment
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment1(attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAttachment1(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentListResponse> {
            return localVarFp.listAttachments(pageNumber, limit, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(file: File, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentInfo> {
            return localVarFp.uploadAttachment(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationAttachmentControllerApi - object-oriented interface
 */
export class OrganizationAttachmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary Safe delete attachments
     * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: RawAxiosRequestConfig) {
        return OrganizationAttachmentControllerApiFp(this.configuration).deleteAttachments(attachmentsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads an attachment
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAttachment1(attachmentId: string, options?: RawAxiosRequestConfig) {
        return OrganizationAttachmentControllerApiFp(this.configuration).downloadAttachment1(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Attachments
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: RawAxiosRequestConfig) {
        return OrganizationAttachmentControllerApiFp(this.configuration).listAttachments(pageNumber, limit, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads an attachment
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadAttachment(file: File, options?: RawAxiosRequestConfig) {
        return OrganizationAttachmentControllerApiFp(this.configuration).uploadAttachment(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationControllerApi - axios parameter creator
 */
export const OrganizationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedRequestDataOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/emission-request-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Catena-X credentials for the current Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatenaXCredentials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/catena-x-credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get own Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrganisation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Catena-X credentials for the current Organization
         * @param {CatenaXCredentialsUpdateRequest} catenaXCredentialsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatenaXCredentials: async (catenaXCredentialsUpdateRequest: CatenaXCredentialsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catenaXCredentialsUpdateRequest' is not null or undefined
            assertParamExists('updateCatenaXCredentials', 'catenaXCredentialsUpdateRequest', catenaXCredentialsUpdateRequest)
            const localVarPath = `/api/organisation/catena-x-credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catenaXCredentialsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization name
         * @param {UpdateOrganizationNameRequest} updateOrganizationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationName: async (updateOrganizationNameRequest: UpdateOrganizationNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOrganizationNameRequest' is not null or undefined
            assertParamExists('updateOrganisationName', 'updateOrganizationNameRequest', updateOrganizationNameRequest)
            const localVarPath = `/api/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationControllerApi - functional programming interface
 */
export const OrganizationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedRequestDataOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedRequestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedRequestDataOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationControllerApi.getAggregatedRequestDataOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Catena-X credentials for the current Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatenaXCredentials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatenaXCredentialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatenaXCredentials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationControllerApi.getCatenaXCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get own Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnOrganisation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnOrganisation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationControllerApi.getOwnOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Catena-X credentials for the current Organization
         * @param {CatenaXCredentialsUpdateRequest} catenaXCredentialsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCatenaXCredentials(catenaXCredentialsUpdateRequest: CatenaXCredentialsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCatenaXCredentials(catenaXCredentialsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationControllerApi.updateCatenaXCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Organization name
         * @param {UpdateOrganizationNameRequest} updateOrganizationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganisationName(updateOrganizationNameRequest: UpdateOrganizationNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganisationName(updateOrganizationNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationControllerApi.updateOrganisationName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationControllerApi - factory interface
 */
export const OrganizationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedRequestDataOverview(options?: RawAxiosRequestConfig): AxiosPromise<AggregatedRequestDataResponse> {
            return localVarFp.getAggregatedRequestDataOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Catena-X credentials for the current Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatenaXCredentials(options?: RawAxiosRequestConfig): AxiosPromise<CatenaXCredentialsResponse> {
            return localVarFp.getCatenaXCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get own Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrganisation(options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.getOwnOrganisation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Catena-X credentials for the current Organization
         * @param {CatenaXCredentialsUpdateRequest} catenaXCredentialsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatenaXCredentials(catenaXCredentialsUpdateRequest: CatenaXCredentialsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCatenaXCredentials(catenaXCredentialsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization name
         * @param {UpdateOrganizationNameRequest} updateOrganizationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationName(updateOrganizationNameRequest: UpdateOrganizationNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.updateOrganisationName(updateOrganizationNameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationControllerApi - object-oriented interface
 */
export class OrganizationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve aggregated emission request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAggregatedRequestDataOverview(options?: RawAxiosRequestConfig) {
        return OrganizationControllerApiFp(this.configuration).getAggregatedRequestDataOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Catena-X credentials for the current Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCatenaXCredentials(options?: RawAxiosRequestConfig) {
        return OrganizationControllerApiFp(this.configuration).getCatenaXCredentials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get own Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOwnOrganisation(options?: RawAxiosRequestConfig) {
        return OrganizationControllerApiFp(this.configuration).getOwnOrganisation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Catena-X credentials for the current Organization
     * @param {CatenaXCredentialsUpdateRequest} catenaXCredentialsUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCatenaXCredentials(catenaXCredentialsUpdateRequest: CatenaXCredentialsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OrganizationControllerApiFp(this.configuration).updateCatenaXCredentials(catenaXCredentialsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization name
     * @param {UpdateOrganizationNameRequest} updateOrganizationNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganisationName(updateOrganizationNameRequest: UpdateOrganizationNameRequest, options?: RawAxiosRequestConfig) {
        return OrganizationControllerApiFp(this.configuration).updateOrganisationName(updateOrganizationNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationInvitationControllerApi - axios parameter creator
 */
export const OrganizationInvitationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('acceptInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/organisation/access-management/{invitationId}/accept`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (createInvitationsRequest: CreateInvitationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationsRequest' is not null or undefined
            assertParamExists('createInvitation', 'createInvitationsRequest', createInvitationsRequest)
            const localVarPath = `/api/organisation/access-management/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send invitations (Deprecated - use /v2)
         * @param {DeprecatedCreateInvitationsRequest} deprecatedCreateInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createInvitationDeprecated: async (deprecatedCreateInvitationsRequest: DeprecatedCreateInvitationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deprecatedCreateInvitationsRequest' is not null or undefined
            assertParamExists('createInvitationDeprecated', 'deprecatedCreateInvitationsRequest', deprecatedCreateInvitationsRequest)
            const localVarPath = `/api/organisation/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deprecatedCreateInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation: async (invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('declineInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/organisation/access-management/{invitationId}/decline`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedInvitations: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/access-management/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>} [accessResponseStatus] 
         * @param {ListSentInvitationsSortByEnum} [sortBy] 
         * @param {ListSentInvitationsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSentInvitations: async (pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>, sortBy?: ListSentInvitationsSortByEnum, sortDirection?: ListSentInvitationsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/access-management/sent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accessResponseStatus) {
                localVarQueryParameter['accessResponseStatus'] = accessResponseStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrgInvitationsAgain: async (sendInvitationsAgainRequest: SendInvitationsAgainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendInvitationsAgainRequest' is not null or undefined
            assertParamExists('sendOrgInvitationsAgain', 'sendInvitationsAgainRequest', sendInvitationsAgainRequest)
            const localVarPath = `/api/organisation/access-management/send-again`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvitationsAgainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationInvitationControllerApi - functional programming interface
 */
export const OrganizationInvitationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationInvitationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.acceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(createInvitationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send invitations (Deprecated - use /v2)
         * @param {DeprecatedCreateInvitationsRequest} deprecatedCreateInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createInvitationDeprecated(deprecatedCreateInvitationsRequest: DeprecatedCreateInvitationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitationDeprecated(deprecatedCreateInvitationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.createInvitationDeprecated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineInvitation(invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineInvitation(invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.declineInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReceivedInvitations(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationInvitationReceivedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReceivedInvitations(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.listReceivedInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>} [accessResponseStatus] 
         * @param {ListSentInvitationsSortByEnum} [sortBy] 
         * @param {ListSentInvitationsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>, sortBy?: ListSentInvitationsSortByEnum, sortDirection?: ListSentInvitationsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationInvitationSentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.listSentInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOrgInvitationsAgain(sendInvitationsAgainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationInvitationControllerApi.sendOrgInvitationsAgain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationInvitationControllerApi - factory interface
 */
export const OrganizationInvitationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationInvitationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(invitationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTokensResponse> {
            return localVarFp.createInvitation(createInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send invitations (Deprecated - use /v2)
         * @param {DeprecatedCreateInvitationsRequest} deprecatedCreateInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createInvitationDeprecated(deprecatedCreateInvitationsRequest: DeprecatedCreateInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTokensResponse> {
            return localVarFp.createInvitationDeprecated(deprecatedCreateInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation(invitationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedInvitations(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationInvitationReceivedListResponse> {
            return localVarFp.listReceivedInvitations(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>} [accessResponseStatus] 
         * @param {ListSentInvitationsSortByEnum} [sortBy] 
         * @param {ListSentInvitationsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>, sortBy?: ListSentInvitationsSortByEnum, sortDirection?: ListSentInvitationsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationInvitationSentListResponse> {
            return localVarFp.listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendOrgInvitationsAgain(sendInvitationsAgainRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationInvitationControllerApi - object-oriented interface
 */
export class OrganizationInvitationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Accepts an invitation
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptInvitation(invitationId: string, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).acceptInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send invitations
     * @param {CreateInvitationsRequest} createInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).createInvitation(createInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send invitations (Deprecated - use /v2)
     * @param {DeprecatedCreateInvitationsRequest} deprecatedCreateInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public createInvitationDeprecated(deprecatedCreateInvitationsRequest: DeprecatedCreateInvitationsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).createInvitationDeprecated(deprecatedCreateInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Declines an invitation
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineInvitation(invitationId: string, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).declineInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List received invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReceivedInvitations(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).listReceivedInvitations(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List sent invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>} [accessResponseStatus] 
     * @param {ListSentInvitationsSortByEnum} [sortBy] 
     * @param {ListSentInvitationsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<ListSentInvitationsAccessResponseStatusEnum>, sortBy?: ListSentInvitationsSortByEnum, sortDirection?: ListSentInvitationsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send organisation invitations again
     * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: RawAxiosRequestConfig) {
        return OrganizationInvitationControllerApiFp(this.configuration).sendOrgInvitationsAgain(sendInvitationsAgainRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListSentInvitationsAccessResponseStatusEnum = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    PENDING: 'PENDING'
} as const;
export type ListSentInvitationsAccessResponseStatusEnum = typeof ListSentInvitationsAccessResponseStatusEnum[keyof typeof ListSentInvitationsAccessResponseStatusEnum];
export const ListSentInvitationsSortByEnum = {
    CREATED_AT: 'CREATED_AT'
} as const;
export type ListSentInvitationsSortByEnum = typeof ListSentInvitationsSortByEnum[keyof typeof ListSentInvitationsSortByEnum];
export const ListSentInvitationsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListSentInvitationsSortDirectionEnum = typeof ListSentInvitationsSortDirectionEnum[keyof typeof ListSentInvitationsSortDirectionEnum];


/**
 * OrganizationLookupControllerApi - axios parameter creator
 */
export const OrganizationLookupControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the PE organisation id for a user email and whether it EXISTS, is a GHOST, or is NOT_FOUND. Does not require a connected organisation. The email defaults to the caller\'s own email, and a caller may only look up an email on their own email domain, unless they belong to a configured administrator email domain.
         * @summary Look up the PE organisation behind a user email
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupOrganisationByEmail: async (email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/registration/organisation-lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the PE organisation id for a user email, creating a ghost organisation if none exists yet. Does not require the caller to already be connected to a PE organisation. The email defaults to the caller\'s own email, and a caller may only resolve an email on their own email domain, unless they belong to a configured administrator email domain. The optional organisationName is only used when a ghost is created.
         * @summary Resolve the PE organisation behind a user email, creating a ghost if none exists
         * @param {string} [email] 
         * @param {string} [organisationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveOrCreateOrganisationByEmail: async (email?: string, organisationName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/registration/organisation-resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (organisationName !== undefined) {
                localVarQueryParameter['organisationName'] = organisationName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationLookupControllerApi - functional programming interface
 */
export const OrganizationLookupControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationLookupControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the PE organisation id for a user email and whether it EXISTS, is a GHOST, or is NOT_FOUND. Does not require a connected organisation. The email defaults to the caller\'s own email, and a caller may only look up an email on their own email domain, unless they belong to a configured administrator email domain.
         * @summary Look up the PE organisation behind a user email
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupOrganisationByEmail(email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationLookupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupOrganisationByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationLookupControllerApi.lookupOrganisationByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the PE organisation id for a user email, creating a ghost organisation if none exists yet. Does not require the caller to already be connected to a PE organisation. The email defaults to the caller\'s own email, and a caller may only resolve an email on their own email domain, unless they belong to a configured administrator email domain. The optional organisationName is only used when a ghost is created.
         * @summary Resolve the PE organisation behind a user email, creating a ghost if none exists
         * @param {string} [email] 
         * @param {string} [organisationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveOrCreateOrganisationByEmail(email?: string, organisationName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResolveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveOrCreateOrganisationByEmail(email, organisationName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationLookupControllerApi.resolveOrCreateOrganisationByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationLookupControllerApi - factory interface
 */
export const OrganizationLookupControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationLookupControllerApiFp(configuration)
    return {
        /**
         * Returns the PE organisation id for a user email and whether it EXISTS, is a GHOST, or is NOT_FOUND. Does not require a connected organisation. The email defaults to the caller\'s own email, and a caller may only look up an email on their own email domain, unless they belong to a configured administrator email domain.
         * @summary Look up the PE organisation behind a user email
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupOrganisationByEmail(email?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationLookupResponse> {
            return localVarFp.lookupOrganisationByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the PE organisation id for a user email, creating a ghost organisation if none exists yet. Does not require the caller to already be connected to a PE organisation. The email defaults to the caller\'s own email, and a caller may only resolve an email on their own email domain, unless they belong to a configured administrator email domain. The optional organisationName is only used when a ghost is created.
         * @summary Resolve the PE organisation behind a user email, creating a ghost if none exists
         * @param {string} [email] 
         * @param {string} [organisationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveOrCreateOrganisationByEmail(email?: string, organisationName?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResolveResponse> {
            return localVarFp.resolveOrCreateOrganisationByEmail(email, organisationName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationLookupControllerApi - object-oriented interface
 */
export class OrganizationLookupControllerApi extends BaseAPI {
    /**
     * Returns the PE organisation id for a user email and whether it EXISTS, is a GHOST, or is NOT_FOUND. Does not require a connected organisation. The email defaults to the caller\'s own email, and a caller may only look up an email on their own email domain, unless they belong to a configured administrator email domain.
     * @summary Look up the PE organisation behind a user email
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public lookupOrganisationByEmail(email?: string, options?: RawAxiosRequestConfig) {
        return OrganizationLookupControllerApiFp(this.configuration).lookupOrganisationByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the PE organisation id for a user email, creating a ghost organisation if none exists yet. Does not require the caller to already be connected to a PE organisation. The email defaults to the caller\'s own email, and a caller may only resolve an email on their own email domain, unless they belong to a configured administrator email domain. The optional organisationName is only used when a ghost is created.
     * @summary Resolve the PE organisation behind a user email, creating a ghost if none exists
     * @param {string} [email] 
     * @param {string} [organisationName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolveOrCreateOrganisationByEmail(email?: string, organisationName?: string, options?: RawAxiosRequestConfig) {
        return OrganizationLookupControllerApiFp(this.configuration).resolveOrCreateOrganisationByEmail(email, organisationName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationUserAccessManagementControllerApi - axios parameter creator
 */
export const OrganizationUserAccessManagementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve or deny access request
         * @param {AccessRequestAnswerRequest} accessRequestAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerAccessRequest: async (accessRequestAnswerRequest: AccessRequestAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessRequestAnswerRequest' is not null or undefined
            assertParamExists('answerAccessRequest', 'accessRequestAnswerRequest', accessRequestAnswerRequest)
            const localVarPath = `/api/organisation/users/access-management/access-requests/answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessRequestAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation: async (createInvitationsRequest: CreateInvitationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationsRequest' is not null or undefined
            assertParamExists('createUserInvitation', 'createInvitationsRequest', createInvitationsRequest)
            const localVarPath = `/api/organisation/users/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation: async (emailListRequest: EmailListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('deleteUserInvitation', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/organisation/users/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users/access-management/access-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingUserInvitation: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users/access-management/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitationsAgain: async (emailListRequest: EmailListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('sendUserInvitationsAgain', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/organisation/users/access-management/send-again`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationUserAccessManagementControllerApi - functional programming interface
 */
export const OrganizationUserAccessManagementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationUserAccessManagementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve or deny access request
         * @param {AccessRequestAnswerRequest} accessRequestAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerAccessRequest(accessRequestAnswerRequest: AccessRequestAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerAccessRequest(accessRequestAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.answerAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserInvitation(createInvitationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.createUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserInvitation(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserInvitation(emailListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.deleteUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessRequests(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessRequests(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.listAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPendingUserInvitation(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInvitationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPendingUserInvitation(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.listPendingUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserInvitationsAgain(emailListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserAccessManagementControllerApi.sendUserInvitationsAgain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationUserAccessManagementControllerApi - factory interface
 */
export const OrganizationUserAccessManagementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationUserAccessManagementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve or deny access request
         * @param {AccessRequestAnswerRequest} accessRequestAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerAccessRequest(accessRequestAnswerRequest: AccessRequestAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailTokensResponse> {
            return localVarFp.answerAccessRequest(accessRequestAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUserInvitation(createInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserInvitation(emailListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestListResponse> {
            return localVarFp.listAccessRequests(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingUserInvitation(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<UserInvitationListResponse> {
            return localVarFp.listPendingUserInvitation(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendUserInvitationsAgain(emailListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationUserAccessManagementControllerApi - object-oriented interface
 */
export class OrganizationUserAccessManagementControllerApi extends BaseAPI {
    /**
     * 
     * @summary Approve or deny access request
     * @param {AccessRequestAnswerRequest} accessRequestAnswerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public answerAccessRequest(accessRequestAnswerRequest: AccessRequestAnswerRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).answerAccessRequest(accessRequestAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send user invitations
     * @param {CreateInvitationsRequest} createInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).createUserInvitation(createInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete user invitations
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUserInvitation(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).deleteUserInvitation(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access requests
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAccessRequests(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).listAccessRequests(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List pending invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPendingUserInvitation(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).listPendingUserInvitation(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send user invitations again
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserAccessManagementControllerApiFp(this.configuration).sendUserInvitationsAgain(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationUserControllerApi - axios parameter creator
 */
export const OrganizationUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/api/organisation/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userUpdateRequest: UserUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdateRequest' is not null or undefined
            assertParamExists('updateUser', 'userUpdateRequest', userUpdateRequest)
            const localVarPath = `/api/organisation/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccessLevel: async (updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserAccessLevelRequest' is not null or undefined
            assertParamExists('updateUserAccessLevel', 'updateUserAccessLevelRequest', updateUserAccessLevelRequest)
            const localVarPath = `/api/organisation/users/update-access-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccessLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationUserControllerApi - functional programming interface
 */
export const OrganizationUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserControllerApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserControllerApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserControllerApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserControllerApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccessLevel(updateUserAccessLevelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUserControllerApi.updateUserAccessLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationUserControllerApi - factory interface
 */
export const OrganizationUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<UserListResponse> {
            return localVarFp.listUsers(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUser(userUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserAccessLevel(updateUserAccessLevelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationUserControllerApi - object-oriented interface
 */
export class OrganizationUserControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get current logged in user user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return OrganizationUserControllerApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an organisation user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUser(userId: string, options?: RawAxiosRequestConfig) {
        return OrganizationUserControllerApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List organisation users
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUsers(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizationUserControllerApiFp(this.configuration).listUsers(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an organisation user
     * @param {UserUpdateRequest} userUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserControllerApiFp(this.configuration).updateUser(userUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user access level
     * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: RawAxiosRequestConfig) {
        return OrganizationUserControllerApiFp(this.configuration).updateUserAccessLevel(updateUserAccessLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PactAuthControllerApi - axios parameter creator
 */
export const PactAuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Issue PACT OAuth2 bearer token (client_credentials grant)
         * @param {string} grantType 
         * @param {string} [authorization] 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueToken: async (grantType: string, authorization?: string, clientId?: string, clientSecret?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantType' is not null or undefined
            assertParamExists('issueToken', 'grantType', grantType)
            const localVarPath = `/auth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (clientId !== undefined) { 
                localVarFormParams.set('client_id', clientId as any);
            }
    
            if (clientSecret !== undefined) { 
                localVarFormParams.set('client_secret', clientSecret as any);
            }
    
            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PactAuthControllerApi - functional programming interface
 */
export const PactAuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PactAuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Issue PACT OAuth2 bearer token (client_credentials grant)
         * @param {string} grantType 
         * @param {string} [authorization] 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueToken(grantType: string, authorization?: string, clientId?: string, clientSecret?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueToken(grantType, authorization, clientId, clientSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactAuthControllerApi.issueToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PactAuthControllerApi - factory interface
 */
export const PactAuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PactAuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Issue PACT OAuth2 bearer token (client_credentials grant)
         * @param {string} grantType 
         * @param {string} [authorization] 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueToken(grantType: string, authorization?: string, clientId?: string, clientSecret?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.issueToken(grantType, authorization, clientId, clientSecret, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PactAuthControllerApi - object-oriented interface
 */
export class PactAuthControllerApi extends BaseAPI {
    /**
     * 
     * @summary Issue PACT OAuth2 bearer token (client_credentials grant)
     * @param {string} grantType 
     * @param {string} [authorization] 
     * @param {string} [clientId] 
     * @param {string} [clientSecret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public issueToken(grantType: string, authorization?: string, clientId?: string, clientSecret?: string, options?: RawAxiosRequestConfig) {
        return PactAuthControllerApiFp(this.configuration).issueToken(grantType, authorization, clientId, clientSecret, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PactCredentialControllerApi - axios parameter creator
 */
export const PactCredentialControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a credential the caller\'s org owns to read the footprints shared with it
         * @param {PactReceivedShareCredentialRequest} [pactReceivedShareCredentialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentialForReceivedShare: async (pactReceivedShareCredentialRequest?: PactReceivedShareCredentialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pact/credentials/received-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pactReceivedShareCredentialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a PACT credential and all its issued tokens
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential: async (credentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('deleteCredential', 'credentialId', credentialId)
            const localVarPath = `/api/pact/credentials/{credentialId}`
                .replace(`{${"credentialId"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the credentials the caller\'s org owns to read the footprints shared with it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedShareCredentials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pact/credentials/received-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PactCredentialControllerApi - functional programming interface
 */
export const PactCredentialControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PactCredentialControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a credential the caller\'s org owns to read the footprints shared with it
         * @param {PactReceivedShareCredentialRequest} [pactReceivedShareCredentialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCredentialForReceivedShare(pactReceivedShareCredentialRequest?: PactReceivedShareCredentialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PactCredentialCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCredentialForReceivedShare(pactReceivedShareCredentialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactCredentialControllerApi.createCredentialForReceivedShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a PACT credential and all its issued tokens
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCredential(credentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCredential(credentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactCredentialControllerApi.deleteCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the credentials the caller\'s org owns to read the footprints shared with it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReceivedShareCredentials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<PactCredentialResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReceivedShareCredentials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactCredentialControllerApi.listReceivedShareCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PactCredentialControllerApi - factory interface
 */
export const PactCredentialControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PactCredentialControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a credential the caller\'s org owns to read the footprints shared with it
         * @param {PactReceivedShareCredentialRequest} [pactReceivedShareCredentialRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentialForReceivedShare(pactReceivedShareCredentialRequest?: PactReceivedShareCredentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<PactCredentialCreatedResponse> {
            return localVarFp.createCredentialForReceivedShare(pactReceivedShareCredentialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a PACT credential and all its issued tokens
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential(credentialId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCredential(credentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the credentials the caller\'s org owns to read the footprints shared with it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedShareCredentials(options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<PactCredentialResponse>> {
            return localVarFp.listReceivedShareCredentials(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PactCredentialControllerApi - object-oriented interface
 */
export class PactCredentialControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create a credential the caller\'s org owns to read the footprints shared with it
     * @param {PactReceivedShareCredentialRequest} [pactReceivedShareCredentialRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCredentialForReceivedShare(pactReceivedShareCredentialRequest?: PactReceivedShareCredentialRequest, options?: RawAxiosRequestConfig) {
        return PactCredentialControllerApiFp(this.configuration).createCredentialForReceivedShare(pactReceivedShareCredentialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a PACT credential and all its issued tokens
     * @param {string} credentialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCredential(credentialId: string, options?: RawAxiosRequestConfig) {
        return PactCredentialControllerApiFp(this.configuration).deleteCredential(credentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the credentials the caller\'s org owns to read the footprints shared with it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReceivedShareCredentials(options?: RawAxiosRequestConfig) {
        return PactCredentialControllerApiFp(this.configuration).listReceivedShareCredentials(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PactOutboundCredentialControllerApi - axios parameter creator
 */
export const PactOutboundCredentialControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an outbound PACT credential used to authenticate into an external PACT tool
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutboundCredential: async (pactOutboundCredentialRequest: PactOutboundCredentialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pactOutboundCredentialRequest' is not null or undefined
            assertParamExists('createOutboundCredential', 'pactOutboundCredentialRequest', pactOutboundCredentialRequest)
            const localVarPath = `/api/pact/outbound-credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pactOutboundCredentialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an outbound PACT credential
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutboundCredential: async (credentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('deleteOutboundCredential', 'credentialId', credentialId)
            const localVarPath = `/api/pact/outbound-credentials/{credentialId}`
                .replace(`{${"credentialId"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List outbound PACT credentials for the current organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutboundCredentials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pact/outbound-credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test outbound PACT credentials by obtaining an access token, without saving them
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOutboundCredential: async (pactOutboundCredentialRequest: PactOutboundCredentialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pactOutboundCredentialRequest' is not null or undefined
            assertParamExists('testOutboundCredential', 'pactOutboundCredentialRequest', pactOutboundCredentialRequest)
            const localVarPath = `/api/pact/outbound-credentials/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pactOutboundCredentialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PactOutboundCredentialControllerApi - functional programming interface
 */
export const PactOutboundCredentialControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PactOutboundCredentialControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an outbound PACT credential used to authenticate into an external PACT tool
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PactOutboundCredentialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutboundCredential(pactOutboundCredentialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactOutboundCredentialControllerApi.createOutboundCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an outbound PACT credential
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOutboundCredential(credentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOutboundCredential(credentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactOutboundCredentialControllerApi.deleteOutboundCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List outbound PACT credentials for the current organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOutboundCredentials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadonlyArray<PactOutboundCredentialResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOutboundCredentials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactOutboundCredentialControllerApi.listOutboundCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test outbound PACT credentials by obtaining an access token, without saving them
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testOutboundCredential(pactOutboundCredentialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PactOutboundCredentialControllerApi.testOutboundCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PactOutboundCredentialControllerApi - factory interface
 */
export const PactOutboundCredentialControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PactOutboundCredentialControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an outbound PACT credential used to authenticate into an external PACT tool
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<PactOutboundCredentialResponse> {
            return localVarFp.createOutboundCredential(pactOutboundCredentialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an outbound PACT credential
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutboundCredential(credentialId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOutboundCredential(credentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List outbound PACT credentials for the current organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutboundCredentials(options?: RawAxiosRequestConfig): AxiosPromise<ReadonlyArray<PactOutboundCredentialResponse>> {
            return localVarFp.listOutboundCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test outbound PACT credentials by obtaining an access token, without saving them
         * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testOutboundCredential(pactOutboundCredentialRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PactOutboundCredentialControllerApi - object-oriented interface
 */
export class PactOutboundCredentialControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create an outbound PACT credential used to authenticate into an external PACT tool
     * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig) {
        return PactOutboundCredentialControllerApiFp(this.configuration).createOutboundCredential(pactOutboundCredentialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an outbound PACT credential
     * @param {string} credentialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOutboundCredential(credentialId: string, options?: RawAxiosRequestConfig) {
        return PactOutboundCredentialControllerApiFp(this.configuration).deleteOutboundCredential(credentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List outbound PACT credentials for the current organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listOutboundCredentials(options?: RawAxiosRequestConfig) {
        return PactOutboundCredentialControllerApiFp(this.configuration).listOutboundCredentials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test outbound PACT credentials by obtaining an access token, without saving them
     * @param {PactOutboundCredentialRequest} pactOutboundCredentialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testOutboundCredential(pactOutboundCredentialRequest: PactOutboundCredentialRequest, options?: RawAxiosRequestConfig) {
        return PactOutboundCredentialControllerApiFp(this.configuration).testOutboundCredential(pactOutboundCredentialRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductControllerApi - axios parameter creator
 */
export const ProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel open emission requests; delete products with no open request
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmissionRequests: async (productsDeleteRequest: ProductsDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productsDeleteRequest' is not null or undefined
            assertParamExists('cancelEmissionRequests', 'productsDeleteRequest', productsDeleteRequest)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequests: async (createEmissionRequestsRequest: CreateEmissionRequestsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmissionRequestsRequest' is not null or undefined
            assertParamExists('createEmissionRequests', 'createEmissionRequestsRequest', createEmissionRequestsRequest)
            const localVarPath = `/api/product/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmissionRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestAgeOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/request-age-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestDataOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/request-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {GetPurchasedProductsSortByEnum} [sortBy] 
         * @param {GetPurchasedProductsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedProducts: async (pageNumber?: number, limit?: number, textSearch?: string, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: GetPurchasedProductsSortByEnum, sortDirection?: GetPurchasedProductsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/purchased-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (textSearch !== undefined) {
                localVarQueryParameter['textSearch'] = textSearch;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (emissionDataVerified) {
                localVarQueryParameter['emissionDataVerified'] = emissionDataVerified;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (emissionValueConfidence) {
                localVarQueryParameter['emissionValueConfidence'] = emissionValueConfidence;
            }

            if (emissionValueGranularity) {
                localVarQueryParameter['emissionValueGranularity'] = emissionValueGranularity;
            }

            if (shareOfPrimaryDataInEmissionFactorFrom !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorFrom'] = shareOfPrimaryDataInEmissionFactorFrom;
            }

            if (shareOfPrimaryDataInEmissionFactorTo !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorTo'] = shareOfPrimaryDataInEmissionFactorTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedProductRequestsSortByEnum} [sortBy] 
         * @param {GetReceivedProductRequestsSortDirectionEnum} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedProductRequests: async (pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetReceivedProductRequestsSortByEnum, sortDirection?: GetReceivedProductRequestsSortDirectionEnum, lastUpdatedFrom?: string, lastUpdatedTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/received-product-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (customerIds) {
                localVarQueryParameter['customerIds'] = customerIds;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Emission Requests
         * @param {ResendEmissionRequestsRequest} resendEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmissionRequests: async (resendEmissionRequestsRequest: ResendEmissionRequestsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendEmissionRequestsRequest' is not null or undefined
            assertParamExists('resendEmissionRequests', 'resendEmissionRequestsRequest', resendEmissionRequestsRequest)
            const localVarPath = `/api/product/emission-requests/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendEmissionRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductControllerApi - functional programming interface
 */
export const ProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel open emission requests; delete products with no open request
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelEmissionRequests(productsDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.cancelEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmissionRequests(createEmissionRequestsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.createEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedProductRequestAgeOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedProductRequestAgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedProductRequestAgeOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getAggregatedProductRequestAgeOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedProductRequestDataOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedProductRequestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedProductRequestDataOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getAggregatedProductRequestDataOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {GetPurchasedProductsSortByEnum} [sortBy] 
         * @param {GetPurchasedProductsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchasedProducts(pageNumber?: number, limit?: number, textSearch?: string, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: GetPurchasedProductsSortByEnum, sortDirection?: GetPurchasedProductsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchasedProducts(pageNumber, limit, textSearch, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getPurchasedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedProductRequestsSortByEnum} [sortBy] 
         * @param {GetReceivedProductRequestsSortDirectionEnum} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetReceivedProductRequestsSortByEnum, sortDirection?: GetReceivedProductRequestsSortDirectionEnum, lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlattenedEmissionRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getReceivedProductRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend Emission Requests
         * @param {ResendEmissionRequestsRequest} resendEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmissionRequests(resendEmissionRequestsRequest: ResendEmissionRequestsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmissionRequests(resendEmissionRequestsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.resendEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductControllerApi - factory interface
 */
export const ProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel open emission requests; delete products with no open request
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelEmissionRequests(productsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createEmissionRequests(createEmissionRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestAgeOverview(options?: RawAxiosRequestConfig): AxiosPromise<AggregatedProductRequestAgeResponse> {
            return localVarFp.getAggregatedProductRequestAgeOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestDataOverview(options?: RawAxiosRequestConfig): AxiosPromise<AggregatedProductRequestDataResponse> {
            return localVarFp.getAggregatedProductRequestDataOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {GetPurchasedProductsSortByEnum} [sortBy] 
         * @param {GetPurchasedProductsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedProducts(pageNumber?: number, limit?: number, textSearch?: string, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: GetPurchasedProductsSortByEnum, sortDirection?: GetPurchasedProductsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<ProductEmissionDataRequestListResponse> {
            return localVarFp.getPurchasedProducts(pageNumber, limit, textSearch, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedProductRequestsSortByEnum} [sortBy] 
         * @param {GetReceivedProductRequestsSortDirectionEnum} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetReceivedProductRequestsSortByEnum, sortDirection?: GetReceivedProductRequestsSortDirectionEnum, lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<FlattenedEmissionRequestListResponse> {
            return localVarFp.getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Emission Requests
         * @param {ResendEmissionRequestsRequest} resendEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmissionRequests(resendEmissionRequestsRequest: ResendEmissionRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendEmissionRequests(resendEmissionRequestsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductControllerApi - object-oriented interface
 */
export class ProductControllerApi extends BaseAPI {
    /**
     * 
     * @summary Cancel open emission requests; delete products with no open request
     * @param {ProductsDeleteRequest} productsDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).cancelEmissionRequests(productsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Emission Requests for multiple products and suppliers
     * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).createEmissionRequests(createEmissionRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overview of aggregated product request age
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAggregatedProductRequestAgeOverview(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getAggregatedProductRequestAgeOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve aggregated product request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAggregatedProductRequestDataOverview(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getAggregatedProductRequestDataOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchased products
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [textSearch] 
     * @param {ReadonlyArray<string>} [supplierIds] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {string} [productInternalReference] 
     * @param {string} [productName] 
     * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
     * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
     * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
     * @param {GetPurchasedProductsSortByEnum} [sortBy] 
     * @param {GetPurchasedProductsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPurchasedProducts(pageNumber?: number, limit?: number, textSearch?: string, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<DataRequestStatus>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: GetPurchasedProductsSortByEnum, sortDirection?: GetPurchasedProductsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getPurchasedProducts(pageNumber, limit, textSearch, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get received products requests
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<string>} [customerIds] 
     * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
     * @param {GetReceivedProductRequestsSortByEnum} [sortBy] 
     * @param {GetReceivedProductRequestsSortDirectionEnum} [sortDirection] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortBy?: GetReceivedProductRequestsSortByEnum, sortDirection?: GetReceivedProductRequestsSortDirectionEnum, lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Emission Requests
     * @param {ResendEmissionRequestsRequest} resendEmissionRequestsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendEmissionRequests(resendEmissionRequestsRequest: ResendEmissionRequestsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).resendEmissionRequests(resendEmissionRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetPurchasedProductsSortByEnum = {
    PRODUCT_REQUEST_STATUS: 'PRODUCT_REQUEST_STATUS',
    INTERNAL_REFERENCE: 'INTERNAL_REFERENCE',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT',
    PRODUCT_UPDATED_AT: 'PRODUCT_UPDATED_AT',
    EMISSION_VALUE: 'EMISSION_VALUE'
} as const;
export type GetPurchasedProductsSortByEnum = typeof GetPurchasedProductsSortByEnum[keyof typeof GetPurchasedProductsSortByEnum];
export const GetPurchasedProductsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetPurchasedProductsSortDirectionEnum = typeof GetPurchasedProductsSortDirectionEnum[keyof typeof GetPurchasedProductsSortDirectionEnum];
export const GetReceivedProductRequestsSortByEnum = {
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT',
    EMISSION_VALUE: 'EMISSION_VALUE',
    PRODUCT_REQUEST_STATUS: 'PRODUCT_REQUEST_STATUS',
    PRODUCT_NAME: 'PRODUCT_NAME',
    PRODUCT_UNIT: 'PRODUCT_UNIT'
} as const;
export type GetReceivedProductRequestsSortByEnum = typeof GetReceivedProductRequestsSortByEnum[keyof typeof GetReceivedProductRequestsSortByEnum];
export const GetReceivedProductRequestsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetReceivedProductRequestsSortDirectionEnum = typeof GetReceivedProductRequestsSortDirectionEnum[keyof typeof GetReceivedProductRequestsSortDirectionEnum];


/**
 * RegistrationControllerApi - axios parameter creator
 */
export const RegistrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUserAccessRequest: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('approveUserAccessRequest', 'token', token)
            const localVarPath = `/auth/registration/users/approve-access-request/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCompanyExists: async (companyExistsRequest: CompanyExistsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyExistsRequest' is not null or undefined
            assertParamExists('checkCompanyExists', 'companyExistsRequest', companyExistsRequest)
            const localVarPath = `/auth/registration/accounts/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyExistsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (accountCreateRequest: AccountCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountCreateRequest' is not null or undefined
            assertParamExists('createAccount', 'accountCreateRequest', accountCreateRequest)
            const localVarPath = `/auth/registration/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userCreateRequest: UserCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateRequest' is not null or undefined
            assertParamExists('createUser', 'userCreateRequest', userCreateRequest)
            const localVarPath = `/auth/registration/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user access request
         * @param {UserAccessRequestCreateRequest} userAccessRequestCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest: async (userAccessRequestCreateRequest: UserAccessRequestCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccessRequestCreateRequest' is not null or undefined
            assertParamExists('createUserAccessRequest', 'userAccessRequestCreateRequest', userAccessRequestCreateRequest)
            const localVarPath = `/auth/registration/access-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAccessRequestCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyUserAccessRequest: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('denyUserAccessRequest', 'token', token)
            const localVarPath = `/auth/registration/users/deny-access-request/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getInvitation', 'token', token)
            const localVarPath = `/auth/registration/invitations/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/registration/accounts/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser: async (loginUserRequest: LoginUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginUserRequest' is not null or undefined
            assertParamExists('loginUser', 'loginUserRequest', loginUserRequest)
            const localVarPath = `/auth/registration/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUserPact: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loginUserPact', 'authorization', authorization)
            const localVarPath = `/auth/registration/users/auth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/auth/registration/users/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (userResetPasswordRequest: UserResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userResetPasswordRequest' is not null or undefined
            assertParamExists('resetUserPassword', 'userResetPasswordRequest', userResetPasswordRequest)
            const localVarPath = `/auth/registration/users/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userUpdatePasswordRequest: UserUpdatePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdatePasswordRequest' is not null or undefined
            assertParamExists('updateUserPassword', 'userUpdatePasswordRequest', userUpdatePasswordRequest)
            const localVarPath = `/auth/registration/users/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationControllerApi - functional programming interface
 */
export const RegistrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveUserAccessRequest(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveUserAccessRequest(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.approveUserAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCompanyExists(companyExistsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.checkCompanyExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(accountCreateRequest: AccountCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(accountCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(userCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create user access request
         * @param {UserAccessRequestCreateRequest} userAccessRequestCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserAccessRequest(userAccessRequestCreateRequest: UserAccessRequestCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserAccessRequest(userAccessRequestCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.createUserAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyUserAccessRequest(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyUserAccessRequest(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.denyUserAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitation(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitation(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.getInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.linkAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUser(loginUserRequest: LoginUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUser(loginUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.loginUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUserPact(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserPact200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUserPact(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.loginUserPact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(userResetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.resetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userUpdatePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationControllerApi.updateUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegistrationControllerApi - factory interface
 */
export const RegistrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUserAccessRequest(token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveUserAccessRequest(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyExistsResponse> {
            return localVarFp.checkCompanyExists(companyExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(accountCreateRequest: AccountCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAccount(accountCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUser(userCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user access request
         * @param {UserAccessRequestCreateRequest} userAccessRequestCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest(userAccessRequestCreateRequest: UserAccessRequestCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUserAccessRequest(userAccessRequestCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyUserAccessRequest(token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.denyUserAccessRequest(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation(token: string, options?: RawAxiosRequestConfig): AxiosPromise<InvitationInfoResponse> {
            return localVarFp.getInvitation(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccount(options?: RawAxiosRequestConfig): AxiosPromise<LinkAccountResponse> {
            return localVarFp.linkAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser(loginUserRequest: LoginUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginUserResponse> {
            return localVarFp.loginUser(loginUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUserPact(authorization: string, options?: RawAxiosRequestConfig): AxiosPromise<LoginUserPact200Response> {
            return localVarFp.loginUserPact(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginUserResponse> {
            return localVarFp.refreshToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetUserPassword(userResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPassword(userUpdatePasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationControllerApi - object-oriented interface
 */
export class RegistrationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Approve user access request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveUserAccessRequest(token: string, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).approveUserAccessRequest(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a company is already registered
     * @param {CompanyExistsRequest} companyExistsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).checkCompanyExists(companyExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new account
     * @param {AccountCreateRequest} accountCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccount(accountCreateRequest: AccountCreateRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).createAccount(accountCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new user
     * @param {UserCreateRequest} userCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).createUser(userCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user access request
     * @param {UserAccessRequestCreateRequest} userAccessRequestCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUserAccessRequest(userAccessRequestCreateRequest: UserAccessRequestCreateRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).createUserAccessRequest(userAccessRequestCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deny user access request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public denyUserAccessRequest(token: string, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).denyUserAccessRequest(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invite detail
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvitation(token: string, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).getInvitation(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link a connected SSO account to an existing account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public linkAccount(options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).linkAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with an existing user
     * @param {LoginUserRequest} loginUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginUser(loginUserRequest: LoginUserRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).loginUser(loginUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with an existing user
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginUserPact(authorization: string, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).loginUserPact(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate an access token / id token from a refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).refreshToken(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates user password reset request
     * @param {UserResetPasswordRequest} userResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).resetUserPassword(userResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates user password
     * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: RawAxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).updateUserPassword(userUpdatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierEmissionControllerApi - axios parameter creator
 */
export const SupplierEmissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineEmissionRequest: async (requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('declineEmissionRequest', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('declineEmissionRequest', 'productId', productId)
            // verify required parameter 'emissionDataRejectionRequest' is not null or undefined
            assertParamExists('declineEmissionRequest', 'emissionDataRejectionRequest', emissionDataRejectionRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/decline`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (requestReference: string, productId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('downloadAttachment', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('downloadAttachment', 'productId', productId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/attachments/{attachmentId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProductDetails: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('getEmissionRequestProductDetails', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getEmissionRequestProductDetails', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/supplier/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReceivedEmissionRequests: async (pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortDirection?: GetReceivedEmissionRequestsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/supplier/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEmissionData: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('lockEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('lockEmissionData', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/lock`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistDraftEmissionData: async (requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'productId', productId)
            // verify required parameter 'updateEmissionDraftDataRequest' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'updateEmissionDraftDataRequest', updateEmissionDraftDataRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/draft`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmissionDraftDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save form data answers (draft and final use the same column)
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistFormData: async (requestReference: string, productId: string, updateFormDataRequest: UpdateFormDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('persistFormData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('persistFormData', 'productId', productId)
            // verify required parameter 'updateFormDataRequest' is not null or undefined
            assertParamExists('persistFormData', 'updateFormDataRequest', updateFormDataRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/form-data`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AI-prefill the PCF survey from uploaded PDFs, streaming progress per section
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {PcfPrefillRequest} pcfPrefillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefillFormData: async (requestReference: string, productId: string, pcfPrefillRequest: PcfPrefillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('prefillFormData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('prefillFormData', 'productId', productId)
            // verify required parameter 'pcfPrefillRequest' is not null or undefined
            assertParamExists('prefillFormData', 'pcfPrefillRequest', pcfPrefillRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/prefill`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pcfPrefillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEmissionData: async (requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('submitEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('submitEmissionData', 'productId', productId)
            // verify required parameter 'emissionRequestProductFormData' is not null or undefined
            assertParamExists('submitEmissionData', 'emissionRequestProductFormData', emissionRequestProductFormData)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionRequestProductFormData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit custom form data without emission data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFormData: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('submitFormData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('submitFormData', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/form-data/submit`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unLockEmissionData: async (requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('unLockEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('unLockEmissionData', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/lock`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierEmissionControllerApi - functional programming interface
 */
export const SupplierEmissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierEmissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.declineEmissionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(requestReference, productId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.downloadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionRequestProductDetails(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionRequestProductDetails(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.getEmissionRequestProductDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionRequestProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierEmissionRequestProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionRequestProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.getEmissionRequestProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortDirection?: GetReceivedEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.getReceivedEmissionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockEmissionData(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.lockEmissionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.persistDraftEmissionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save form data answers (draft and final use the same column)
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistFormData(requestReference: string, productId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistFormData(requestReference, productId, updateFormDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.persistFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AI-prefill the PCF survey from uploaded PDFs, streaming progress per section
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {PcfPrefillRequest} pcfPrefillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prefillFormData(requestReference: string, productId: string, pcfPrefillRequest: PcfPrefillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SseEmitter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prefillFormData(requestReference, productId, pcfPrefillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.prefillFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitEmissionData(requestReference, productId, emissionRequestProductFormData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.submitEmissionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit custom form data without emission data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFormData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFormData(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.submitFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unLockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unLockEmissionData(requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionControllerApi.unLockEmissionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierEmissionControllerApi - factory interface
 */
export const SupplierEmissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierEmissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAttachment(requestReference, productId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProductDetails(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.getEmissionRequestProductDetails(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProducts(options?: RawAxiosRequestConfig): AxiosPromise<SupplierEmissionRequestProductResponse> {
            return localVarFp.getEmissionRequestProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
         * @param {GetReceivedEmissionRequestsSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortDirection?: GetReceivedEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestSummaryResponse> {
            return localVarFp.getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lockEmissionData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save form data answers (draft and final use the same column)
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistFormData(requestReference: string, productId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.persistFormData(requestReference, productId, updateFormDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AI-prefill the PCF survey from uploaded PDFs, streaming progress per section
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {PcfPrefillRequest} pcfPrefillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefillFormData(requestReference: string, productId: string, pcfPrefillRequest: PcfPrefillRequest, options?: RawAxiosRequestConfig): AxiosPromise<SseEmitter> {
            return localVarFp.prefillFormData(requestReference, productId, pcfPrefillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: RawAxiosRequestConfig): AxiosPromise<EmissionRequestProduct> {
            return localVarFp.submitEmissionData(requestReference, productId, emissionRequestProductFormData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit custom form data without emission data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFormData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitFormData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unLockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unLockEmissionData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierEmissionControllerApi - object-oriented interface
 */
export class SupplierEmissionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Decline emission data request
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).downloadAttachment(requestReference, productId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get emissions data request product details
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmissionRequestProductDetails(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).getEmissionRequestProductDetails(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get emission request products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmissionRequestProducts(options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).getEmissionRequestProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Summary of Emission Requests received
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<DataRequestStatus>} [productRequestStatus] 
     * @param {GetReceivedEmissionRequestsSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<DataRequestStatus>, sortDirection?: GetReceivedEmissionRequestsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Locks emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public lockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).lockEmissionData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Auto-save interim emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save form data answers (draft and final use the same column)
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {UpdateFormDataRequest} updateFormDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public persistFormData(requestReference: string, productId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).persistFormData(requestReference, productId, updateFormDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AI-prefill the PCF survey from uploaded PDFs, streaming progress per section
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {PcfPrefillRequest} pcfPrefillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public prefillFormData(requestReference: string, productId: string, pcfPrefillRequest: PcfPrefillRequest, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).prefillFormData(requestReference, productId, pcfPrefillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Emission Data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).submitEmissionData(requestReference, productId, emissionRequestProductFormData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit custom form data without emission data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitFormData(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).submitFormData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Un-locks emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unLockEmissionData(requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionControllerApiFp(this.configuration).unLockEmissionData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetReceivedEmissionRequestsSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetReceivedEmissionRequestsSortDirectionEnum = typeof GetReceivedEmissionRequestsSortDirectionEnum[keyof typeof GetReceivedEmissionRequestsSortDirectionEnum];


/**
 * SupplierEmissionsDataRequestControllerApi - axios parameter creator
 */
export const SupplierEmissionsDataRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionsDataRequest: async (requestReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('getEmissionsDataRequest', 'requestReference', requestReference)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierEmissionsDataRequestControllerApi - functional programming interface
 */
export const SupplierEmissionsDataRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierEmissionsDataRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionsDataRequest(requestReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionsDataRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionsDataRequest(requestReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierEmissionsDataRequestControllerApi.getEmissionsDataRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierEmissionsDataRequestControllerApi - factory interface
 */
export const SupplierEmissionsDataRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierEmissionsDataRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionsDataRequest(requestReference: string, options?: RawAxiosRequestConfig): AxiosPromise<EmissionsDataRequestResponse> {
            return localVarFp.getEmissionsDataRequest(requestReference, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierEmissionsDataRequestControllerApi - object-oriented interface
 */
export class SupplierEmissionsDataRequestControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get EmissionsDataRequest by Id
     * @param {string} requestReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmissionsDataRequest(requestReference: string, options?: RawAxiosRequestConfig) {
        return SupplierEmissionsDataRequestControllerApiFp(this.configuration).getEmissionsDataRequest(requestReference, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TemplateControllerApi - axios parameter creator
 */
export const TemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (templateCreateRequest: TemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateCreateRequest' is not null or undefined
            assertParamExists('createTemplate', 'templateCreateRequest', templateCreateRequest)
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {TemplateCreateRequest} [templateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromProduct: async (productId: string, templateCreateRequest?: TemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createTemplateFromProduct', 'productId', productId)
            const localVarPath = `/api/templates/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplate', 'templateId', templateId)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplates: async (requestBody: ReadonlyArray<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteTemplates', 'requestBody', requestBody)
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllTemplates: async (fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplateAttachment: async (templateId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('downloadTemplateAttachment', 'templateId', templateId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadTemplateAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/templates/{templateId}/attachments/{attachmentId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDetails: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplateDetails', 'templateId', templateId)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import templates from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTemplates: async (file: File, allowWarnings?: boolean, dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importTemplates', 'file', file)
            const localVarPath = `/api/templates/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (allowWarnings !== undefined) {
                localVarQueryParameter['allowWarnings'] = allowWarnings;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {ListTemplatesSortByEnum} [sortBy] 
         * @param {ListTemplatesSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (pageNumber?: number, limit?: number, textSearch?: string, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: ListTemplatesSortByEnum, sortDirection?: ListTemplatesSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (textSearch !== undefined) {
                localVarQueryParameter['textSearch'] = textSearch;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prefill form data for a request product by translating from a template via PACT
         * @param {string} templateId 
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefill: async (templateId: string, requestReference: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('prefill', 'templateId', templateId)
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('prefill', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('prefill', 'productId', productId)
            const localVarPath = `/api/templates/{templateId}/prefill`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (requestReference !== undefined) {
                localVarQueryParameter['requestReference'] = requestReference;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplate', 'templateId', templateId)
            // verify required parameter 'templateCreateRequest' is not null or undefined
            assertParamExists('updateTemplate', 'templateCreateRequest', templateCreateRequest)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (updateEmissionData !== undefined) {
                localVarQueryParameter['updateEmissionData'] = updateEmissionData;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save template form data
         * @param {string} templateId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateFormData: async (templateId: string, updateFormDataRequest: UpdateFormDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplateFormData', 'templateId', templateId)
            // verify required parameter 'updateFormDataRequest' is not null or undefined
            assertParamExists('updateTemplateFormData', 'updateFormDataRequest', updateFormDataRequest)
            const localVarPath = `/api/templates/{templateId}/form-data`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateControllerApi - functional programming interface
 */
export const TemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(templateCreateRequest: TemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(templateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.createTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {TemplateCreateRequest} [templateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplateFromProduct(productId: string, templateCreateRequest?: TemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplateFromProduct(productId, templateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.createTemplateFromProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.deleteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplates(requestBody: ReadonlyArray<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplates(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.deleteTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllTemplates(fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllTemplates(fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.downloadAllTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemplateAttachment(templateId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemplateAttachment(templateId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.downloadTemplateAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateDetails(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateDetails(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.getTemplateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import templates from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTemplates(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTemplates(file, allowWarnings, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.importTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {ListTemplatesSortByEnum} [sortBy] 
         * @param {ListTemplatesSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(pageNumber?: number, limit?: number, textSearch?: string, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: ListTemplatesSortByEnum, sortDirection?: ListTemplatesSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(pageNumber, limit, textSearch, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.listTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prefill form data for a request product by translating from a template via PACT
         * @param {string} templateId 
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prefill(templateId: string, requestReference: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplatePrefillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prefill(templateId, requestReference, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.prefill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(templateId, templateCreateRequest, updateEmissionData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.updateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save template form data
         * @param {string} templateId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplateFormData(templateId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplateFormData(templateId, updateFormDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateControllerApi.updateTemplateFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TemplateControllerApi - factory interface
 */
export const TemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(templateCreateRequest: TemplateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.createTemplate(templateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {TemplateCreateRequest} [templateCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromProduct(productId: string, templateCreateRequest?: TemplateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.createTemplateFromProduct(productId, templateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplates(requestBody: ReadonlyArray<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTemplates(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllTemplates(fileName?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAllTemplates(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplateAttachment(templateId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadTemplateAttachment(templateId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDetails(templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.getTemplateDetails(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import templates from file
         * @param {File} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTemplates(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<TemplateImportResponse> {
            return localVarFp.importTemplates(file, allowWarnings, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [textSearch] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {ListTemplatesSortByEnum} [sortBy] 
         * @param {ListTemplatesSortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(pageNumber?: number, limit?: number, textSearch?: string, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: ListTemplatesSortByEnum, sortDirection?: ListTemplatesSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<TemplateListResponse> {
            return localVarFp.listTemplates(pageNumber, limit, textSearch, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prefill form data for a request product by translating from a template via PACT
         * @param {string} templateId 
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prefill(templateId: string, requestReference: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<TemplatePrefillResponse> {
            return localVarFp.prefill(templateId, requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.updateTemplate(templateId, templateCreateRequest, updateEmissionData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save template form data
         * @param {string} templateId 
         * @param {UpdateFormDataRequest} updateFormDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateFormData(templateId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.updateTemplateFormData(templateId, updateFormDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateControllerApi - object-oriented interface
 */
export class TemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create Template
     * @param {TemplateCreateRequest} templateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTemplate(templateCreateRequest: TemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).createTemplate(templateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Template from Product
     * @param {string} productId 
     * @param {TemplateCreateRequest} [templateCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTemplateFromProduct(productId: string, templateCreateRequest?: TemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).createTemplateFromProduct(productId, templateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Deprecated) Delete template and its form data by Id
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).deleteTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete templates and their form data by Id
     * @param {ReadonlyArray<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTemplates(requestBody: ReadonlyArray<string>, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).deleteTemplates(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads template data
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAllTemplates(fileName?: string, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).downloadAllTemplates(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} templateId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadTemplateAttachment(templateId: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).downloadTemplateAttachment(templateId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get template form data by Id
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTemplateDetails(templateId: string, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).getTemplateDetails(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import templates from file
     * @param {File} file 
     * @param {boolean} [allowWarnings] 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importTemplates(file: File, allowWarnings?: boolean, dryRun?: boolean, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).importTemplates(file, allowWarnings, dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Templates
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [textSearch] 
     * @param {string} [productName] 
     * @param {string} [productInternalReference] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {ListTemplatesSortByEnum} [sortBy] 
     * @param {ListTemplatesSortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTemplates(pageNumber?: number, limit?: number, textSearch?: string, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: ListTemplatesSortByEnum, sortDirection?: ListTemplatesSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).listTemplates(pageNumber, limit, textSearch, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prefill form data for a request product by translating from a template via PACT
     * @param {string} templateId 
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public prefill(templateId: string, requestReference: string, productId: string, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).prefill(templateId, requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Template
     * @param {string} templateId 
     * @param {TemplateCreateRequest} templateCreateRequest 
     * @param {boolean} [updateEmissionData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).updateTemplate(templateId, templateCreateRequest, updateEmissionData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save template form data
     * @param {string} templateId 
     * @param {UpdateFormDataRequest} updateFormDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTemplateFormData(templateId: string, updateFormDataRequest: UpdateFormDataRequest, options?: RawAxiosRequestConfig) {
        return TemplateControllerApiFp(this.configuration).updateTemplateFormData(templateId, updateFormDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListTemplatesSortByEnum = {
    UPDATED_AT: 'UPDATED_AT',
    CREATED_AT: 'CREATED_AT',
    EMISSION_VALUE: 'EMISSION_VALUE'
} as const;
export type ListTemplatesSortByEnum = typeof ListTemplatesSortByEnum[keyof typeof ListTemplatesSortByEnum];
export const ListTemplatesSortDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type ListTemplatesSortDirectionEnum = typeof ListTemplatesSortDirectionEnum[keyof typeof ListTemplatesSortDirectionEnum];


